import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  FormLabel,
  Row,
  Table,
  FormControl,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { NEW_ENTRY, DOCUMENT_CHANGED } from "../ds/App_Constants.js";
import { DebitMemoService } from "../services/DebitMemoService.js";
import {
  BaseBean,
  NodeData,
  RestReportBean,
  PurchaseOrderReceiptRollLineBeanFilter,
} from "../ds/client_ds.js";
import {
  AddressBean,
  InvoiceServiceLineBean,
  PageListBean,
  PurchaseOrderBean,
  PurchaseOrderInTransitBean,
  PurchaseOrderInTransitForPurchaseOrderSearchCriteria,
  PurchaseOrderInTransitSearchCriteria,
  PurchaseOrderReceiptBean,
  PurchaseOrderReceiptElectronicInputBean,
  PurchaseOrderReceiptLineBean,
  PurchaseOrderReceiptLineSearchCriteria,
  PurchaseOrderReceiptPrintRequest,
  PurchaseOrderReceiptRollLineBean,
  PurchaseOrderReceiptSearchCriteria,
  PurchaseOrderSearchCriteria,
  PurchaseReceiptToInvoiceInputBean,
  ReasonBean,
  RestEntityUnLockRequest,
  RestPurchaseOrderInTransitListRequest,
  RestPurchaseOrderListRequest,
  RestPurchaseOrderReceiptBeanRequest,
  RestPurchaseOrderReceiptExcelImportRequest,
  RestPurchaseOrderReceiptLineRequest,
  RestPurchaseOrderReceiptListRequest,
  RestPurchaseOrderReceiptRequest,
  RestReadRequest,
  VendorBean,
  PurchaseOrderReceiptDocumentBean,
  PurchaseOrderReceiptImageBean,
  PurchaseOrderReceiptApprovalResponseBean,
  PurchaseOrderReceiptApprovalCriteriaBean,
  PurchaseOrderReceiptApprovalBean,
  RestPurchaseOrderReceiptApprovalListRequest,
  VendorInvoicePaymentSearchCriteria,
  RestVendorInvoicePaymentListRequest,
  SKUBatchInventorySearchCriteria,
  RestSkuBatchInventoryListRequest,
  RestPageListBean,
  FabricStylePurchaseReceiptHistoryCriteriaBean,
  DebitMemoBean,
  DebitMemoReturnLineBean,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
  UploadDocIcon,
  CameraIcon,
  AddIcon,
  CancelIcon,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGrid,
  DataGridColumnDefinition,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
  MessageBoxComponent,
  InputCheckbox,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toFormattedDate_v1,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PurchaseOrderInTransitLookupHandler } from "../lookup/PurchaseOrderInTransitLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { PurchaseOrderReceiptLookupHandler } from "../lookup/PurchaseOrderReceiptLookupHandler.js";
import {
  PopupPurchaseInTransitModule,
  PopupPurchaseOrderModule,
  PopupCustomerModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { PurchaseOrderInTransitService } from "../services/PurchaseOrderInTransitService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { PopupPurchaseAndSlesDetailsInq } from "../Inquiry/InquiryUtil.js";
import CustomTable from "../gui_components/CustomTable.js";
import { InventoryService } from "../services/InventoryService.js";

class PurchaseOrderReceiptList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.cancelReasonDialogRef = React.createRef();
    this.receiptLineCancelReasonDialogRef = React.createRef();
    this.rollLineCancelReasonDialogRef = React.createRef();
    this.state = {
      pageTitle: "Purchase Order Receipt Maintenance",
      purchaseOrderReceiptListData: new Array(),
      pageList: new PageListBean(),
      criteria: new PurchaseOrderReceiptSearchCriteria(),
      purchaseOrderReceiptData: new PurchaseOrderReceiptBean(),
      purchaseOrderReceiptLineData: new PurchaseOrderReceiptLineBean(),
      purchaseOrderReceiptRollLineData: new PurchaseOrderReceiptRollLineBean(),
      purchaseOrdersList: new Array(),
      purchaseOrderData: new PurchaseOrderBean(),
      currentVendor: new VendorBean(),
      purchaseOrderReceiptElectronicInputBean:
        new PurchaseOrderReceiptElectronicInputBean(),
      purchaseOrderInTransitListData: new Array(),
      purchaseOrderInTransitData: new PurchaseOrderInTransitBean(),
      currentPageNumber: 0,
      totalCount: 0,
      error_list: [],
      nodeList: [],
      purchaseRollList: [],
      vendor_List: new Array(),
      fabricStyle_List: new Array(),
      fOBCities: new Array(),
      shipmentTerms: new Array(),
      wareHouses: new Array(),
      incoTerms: new Array(),
      paymentTerms: new Array(),
      vendorTerms: new Array(),
      transportTypes: new Array(),
      countries: new Array(),
      uoms: new Array(),
      shipVias: new Array(),
      isLoading: true,
      isDisableFields: false,
      isShowNodes: false,
      isShowNewButton: true,
      isShowBackButton: false,
      isShowSaveButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowCreateInvoiceButton: false,
      isPurchaseOrderReceiptListFormOpen: true,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: false,
      isPurchaseOrderReceiptApproveReceiptLinesFormOpen: false,
      selectedNodeKey: "headerView",
      selectedDocument: "",
      reasonData: new ReasonBean(),
      cancelReasons: [],
      unapprovalReasons: [],
      isResetModule: false,
      moduleForPopup: [],
      isShowPopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      purchaseOrderReceiptLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      moduleOrderStatus: "",
      disableFormFields: false,
      disabled: false,
      isResetView: true,
      isFocus: false,
      isFocusLookup: true,
      poReceiptRollLinesList: new Array(),
      isMaintenanceMode: true,
      isDisabledFields: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisableRollLine: false,
      isShowPopupAlert: false,
      isShowLinePopup: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseOrderInTransitModule: false,
      fabricStyles: [],
      purchaseOrderBean: new PurchaseOrderBean(),
      isShowPopupAlertlvl1: false,
      isShowPopupAlertlvl5: false,
      isShowPORButton: true,
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteRolllineLocationList: false,
      rollLineLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFobCityList: false,
      FobCityPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipmentTermList: false,
      shipmentTermPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoIntransitList: false,
      poIntransitPageListForAutoCompleteList: new Array(),
      isDisableButtons: true,
      reasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteReason: false,
      is3PL: false,
      isShowCreateInvoicePopup: false,
      isShowPopupAlertlvl2: false,
      invoiceServiceLineList: [],
      services: [],
      invoiceServiceLineData: new InvoiceServiceLineBean(),
      isShowAutoCompleteInvoiceUomList: false,
      invoiceUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: false,
      servicePageListForAutoCompleteList: new Array(),
      isShowInTransitLookup: true,
      isDisablePoIntransit: false,
      isShowCancelReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
      isShowRollLineCancelReasonPopup: false,
      order: "",
      sortField: "",
      isReseted: false,
      isViewMode: false,
      purchaseOrderRollLineBeanFilter:
        new PurchaseOrderReceiptRollLineBeanFilter(),
      filterPurchaseList: [],
      isTexco: false,
      isSearchCriteria: false,
      isResetCriteria: true,
      isShowFilterList: false,
      isImageFormOpened: false,
      isDocumentsFormOpened: false,

      documents: [],
      preview_Docs: [],
      imgUrl: "",
      images: [],
      preview_Url: [],
      isShowfabricAndCustomerSalesDetails: false,
      isShowReceiptApprovalPopup: false,
      purchaseOrderReceiptApprovalList: [],

      purchaseOrderReceiptApproval: new PurchaseOrderReceiptApprovalBean(),

      receiptApprovalList: [],
      isCreateButtonDisabled: false,
      isPaymentDetailViewOpen: false,
      purchasePaymentDetailList: [],

      isShowWarningMsgPopup: false,
      receiptWarningMessage: "",

      isShowPurchaseHistoryPopup: false,
      purchaseSkuHistory: [],
      purchaseFabricHistory: [],
      isShowCustomerModule: false,
      isShowInvoiceModule: false,
      totalShippedQty: 0,
      totalOnHandQty: 0,

      isShowReturnButton: false,
      isShowReturnPopup: false,
      isShowAlertLvlReturn: false,

      rollSkuList: [],

      debitMemoDataBean: new DebitMemoBean(),

      debitMemoReturnLineData: new DebitMemoReturnLineBean(),
      isShowRollInfoPopup: false,
      isShowAlertLvl6: false,
       isVendorInvoiceShow:false
    };
    this.receiptWarningResolve = null;
  }

  aprovalonChange = (e) => {
    let PurchaseOrderReceiptApprovalBean =
      this.state.purchaseOrderReceiptApproval;
    PurchaseOrderReceiptApprovalBean[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderReceiptApproval: PurchaseOrderReceiptApprovalBean,
    });
  };

  code = NEW_ENTRY;
  isLocked = false;
  moduleCaption = "Purchase Order Receipt Maintenance";
  fetchAttributesFromLocalStorage = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let fOBCities = attribute_cache.fOBCities;
    let fOBCities_temp = [];
    if (fOBCities != null || fOBCities != undefined) {
      fOBCities.map((attr) => {
        fOBCities_temp.push(attr);
        this.state.fOBCities = ModuleUtils.isActiveAttribute(fOBCities_temp);
      });
    }
    let shipmentTerms = attribute_cache.shipmentTerms;
    let shipmentTerms_temp = [];
    if (shipmentTerms != null || shipmentTerms != undefined) {
      shipmentTerms.map((attr) => {
        shipmentTerms_temp.push(attr);
        this.state.shipmentTerms =
          ModuleUtils.isActiveAttribute(shipmentTerms_temp);
      });
    }
    let wareHouses = attribute_cache.warehouses;
    let wareHouses_temp = [];
    if (wareHouses != null || wareHouses != undefined) {
      wareHouses.map((attr) => {
        wareHouses_temp.push(attr);
        this.state.wareHouses = ModuleUtils.isActiveAttribute(wareHouses_temp);
      });
    }
    let incoTerms = attribute_cache.incoTerms;
    let incoTerms_temp = [];
    if (incoTerms != null || incoTerms != undefined) {
      incoTerms.map((attr) => {
        incoTerms_temp.push(attr);
        this.state.incoTerms = ModuleUtils.isActiveAttribute(incoTerms_temp);
      });
    }
    let paymentTerms = attribute_cache.paymentTerms;
    let paymentTerms_temp = [];
    if (paymentTerms != null || paymentTerms != undefined) {
      paymentTerms.map((attr) => {
        paymentTerms_temp.push(attr);
        this.state.paymentTerms =
          ModuleUtils.isActiveAttribute(paymentTerms_temp);
      });
    }
    let transportTypes = attribute_cache.transportTypes;
    let transportTypes_temp = [];
    if (transportTypes != null || transportTypes != undefined) {
      transportTypes.map((attr) => {
        transportTypes_temp.push(attr);
        this.state.transportTypes =
          ModuleUtils.isActiveAttribute(transportTypes_temp);
      });
    }
    let countries = attribute_cache.countries;
    let countries_temp = [];
    if (countries != null || countries != undefined) {
      countries.map((attr) => {
        countries_temp.push(attr);
        this.state.countries = ModuleUtils.isActiveAttribute(countries_temp);
      });
    }
    let uoms = attribute_cache.uoms;
    let uoms_temp = [];
    if (uoms != null || uoms != undefined) {
      uoms.map((attr) => {
        uoms_temp.push(attr);
        this.state.uoms = ModuleUtils.isActiveAttribute(uoms_temp);
      });
    }
    let vendorTerms = attribute_cache.vendorTerms;
    let vendorTerms_temp = [];
    if (vendorTerms != null || vendorTerms != undefined) {
      vendorTerms.map((attr) => {
        vendorTerms_temp.push(attr);
        this.state.vendorTerms =
          ModuleUtils.isActiveAttribute(vendorTerms_temp);
      });
    }
    let shipVias = attribute_cache.vendorShipVias;
    let shipVias_temp = [];
    if (shipVias != null || shipVias != undefined) {
      shipVias.map((attr) => {
        shipVias_temp.push(attr);
        this.state.shipVias = ModuleUtils.isActiveAttribute(shipVias_temp);
      });
    }
    this.state.cancelReasons = [];
    let cancelReasons = attribute_cache.purchaseReceiptCancelReasons;
    let cancelReasons_temp = [];
    cancelReasons.map((ent) => {
      cancelReasons_temp.push(ent);
      this.state.cancelReasons =
        ModuleUtils.isActiveAttribute(cancelReasons_temp);
    });
    let services = attribute_cache.serviceInfos;
    let services_temp = [];
    if (services != null || services != undefined) {
      services.map((attr) => {
        services_temp.push(attr);
        this.state.services = ModuleUtils.isActiveAttribute(services_temp);
      });
    }
  };

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.setState({
        is3PL: true,
      });
    }

    if (ConfigManager.isTexcoFabricKey()) {
      this.setState({
        isTexco: true,
      });
    }
    ModuleUtils.getPurchaseOrderReceiptStatusList();
    ModuleUtils.getPurchaseOrderReceiptLineStatusList();
    ModuleUtils.getPurchaseOrderReceiptPaymentStatusList();
    this.fetchAttributesFromLocalStorage();
    this.state.criteria = new PurchaseOrderReceiptSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    // this.getPurchaseOrdersList();
    this.initLookupHandlers();
    //set readOnly components using view Modes && disable toolbars
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      // this.unlockPurchaseOrderReceipt(this.props.code);
      this.code = this.props.code;
      this.editPurchaseOrderReceipt(this.props.code, false);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        disableFormFields: true,
        isViewMode: true,
      });
    } else {
      // this.addNewEntry();
      this.loadPage();
    }
  }
  initLookupHandlers = () => {
    let purchaseOrderReceiptLookupHandler =
      new PurchaseOrderReceiptLookupHandler(
        this.companyCode,
        "PurchaseOrder Receipt",
      );
    this.setState({
      purchaseOrderReceiptLookupHandler: purchaseOrderReceiptLookupHandler,
    });
    let serviceLookupHandler = new GenericAttributeLookupHandler(
      this.state.services,
      "Service",
    );
    this.setState({ serviceLookupHandler: serviceLookupHandler });
    let uomLookupHandler = new GenericAttributeLookupHandler(
      this.state.uoms,
      "UOM",
    );
    this.setState({ uomLookupHandler: uomLookupHandler });
    let purchaseInTransitLookupHandler =
      new PurchaseOrderInTransitLookupHandler(
        this.companyCode,
        "Purchase InTransit",
      );
    this.setState({
      purchaseInTransitLookupHandler: purchaseInTransitLookupHandler,
    });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;

    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadPurchaseOrderReceiptPage();
  };
  onCriteriaChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  resetfilteredPurchaseOrder = (criteria) => {
    criteria = new PurchaseOrderReceiptSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
    criteria.criteriakey = "";
  };
  filterPurchaseOrder = () => {
    this.loadPage(1);
  };
  loadPurchaseOrderReceiptPage = () => {
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isResetView: false,
      isMaintenanceMode: false,
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (
      SecurityAccessManager.PurchaseOrderReceiptMaintenanceView_IsAccessible()
    ) {
      PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
        requestInput,
        this.loadPurchaseOrderReceiptResponse,
        this.loadPurchaseOrderReceiptError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderReceiptResponse = (response) => {
    if (
      response.data != null &&
      response.data.purchaseOrderReceiptPageList != null
    ) {
      // if (
      //   !isEmptyArray(
      //     response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts
      //   )
      // ) {
      let pageList = this.state.pageList;

      let purchaseOrderReceiptListData =
        response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
      pageList.totalCount =
        response.data.purchaseOrderReceiptPageList.totalCount;
      pageList.currentPage =
        response.data.purchaseOrderReceiptPageList.currentPage;
      this.setState({
        isLoading: false,
        purchaseOrderReceiptListData: purchaseOrderReceiptListData,
        pageList: pageList,
      });
      //}
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  loadPurchaseOrderReceiptError = (error) => {
    ShowError("Error :" + error);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  unlockPurchaseOrderReceipt = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.unLockPurchaseOrderReceipt(
        request,
        this.unlockPurchaseOrderReceiptResponse,
        this.unlockPurchaseOrderReceiptError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockPurchaseOrderReceiptResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editPurchaseOrderReceipt(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockPurchaseOrderReceiptError = (error) => {
    ShowError("Error : ", error);
  };

  getPurchaseOrdersList = () => {
    this.loadPurchaseOrderList();
  };
  loadPurchaseOrderList = () => {
    let criteria = new PurchaseOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    let orderStatusList = new Array();
    orderStatusList.push("A");
    orderStatusList.push("I");
    criteria.orderStatusList = orderStatusList;
    let requestInput = new RestPurchaseOrderListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderService.getPurchaseOrderPageList(
        requestInput,
        this.loadPurchaseOrderResponse,
        this.loadPurchaseOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderResponse = (response) => {
    if (response.data != null && response.data.purchaseOrderPageList != null) {
      let purchaseOrdersList =
        response.data.purchaseOrderPageList.purchaseOrders;
      if (!isEmptyArray(purchaseOrdersList == null)) {
        purchaseOrdersList = new Array();
      }
      this.setState({ purchaseOrdersList: purchaseOrdersList });
    }
  };
  loadPurchaseOrderError = (error) => {
    ShowError("Error : ", error);
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Fields ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderService.readPurchaseOrder(
        readrestInput,
        this.readPurchaseOrderResponse,
        this.readPurchaseOrderError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  readPurchaseOrderResponse = (response) => {
    if (response.data != null && response.data.purchaseOrder != null) {
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        purchaseOrderData: response.data.purchaseOrder,
      });
      this.readPOIntransit(response.data.purchaseOrder.code);
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readPurchaseOrderError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : ", error);
  };
  readPOIntransit = (code) => {
    let request = new PurchaseOrderInTransitForPurchaseOrderSearchCriteria();
    request.companyCode = this.companyCode;
    request.purchaseOrderNumber = code;
    PurchaseOrderInTransitService.getPurchaseOrderInTransitForPurchaseOrder(
      request,
      this.poIntransitResponse,
      this.errorCallBack,
    );
  };
  poIntransitResponse = (response) => {
    const poData = this.state.purchaseOrderData;
    if (
      response.data != null &&
      response.data.result != null &&
      !isEmptyArray(response.data.result.purchaseOrderInTransits)
    ) {
      const purchaseOrderInTransits =
        response.data.result.purchaseOrderInTransits;
      if (purchaseOrderInTransits.length === 1) {
        this.toUpdatePurchaseOrderInTransitData(purchaseOrderInTransits[0]);
        this.setState({
          isDisablePoIntransit: true,
        });
      } else if (purchaseOrderInTransits.length > 1) {
        // lookup call based on po
        let purchaseInTransitLookupHandler =
          new PurchaseOrderInTransitLookupHandler(
            this.companyCode,
            "Purchase InTransit",
            poData.code,
            LogicConstants.PURCHASEORDER_INTRANSIT_APPROVE_STATUS,
          );
        this.setState({
          purchaseInTransitLookupHandler: purchaseInTransitLookupHandler,
        });
        this.setState({
          isShowInTransitLookup: true,
        });
      }
    } else {
      this.toUpdatePurchaseOrderData();
    }
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  readPOIntransitBySearchString = (poIntransitNumber) => {
    let inTransitCriteria = new PurchaseOrderInTransitSearchCriteria();
    inTransitCriteria.companyCode = this.companyCode;
    inTransitCriteria.purchaseOrderInTransitNumberStartsWith =
      poIntransitNumber;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = 1;
    let requestInput = new RestPurchaseOrderInTransitListRequest();
    requestInput.pageInput = pageInput;
    requestInput.searchCriteria = inTransitCriteria;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderInTransitService.getPurchaseOrderInTransitPageList(
        requestInput,
        this.loadPurchaseOrderInTransitResponse,
        this.loadPurchaseOrderInTransitError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderInTransitResponse = (response) => {
    if (response.data != null && response.data.inTransitPageListBean != null) {
      if (response.data.inTransitPageListBean.purchaseOrderinTransits != null) {
        let purchaseOrderInTransitListData =
          response.data.inTransitPageListBean.purchaseOrderinTransits;
        let simpleAutoCompleteList = new Array();
        if (
          purchaseOrderInTransitListData.length > 0 &&
          purchaseOrderInTransitListData != null
        ) {
          purchaseOrderInTransitListData.map((obj) => {
            let simpleItemBean = {
              code: obj.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          poIntransitPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    }
  };
  loadPurchaseOrderInTransitError = (error) => {
    ShowError("Error :" + error);
  };
  readPurchaseInTransit = (purchaseInTransitCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Fields ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseInTransitCode;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderInTransitService.readPurchaseOrderInTransit(
        readrestInput,
        this.readPurchaseOrderInTransitResponse,
        this.readPurchaseOrderInTransitError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readPurchaseOrderInTransitResponse = (response) => {
    if (response.data.purchaseOrderinTransit != null) {
      let ptBean = response.data.purchaseOrderinTransit;
      if (ptBean != null) {
        this.setState(
          {
            purchaseOrderInTransitData: ptBean,
          },
          () => {
            this.toUpdatePurchaseOrderInTransitData(ptBean);
          },
        );

        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readPurchaseOrderInTransitError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : ", error);
  };
  getPurchaseOrderLineMaxLineNumber = (purchaseOrderReceiptData) => {
    let maxLineNumber = 1;
    let poLineData = purchaseOrderReceiptData.lines;
    if (poLineData.length > 0)
      poLineData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  };
  toUpdatePurchaseOrderData = () => {
    const purchaseOrderData = { ...this.state.purchaseOrderData };
    let purchaseOrderReceiptData = { ...this.state.purchaseOrderReceiptData };
    if (!isEmpty(purchaseOrderData)) {
      purchaseOrderReceiptData.factoryCode = purchaseOrderData.factoryCode;
      purchaseOrderReceiptData.receiptDate = new Date();
      purchaseOrderReceiptData.createdDate = new Date();
      purchaseOrderReceiptData.companyCode = this.companyCode;
      purchaseOrderReceiptData.purchaseOrderNumber = purchaseOrderData.code;
      purchaseOrderReceiptData.vendorCode = purchaseOrderData.vendorCode;
      purchaseOrderReceiptData.vendorName = purchaseOrderData.vendorName;
      purchaseOrderReceiptData.factoryCode = purchaseOrderData.factoryCode;
      purchaseOrderReceiptData.fOBCity = purchaseOrderData.fOBCity;
      purchaseOrderReceiptData.shipViaCode = purchaseOrderData.shipViaCode;
      purchaseOrderReceiptData.shipmentTermsCode =
        purchaseOrderData.shipmentTermsCode;
      purchaseOrderReceiptData.locationCode = purchaseOrderData.locationCode;
      purchaseOrderReceiptData.customerCode = purchaseOrderData.customerCode;
      purchaseOrderReceiptData.customerReferenceNumber =
        purchaseOrderData.customerReferenceNumber;
      purchaseOrderReceiptData.containerNumber =
        purchaseOrderData.containerNumber;
      var lineNumber = this.getPurchaseOrderLineMaxLineNumber(
        purchaseOrderReceiptData,
      );
      let receiptLines = new Array();
      if (purchaseOrderData.lines) {
        for (let line of purchaseOrderData.lines) {
          if (line.lineStatus == "O" || line.lineStatus == "I") {
            let receiptLine = new PurchaseOrderReceiptLineBean();
            receiptLine.companyCode = line.companyCode;
            receiptLine.lineStatus = "O";
            receiptLine.purchaseOrderNumber = line.purchaseOrderNumber;
            receiptLine.lineNumber = lineNumber;
            receiptLine.purchaseOrderLineNumber = line.lineNumber;
            receiptLine.fabricStyleCode = line.fabricStyleCode;
            receiptLine.fabricStyleName = line.fabricStyleName;
            receiptLine.widthCode = line.widthCode;
            receiptLine.colorCode = line.colorCode;
            receiptLine.skuNumber = line.skuNumber;
            receiptLine.upcCode = line.upcCode;
            receiptLine.uomCode = line.uomCode;
            receiptLine.inventoryUomCode = line.inventoryUomCode;
            receiptLine.uomConversionRate = line.uomConversionRate;
            receiptLine.locationCode = line.locationCode;
            receiptLine.vendorStyleCode = line.vendorStyleCode;
            receiptLine.vendorStyleColorCode = line.vendorStyleColorCode;
            receiptLine.purchaseOrderQuantity = line.orderQuantity;
            receiptLine.openOrderQuantity = line.openQuantity;
            receiptLine.receivedQuantity = 0;
            receiptLine.receivedQuantityToDate = 0;
            receiptLine.badQualityReceivedQuantity = 0;
            receiptLine.goodQualityReceivedQuantity = 0;
            receiptLine.inTransitQuantity = line.inTransitQuantity;
            receiptLine.openInTransistQuantity = line.inTransitQuantity;
            ++lineNumber;
            receiptLines.push(receiptLine);
          }
        }
      }
      purchaseOrderReceiptData.lines = receiptLines;
      this.setState({
        purchaseOrderReceiptData: purchaseOrderReceiptData,
        isShowInTransitLookup: false,
      });
    }
  };
  toUpdatePurchaseOrderInTransitData = (purchaseIntransitData) => {
    let purchaseOrderReceiptData = { ...this.state.purchaseOrderReceiptData };
    let purchaseOrderData = { ...this.state.purchaseOrderData };
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    if (!isEmpty(purchaseIntransitData)) {
      purchaseOrderReceiptData.factoryCode = purchaseIntransitData.factoryCode;
      purchaseOrderReceiptData.receiptDate = new Date();
      purchaseOrderReceiptData.createdDate = new Date();
      purchaseOrderReceiptData.companyCode = this.companyCode;
      purchaseOrderReceiptData.purchaseOrderNumber =
        purchaseIntransitData.purchaseOrderNumber;
      purchaseOrderReceiptData.purchaseOrderInTransitNumber =
        purchaseIntransitData.code;
      purchaseOrderReceiptData.vendorCode = purchaseIntransitData.vendorCode;
      purchaseOrderReceiptData.vendorName = purchaseIntransitData.vendorName;
      purchaseOrderReceiptData.factoryCode = purchaseIntransitData.factoryCode;
      purchaseOrderReceiptData.fOBCity = purchaseIntransitData.fOBCity;
      purchaseOrderReceiptData.shipViaCode = purchaseIntransitData.shipViaCode;
      purchaseOrderReceiptData.shipmentTermsCode =
        purchaseIntransitData.shipmentTermsCode;
      purchaseOrderReceiptData.locationCode = purchaseOrderData.locationCode;
      purchaseOrderReceiptData.vendorInvoiceNumber =
        purchaseIntransitData.vendorInvoiceNumber;
      purchaseOrderReceiptData.etaDate = purchaseIntransitData.etaDate;
      purchaseOrderReceiptData.etdDate = purchaseIntransitData.etdDate;
      var lineNumber = this.getPurchaseOrderLineMaxLineNumber(
        purchaseOrderReceiptData,
      );
      let intransits = [];
      let receiptLines = new Array();
      if (purchaseIntransitData.lines) {
        for (let line of purchaseIntransitData.lines) {
          if (
            line.lineStatus ==
              LogicConstants.PURCHASE_ORDER_INTRANSIT_LINE_OPEN_STATUS &&
            line.inTransitQuantity != 0
          ) {
            let receiptLine = new PurchaseOrderReceiptLineBean();
            receiptLine.companyCode = line.companyCode;
            receiptLine.lineStatus =
              LogicConstants.PURCHASE_ORDER_INTRANSIT_LINE_OPEN_STATUS;
            receiptLine.purchaseOrderNumber = line.purchaseOrderNumber;
            receiptLine.lineNumber = lineNumber;
            receiptLine.purchaseOrderLineNumber = line.lineNumber;
            receiptLine.fabricStyleCode = line.fabricStyleCode;
            receiptLine.fabricStyleName = line.fabricStyleName;
            receiptLine.widthCode = line.widthCode;
            receiptLine.colorCode = line.colorCode;
            receiptLine.skuNumber = line.skuNumber;
            receiptLine.upcCode = line.upcCode;
            receiptLine.uomCode = line.uomCode;
            receiptLine.inventoryUomCode = line.inventoryUomCode;
            receiptLine.uomConversionRate = line.uomConversionRate;
            receiptLine.locationCode = purchaseOrderReceiptData.locationCode;
            receiptLine.vendorStyleCode = line.vendorStyleCode;
            receiptLine.vendorStyleColorCode = line.vendorStyleColorCode;
            receiptLine.purchaseOrderQuantity = line.purchaseOrderQuantity;
            receiptLine.openOrderQuantity = line.openOrderQuantity;
            receiptLine.receivedQuantity = line.inTransitQuantity;
            receiptLine.receivedQuantityToDate = 0;
            receiptLine.badQualityReceivedQuantity = 0;
            receiptLine.goodQualityReceivedQuantity = 0;
            receiptLine.inTransitQuantity = line.inTransitQuantity;
            receiptLine.openInTransistQuantity = line.inTransitQuantity;
            receiptLine.purchaseOrderInTransitLineNumber = line.lineNumber;
            receiptLine.purchaseOrderInTransitNumber =
              line.purchaseOrderInTransitNumber;
            // receiptLine.receiptRollLines = line.inTransitRollLines;
            let intransitRollLines = [];
            if (line.inTransitRollLines) {
              line.inTransitRollLines.map((rolls) => {
                let rollLine = new PurchaseOrderReceiptRollLineBean();
                rollLine.companyCode = rolls.companyCode;
                rollLine.purchaseOrderReceiptNumber =
                  purchaseOrderReceiptData.code;
                rollLine.receiptRollLineNumber = rolls.inTransitRollLineNumber;
                rollLine.receiptLineNumber = receiptLine.lineNumber;
                rollLine.rollSkuNumber = rolls.rollSkuNumber;
                rollLine.rollNumber = rolls.rollNumber;
                rollLine.locationCode = receiptLine.locationCode;
                rollLine.locationType = rolls.locationType;
                rollLine.fabricStyleCode = rolls.fabricStyleCode;
                rollLine.fabricStyleName = rolls.fabricStyleCode;
                rollLine.widthCode = rolls.widthCode;
                rollLine.uomCode = rolls.uomCode;
                rollLine.colorCode = rolls.colorCode;
                rollLine.skuNumber = rolls.skuNumber;
                rollLine.receivedQuantity = rolls.inTransitQuantity;
                rollLine.inventoryUomCode = rolls.inventoryUomCode;
                rollLine.uomConversionRate = rolls.uomConversionRate;
                rollLine.inventoryReceivedQuantity = 0;
                rollLine.boxNumber = rolls.boxNumber;
                rollLine.vendorLotNumber = rolls.vendorLotNumber;
                rollLine.infoText = rolls.infoText;
                rollLine.aisleInfoText = rolls.aisleInfoText;
                rollLine.inTransitQuantity = rolls.inTransitQuantity;
                rollLine.purchaseOrderInTransitLineNumber =
                  rolls.inTransitLineNumber;
                rollLine.purchaseOrderInTransitRollLineNumber =
                  rolls.inTransitRollLineNumber;
                intransitRollLines.push(rollLine);
              });
            }
            receiptLine.receiptRollLines = intransitRollLines;
            intransits = intransitRollLines;
            ++lineNumber;
            receiptLines.push(receiptLine);
          }
        }
      }
      purchaseOrderReceiptData.lines = receiptLines;
      purchaseOrderReceiptLineData.totalRolls = intransits.length;
      this.setState({
        purchaseOrderReceiptData: purchaseOrderReceiptData,
        purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
      });
    }
  };
  getEmptyView() {
    return <div></div>;
  }
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setPurchaseReceiptHeaderView();
    } else if (selectedNode == "imageView") {
      this.setImageView();
    } else if (selectedNode == "multipleDocumentView") {
      this.setMultipleDocumentView();
    } else if (selectedNode == "historyView") {
      this.setPurchaseReceiptHistoryView();
    } else if (selectedNode == "receiptLinesApproval") {
      this.setReceiptLinesApprovalView();
    } else if (selectedNode == "receiptPaymentDetails") {
      this.setPaymentDetailView();
    }
  };
  getNodeList = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;

    let nodeList = [];
    //   let emptyObject = this.getEmptyView();
    let headerObject = this.getEmptyView();
    let historyDetailObject = this.getEmptyView();
    let receiptLinesApprovalObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject);
    let imageNode = new NodeData("imageView", "Image", headerObject);
    let multipleDocumentNode = new NodeData(
      "multipleDocumentView",
      "Documents",
      headerObject,
    );

    let historyDetailNode = new NodeData(
      "historyView",
      "History",
      historyDetailObject,
    );

    let receiptLinesApprovalNode = new NodeData(
      "receiptLinesApproval",
      "ReceiptLines Approval",
      receiptLinesApprovalObject,
    );
    let receiptPaymentDetailsNode = new NodeData(
      "receiptPaymentDetails",
      "ReceiptPaymentDetails",
    );
    nodeList["headerView"] = headerNode;
    if (purchaseOrderReceiptData.isFetched) {
      nodeList["imageView"] = imageNode;
      nodeList["multipleDocumentView"] = multipleDocumentNode;
      nodeList["historyView"] = historyDetailNode;

      if (
        purchaseOrderReceiptData.receiptStatus ===
        LogicConstants.PURCHASEORDER_RECEIPT_APPROVE_STATUS
      ) {
        nodeList["receiptPaymentDetails"] = receiptPaymentDetailsNode;
        nodeList["receiptLinesApproval"] = receiptLinesApprovalNode;
      }
    }
    this.setState({ nodeList: nodeList });
  };
  setPurchaseReceiptHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowBackButton: true,
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: true,
      isPurchaseOrderReceiptHistoryFormOpen: false,
      isPurchaseOrderReceiptApproveReceiptLinesFormOpen: false,
      isImageFormOpened: false,
      isDocumentsFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  setImageView = () => {
    this.closeAllNodeViews();
    this.setState({
      isImageFormOpened: true,
      isShowBackButton: false,
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: false,
      isPurchaseOrderReceiptApproveReceiptLinesFormOpen: false,
      isDocumentsFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  setMultipleDocumentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isMultipleDocFormOpened: true,
      isShowBackButton: false,
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: false,
      isPurchaseOrderReceiptApproveReceiptLinesFormOpen: false,
      isImageFormOpened: false,
      isDocumentsFormOpened: true,
      isPaymentDetailViewOpen: false,
    });
  };
  setPurchaseReceiptHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowBackButton: true,
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: true,
      isPurchaseOrderReceiptApproveReceiptLinesFormOpen: false,
      isImageFormOpened: false,
      isDocumentsFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };

  setReceiptLinesApprovalView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowBackButton: true,
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: false,
      isPurchaseOrderReceiptApproveReceiptLinesFormOpen: true,
      isImageFormOpened: false,
      isDocumentsFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  setPaymentDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowBackButton: true,
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: false,
      isPurchaseOrderReceiptApproveReceiptLinesFormOpen: false,
      isImageFormOpened: false,
      isDocumentsFormOpened: false,
      isPaymentDetailViewOpen: true,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: false,
      isPurchaseOrderReceiptApproveReceiptLinesFormOpen: false,
      isImageFormOpened: false,
      isDocumentsFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  validatePOReceipt = (poReceiptBean) => {
    let isValidPoReceiptBean = false;
    let err_list = [];
    let errorMessage = "";
    if (poReceiptBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(poReceiptBean.lines)) {
        let errMsg = "PO Receipt Lines is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(poReceiptBean.purchaseOrderNumber)) {
        let errMsg = "PO Number is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(poReceiptBean.vendorCode)) {
        let errMsg = "Vendor Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(poReceiptBean.vendorName)) {
        let errMsg = "Vendor Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidPoReceiptBean = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: false,
      });
    } else {
      isValidPoReceiptBean = true;
      this.setState({
        isShowAlert: false,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: false,
      });
    }
    return isValidPoReceiptBean;
  };
  save = () => {
    this.savePurchaseOrderReceipt();
  };
  savePurchaseOrderReceipt = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let poReceiptBean = this.state.purchaseOrderReceiptData;
    let isValidLine = false;
    isValidLine = this.validatePOReceipt(poReceiptBean);
    if (isValidLine) {
      if (poReceiptBean.isFetched) {
        if (
          SecurityAccessManager.PurchaseOrderReceiptMaintenanceEdit_IsAccessible()
        ) {
          PurchaseOrderReceiptService.updatePurchaseOrderReceipt(
            poReceiptBean,
            this.savePurchaseOrderReceiptResponse,
            this.savePurchaseOrderReceiptError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.PurchaseOrderReceiptMaintenanceCreate_IsAccessible()
        ) {
          PurchaseOrderReceiptService.createPurchaseOrderReceipt(
            poReceiptBean,
            this.savePurchaseOrderReceiptResponse,
            this.savePurchaseOrderReceiptError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
      // else {
      //   this.setState({
      //     isLoading: false,
      //     loadingText: "",
      //   });
      // }
    } else {
      this.setState({
        isLoading: false,
        loadingText: "",
      });
    }
  };
  savePurchaseOrderReceiptResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && !isEmpty(response.data.purchaseOrderReceipt)) {
      let purchaseOrderReceiptBean = response.data.purchaseOrderReceipt;
      let pageTitle = this.moduleCaption + " - EDIT";
      if (purchaseOrderReceiptBean != null) {
        this.setState({
          purchaseOrderReceiptData: purchaseOrderReceiptBean,
          pageTitle: pageTitle,
          isLoading: false,
          loadingText: "",
        },()=>{
 this.uploadImagesToServer();
            this.uploadMultiDocsToServer();
        });
    
       
        // this.unlockPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        // this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code, false);
        if (!this.isLocked) {
          this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        } else {
          this.code = purchaseOrderReceiptBean.code;
          this.unlockPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        }
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  savePurchaseOrderReceiptError = (error) => {
    ShowError("Error : " + error);
  };
  uploadMultiDocsToServer = () => {
    const receiptData = { ...this.state.purchaseOrderReceiptData };
    const documents = this.state.documents;
    if (!isEmptyArray(receiptData.receiptDocuments)) {
      receiptData.receiptDocuments.map((doc) => {
        if (doc.isDeleted != true && doc.isFetched != true) {
          documents.map((docData) => {
            if (doc.documentOriginalName == docData.name) {
              this.docToServer(docData, doc.documentName);
            }
          });
        }
      });
    }
  };

  docToServer = (file, fileName) => {
    let document = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", document);
    PurchaseOrderReceiptService.purchaseReceiptDocumentUpload(
      formData,
      this.documentUploadResponse,
      this.errorCallBack,
    );
  };
  documentUploadResponse = (response) => {};
  uploadImagesToServer = () => {
    const entity__Data = { ...this.state.purchaseOrderReceiptData };
    const images = this.state.images;
    if (!isEmptyArray(entity__Data.receiptImages)) {
      entity__Data.receiptImages.map((img) => {
        if (img.isDeleted != true && img.isFetched != true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        } else if (img.isFetched == true && img.isApplied == true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        }
      });
    }
    // }
  };
  toServer = (file, fileName) => {
    let image = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", image);
    PurchaseOrderReceiptService.purchaseOrderRecieptImageUpload(
      formData,
      this.imageUploadResponse,
      this.errorCallBack,
    );
  };
  imageUploadResponse = (response) => {};
  back = () => {
    this.closeEntryForm();
    this.loadPage(1);
  };
  onChange = (e) => {
    let tempPurchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    tempPurchaseOrderReceiptData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderReceiptData: tempPurchaseOrderReceiptData,
    });
  };
  onPurchaseOrderChange = (e) => {
    let purchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePurchaseOrderList = true;
    let tempPurchaseReceiptData = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
    if (isEmpty(purchaseOrderNumber)) {
      this.state.isShowAutoCompletePurchaseOrderList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
      let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
      purchaseOrderReceiptData.purchaseOrderNumber = "";
      purchaseOrderReceiptData.vendorCode = "";
      purchaseOrderReceiptData.vendorName = "";
      purchaseOrderReceiptData.locationCode = "";
      purchaseOrderReceiptData.factoryCode = "";
      purchaseOrderReceiptData.shipmentTermsCode = "";
      purchaseOrderReceiptData.fOBCity = "";
      purchaseOrderReceiptData.lines = new Array();
      purchaseOrderReceiptData.shipViaCode = "";
      purchaseOrderReceiptData.purchaseOrderInTransitNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: purchaseOrderReceiptData,
        purchaseOrderPageListForAutoCompleteList: suggestion,
        isShowAutoCompletePoIntransitList: false,
        poIntransitPageListForAutoCompleteList: suggestion,
        isDisablePoIntransit: false,
        isShowInTransitLookup: true,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderNumber !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    tempPurchaseReceiptData[e.target.name] = e.target.value;
    this.setState({ purchaseOrderReceiptData: tempPurchaseReceiptData });
  };
  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.readPurchaseOrderBySearchStringError,
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (response.data.purchaseOrderPageList != null) {
      if (purchaseorderData.length > 0 && purchaseorderData != null) {
        purchaseorderData.map((po) => {
          let simpleItemBean = {
            code: po.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readPurchaseOrderBySearchStringError = (error) => {
    ShowError("Error : " + error);
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    let poCode = e.target.value;
    this.readPurchaseOrder(poCode);
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };
  onDateChange = (e) => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    purchaseOrderReceiptData[e.target.name] = e.target.value;
    this.setState({ purchaseOrderReceiptData: purchaseOrderReceiptData });
  };
  onVendorCodeChange = (e) => {
    let tempPurchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    tempPurchaseOrderReceiptData[e.target.name] = e.target.value;
    let tempVendorData = this.state.currentVendor;
    if (e.target.name == "vendorCode") {
      tempPurchaseOrderReceiptData["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          tempPurchaseOrderReceiptData["vendorName"] = vendor.description;
          tempVendorData = vendor;
        }
      });
    }
    this.setState({
      purchaseOrderReceiptData: tempPurchaseOrderReceiptData,
      currentVendor: tempVendorData,
    });
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    this.setState({
      isPurchaseOrderReceiptListFormOpen: true,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isCollapsible_open: false,
      isShowSaveButton: false,
      isShowNewButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowCreateInvoiceButton: false,
      isShowNodes: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isShowExcelButton: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isImageFormOpened: false,
      isDocumentsFormOpened: false,
      isPaymentDetailViewOpen: false,
      isShowReturnButton: false,
    });
  };
  openEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: true,
      isCollapsible_open: false,
      isImageFormOpened: false,
      isDocumentsFormOpened: false,
      isPaymentDetailViewOpen: false,
      isShowSaveButton: true,
      isShowNewButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      isShowApproveButton: true,
      isShowCancelButton: false,
      isShowCreateInvoiceButton: false,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      isResetView: false,
      isShowPORButton: true,
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteRolllineLocationList: false,
      rollLineLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFobCityList: false,
      FobCityPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipmentTermList: false,
      shipmentTermPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoIntransitList: false,
      poIntransitPageListForAutoCompleteList: new Array(),
      isDisableButtons: true,
      isShowInTransitLookup: true,
      isDisablePoIntransit: false,
      isShowReturnButton: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isPurchaseOrderReceiptListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
        disableFormFields: false,
        isDisablePoIntransit: false,
      });
    } else {
      this.setState({
        isDisabledFields: true,
        disableFormFields: true,
        isDisablePoIntransit: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let receiptStatus = ModuleUtils.getPurchaseOrderReceiptStatusCaption(
      this.state.purchaseOrderReceiptData.receiptStatus,
    );
    if (receiptStatus !== undefined && receiptStatus !== null) {
      moduleOrderStatus = receiptStatus;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    if (purchaseOrderReceiptData.isFetched) {
      if (
        purchaseOrderReceiptData.receiptStatus ==
        LogicConstants.PURCHASEORDER_RECEIPT_APPROVE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: false,
          isShowSaveButton: false,
          disableFormFields: true,
          isShowExcelButton: true,
          isShowPDFReportButton: true,
          isShowPORButton: false,
          isDisableButtons: false,
          isShowCreateInvoiceButton: true,
          isShowInTransitLookup: false,
          isDisablePoIntransit: true,
          isShowReturnButton: true,
        });
      }
      if (
        purchaseOrderReceiptData.receiptStatus ==
        LogicConstants.PURCHASEORDER_RECEIPT_UNAPPROVE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: true,
          isShowSaveButton: true,
          disableFormFields: false,
          isShowExcelButton: true,
          isShowPDFReportButton: true,
          isShowPORButton: false,
          isDisableButtons: true,
          isShowCreateInvoiceButton: false,
          isShowInTransitLookup: true,
          isDisablePoIntransit: true,
          isShowReturnButton: false,
        });
      }
      if (
        purchaseOrderReceiptData.receiptStatus ==
        LogicConstants.PURCHASEORDER_RECEIPT_CANCEL_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: false,
          isShowSaveButton: false,
          disableFormFields: true,
          isShowExcelButton: true,
          isShowPDFReportButton: true,
          isShowPORButton: false,
          isDisableButtons: false,
          isShowCreateInvoiceButton: false,
          isShowInTransitLookup: false,
          isDisablePoIntransit: true,
        });
      }
      if (!purchaseOrderReceiptData.isFetched) {
        this.setState({
          isDisableButtons: true,
          isShowUnApproveButton: false,
          disableFormFields: true,
          isShowPORButton: false,
          isShowAutoCompletePurchaseOrderList: false,
          purchaseOrderPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteRolllineLocationList: false,
          rollLineLocationPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteLocationList: false,
          locationPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteFobCityList: false,
          FobCityPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteShipmentTermList: false,
          shipmentTermPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteShipViaList: false,
          shipViaPageListForAutoCompleteList: new Array(),
          isShowAutoCompletePoIntransitList: false,
          poIntransitPageListForAutoCompleteList: new Array(),
          isShowCreateInvoiceButton: false,
          isShowInTransitLookup: true,
        });
      }
    }
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        disabled: true,
        pageTitle: pageTitle,
        disableFormFields: true,
        isDisablePoIntransit: true,
        isDisableButtons: false,
      });
    }
  };
  editPurchaseOrderReceipt = (receiptCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = receiptCode;
    let isLockRequired = false;
    if (this.props.isSpecialViewMode) {
      isLockRequired = false;
    } else {
      isLockRequired = NEW_ENTRY === receiptCode ? false : true;
    }
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.initPurchaseOrderReceiptModule(
        readrestInput,
        this.editPOReceiptResponse,
        this.editPOReceiptError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      // disabled: true,
      isLoading: true,
    });
  };
  editPOReceiptResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.purchaseOrderReceiptResponse != null) {
      let prBean = response.data.purchaseOrderReceiptResponse;
     
      
      if(prBean.receiptStatus == LogicConstants.PURCHASEORDER_RECEIPT_APPROVE_STATUS || prBean.receiptStatus == LogicConstants.PURCHASEORDER_RECEIPT_UNAPPROVE_STATUS ){
            
              this.setState({
                  isVendorInvoiceShow:false
                })
            }else{
               this.setState({
                  isVendorInvoiceShow:true
                })
            }
      if (response.data.purchaseOrderReceiptResponse.errors != null) {
        response.data.purchaseOrderReceiptResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (response.data.purchaseOrderReceiptResponse != null) {
      if (
        errMsg !=
        "Purchase Order Receipt [" + this.state.moduleKeyCode + "] Not read!"
      ) {
        this.showErrorMessage(response.data.purchaseOrderReceiptResponse);
      }
    }
    if (response.data.dependenciesResponse != null) {
      if (response.data.dependenciesResponse.dependenciesBean != null) {
        let fabricStyles =
          response.data.dependenciesResponse.dependenciesBean.fabricStyles;
        let purchaseOrderBean =
          response.data.dependenciesResponse.dependenciesBean.purchaseOrder;
        this.setState({
          fabricStyles: fabricStyles,
          purchaseOrderBean: purchaseOrderBean,
        });
      }
    }
    if (response.data.purchaseOrderReceiptResponse != null) {
      if (
        response.data.purchaseOrderReceiptResponse.purchaseOrderReceipt != null
      ) {
        let poReceiptBean =
          response.data.purchaseOrderReceiptResponse.purchaseOrderReceipt;
        let pageTitle = this.moduleCaption + " - EDIT";
        let moduleKeyCode = poReceiptBean.code;

        if (!isEmptyArray(poReceiptBean.receiptDocuments)) {
          const preview_Docs = poReceiptBean.receiptDocuments;
          let url = this.getDocURL();
          let urlDoc_list = [];
          preview_Docs.map((urlIndex) => {
            urlDoc_list.push(url + urlIndex.documentName);
          });
          this.setState({
            // imgData: imagesList,
            documents: preview_Docs,
            preview_Docs: urlDoc_list,
          });
        } else {
          this.setState({
            preview_Docs: [],
            documents: [],
          });
        }
        if (!isEmptyArray(poReceiptBean.receiptImages)) {
          const imagesList = poReceiptBean.receiptImages;

          let url = this.getImageURL();
          // url = url + imagesList[0].imageName;
          // this.setImgUrl(url);
          let url_list = [];
          imagesList.map((urlIndex) => {
            url_list.push(url + urlIndex.imageName);
          });
          this.setState({
            imgData: null,
            preview_Url: url_list,
            images: imagesList,
          });
        } else {
          this.setState({
            imgUrl: "",
            imgData: null,
            images: [],
            preview_Url: [],
          });
        }
        this.setState(
          {
            purchaseOrderReceiptData: poReceiptBean,
            pageTitle: pageTitle,
            isFocusLookup: false,
            isFocus: true,
            moduleKeyCode: moduleKeyCode,
            isLoading: false,
            selectedNodeKey: "headerView",
          },
          () => {
            this.openEntryForm();
          },
        );
        this.isLocked = true;
        // //this.getNodeList();
        // this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
    this.setState({ isLoading: false });
  };
  editPOReceiptError = (error) => {
    this.showErrorMessage(error);
  };
  getImageURL = () => {
    const { appData } = this.context;
    return appData.serviceURL + "/" + "purchasereceiptimages?file=";
  };

  getDocURL = () => {
    const { appData } = this.context;
    return appData.serviceURL + "/" + "purchaseReceiptDocument?file=";
    // return appData.serviceURL + "/" + process.env.REACT_APP_ITEM_DOC_PATH;
  };
  editPurchaseOrderReceiptLine = (val, rowData) => {
    let receiptData = this.state.purchaseOrderReceiptData;
    let receiptLineData = { ...rowData };
    let poReceiptRollLines_List = [];
    receiptLineData.receiptRollLines.map((ln) => {
      poReceiptRollLines_List.push(ln);
    });
    receiptLineData.purchaseOrderReceiptNumber = receiptData.code;
    receiptLineData.totalRolls = poReceiptRollLines_List.length;
    this.setState({
      purchaseOrderReceiptLineData: receiptLineData,
      poReceiptRollLinesList: poReceiptRollLines_List,
    });
  };
  onPurchaseOrderReceiptLineChange = (e) => {
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    purchaseOrderReceiptLineData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
    });
  };
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );

        success = true;
      }
    }
    if (!isEmpty(response.additionalOperationResponse)) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );

        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );

        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyArray(errList)) {
      // let errorMsg = [];
      // errorMsg.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  approvePurchaseOrderReceipt = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Approving PO Receipt",
      });
      let poReceiptBean = this.state.purchaseOrderReceiptData;
      let inputRequest = new RestPurchaseOrderReceiptBeanRequest();
      inputRequest.purchaseOrderReceiptBean = poReceiptBean;
      inputRequest.companyCode = this.companyCode;
      if (poReceiptBean.isFetched) {
        inputRequest.isLockRequired = true;
      } else {
        inputRequest.isLockRequired = false;
      }
      if (poReceiptBean.isFetched) {
        if (
          SecurityAccessManager.PurchaseOrderReceiptMaintenanceApprove_IsAccessible()
        ) {
          PurchaseOrderReceiptService.updateAndApprovePurchaseOrderReceipt(
            inputRequest,
            this.approvePurchaseOrderReceiptResponse,
            this.approvePurchaseOrderReceiptError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.PurchaseOrderReceiptMaintenanceApprove_IsAccessible()
        ) {
          PurchaseOrderReceiptService.createAndApprovePurchaseOrderReceipt(
            inputRequest,
            this.approvePurchaseOrderReceiptResponse,
            this.approvePurchaseOrderReceiptError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };

  approvePurchaseOrderReceiptResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleApproveResponse(response.data);
    if (
      response.data != null &&
      response.data.additionalOperationResponse != null
    ) {
      const purchaseOrderReceiptBean =
        response.data.additionalOperationResponse.purchaseOrderReceipt;
      if (purchaseOrderReceiptBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderReceiptData: purchaseOrderReceiptBean,
          pageTitle: pageTitle,
          disableFormFields: true,
        });
        // if (!this.isLocked) {
        this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        // } else {
        //   this.code = purchaseOrderReceiptBean.code;
        //   this.unlockPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        // }
      }
    }
  };
  approvePurchaseOrderReceiptError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error :" + error);
  };

  onLineCancelReasonContinue = () => {
    this.savePurchaseReceiptLineCancel();
    this.closeReasonModelCallBack();
  };
  savePurchaseReceiptLineCancel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling PO Receipt",
    });
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    let input = new RestPurchaseOrderReceiptLineRequest();
    let temp_purchaseOrderReceiptLineSearchCriteria =
      new PurchaseOrderReceiptLineSearchCriteria();
    temp_purchaseOrderReceiptLineSearchCriteria.companyCode = this.companyCode;
    temp_purchaseOrderReceiptLineSearchCriteria.purchaseOrderNumber =
      purchaseOrderReceiptLineData.purchaseOrderNumber;
    temp_purchaseOrderReceiptLineSearchCriteria.purchaseOrderLineNumber =
      purchaseOrderReceiptLineData.purchaseOrderLineNumber;
    temp_purchaseOrderReceiptLineSearchCriteria.purchaseOrderReceiptNumber =
      purchaseOrderReceiptLineData.purchaseOrderReceiptNumber;
    temp_purchaseOrderReceiptLineSearchCriteria.purchaseOrderReceiptLineNumber =
      purchaseOrderReceiptLineData.lineNumber;
    input.companyCode = this.companyCode;
    input.lineSearchCriteria = temp_purchaseOrderReceiptLineSearchCriteria;
    input.reason = this.state.reasonData;
    input.isLockRequired = true;
    if (
      SecurityAccessManager.PurchaseOrderReceiptMaintenanceCancel_IsAccessible()
    ) {
      PurchaseOrderReceiptService.cancelPurchaseOrderReceiptLine(
        input,
        this.savePurchaseOrderLineCancelResponse,
        this.savePurchaseOrderLineCancelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  savePurchaseOrderLineCancelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.purchaseOrderReceipt.lines)
    ) {
      let purchaseOrderReceipt = response.data.purchaseOrderReceipt;
      this.setState({
        purchaseOrderReceiptData: purchaseOrderReceipt,
      });
      // this.unlockPurchaseOrderReceipt(response.data.purchaseOrderReceipt.code);
      // this.editPurchaseOrderReceipt(response.data.purchaseOrderReceipt.code);
      if (this.isLocked) {
        this.code = purchaseOrderReceipt.code;
        this.unlockPurchaseOrderReceipt(
          response.data.purchaseOrderReceipt.code,
        );
      }
    }
  };
  savePurchaseOrderLineCancelError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error cancel line: " + error);
  };
  onRollLineCancelReasonContinue = () => {
    // let isValid = false;
    // isValid = this.isValidReason();
    // if (isValid) {
    //   if (
    //     !isEmpty(this.rollLineCancelReasonDialogRef) &&
    //     !isEmpty(this.rollLineCancelReasonDialogRef.current)
    //   ) {
    //     this.rollLineCancelReasonDialogRef.current.closeDialog();
    //   }
    // }
    this.closeReasonModelCallBack();
  };
  reArrangeRollLineDisplayNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.receiptRollLineNumber = maxLineNumber;
    });
  };
  deleteReceiptRollLine = (rowData) => {
    let receiptLineData = this.state.purchaseOrderReceiptLineData;
    let lines = this.state.poReceiptRollLinesList;
    if (!rowData.isFetched) {
      if (!isEmptyArray(lines)) {
        var index1 = lines.indexOf(rowData);
        if (index1 > -1) {
          lines.splice(index1, 1);
        }
        this.reArrangeRollLineDisplayNumbers(lines);
        this.setReceivedQtyValues(lines);
        this.state.poReceiptRollLinesList = lines;
      }
    } else {
      let errMsg = "Already Existing PurchaseRoll Lines";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    }
  };
  setReceivedQtyValues = (lines) => {
    let lineData = this.state.purchaseOrderReceiptLineData;
    let receivedQty = 0;
    lines.map((ln) => {
      receivedQty += parseFloat(ln.receivedQuantity);
    });
    lineData.receivedQuantity = parseFloat(receivedQty).toFixed(2);
    lineData.totalRolls = lines.length;
    this.setState({
      purchaseOrderReceiptLineData: lineData,
      poReceiptRollLinesList: lines,
    });
  };
  isValidReason = () => {
    let isValid = true;
    let err_list = [];
    let errorMsg = "";
    if (isEmpty(this.state.reasonData)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    if (isEmptyString(this.state.reasonData.code)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    this.setState({ error_list: err_list });
    if (err_list.length > 0) isValid = false;
    return isValid;
  };
  saveCancelPurchaseOrderReceipt = () => {
    let poBean = this.state.purchaseOrderReceiptData;
    let purchaseReceiptRequest = new RestPurchaseOrderReceiptRequest();
    purchaseReceiptRequest.purchaseOrderReceiptBean = poBean;
    purchaseReceiptRequest.reason = this.state.reasonData;
    if (
      SecurityAccessManager.PurchaseOrderReceiptMaintenanceCancel_IsAccessible()
    ) {
      PurchaseOrderReceiptService.cancelAndUnLockPurchaseOrderReceiptAfterApproval(
        purchaseReceiptRequest,
        this.cancelPurchaseOrderReceiptResponse,
        this.cancelPurchaseOrderReceiptError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  cancelPurchaseOrderReceiptResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && response.data.mainOperationResponse != null) {
      this.handleResponse(response.data.mainOperationResponse);
      const purchaseOrderReceiptBean =
        response.data.mainOperationResponse.purchaseOrderReceipt;
      if (purchaseOrderReceiptBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderReceiptData: purchaseOrderReceiptBean,
          pageTitle: pageTitle,
          disableFormFields: true,
          isLoading: false,
          loadingText: "",
        });
        this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
      }
    }
  };
  cancelPurchaseOrderReceiptError = (error) => {
    ShowError("Error :" + error);
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
      isShowRollLineCancelReasonPopup: false,
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    } else if (type === 3) {
      this.setState({
        isShowLineCancelReasonPopup: true,
      });
    } else if (type === 3) {
      this.setState({
        isShowRollLineCancelReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  onCancelReasonContinue = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling ...",
    });
    this.saveCancelPurchaseOrderReceipt();
    this.closeReasonModelCallBack();
  };
  cancelPurchaseOrderReceipt = (e) => {
    if (e.detail == 1) this.openReasonCapture(1);
  };
  addOrUpdatePurchaseOrderReceiptLine = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let lines = [];
    lines = purchaseOrderReceiptData.lines;
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    purchaseOrderReceiptLineData.receiptRollLines =
      this.state.poReceiptRollLinesList;

    if (!isEmptyArray(lines)) {
      lines.map((line, i) => {
        if (line.lineNumber == purchaseOrderReceiptLineData.lineNumber) {
          lines[i] = purchaseOrderReceiptLineData;
        }
      });
    }
    purchaseOrderReceiptData.lines = lines;
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
      isShowPopup: false,
    });
    this.closePoReceiptLinePopup();
  };
  closePoReceiptLinePopup = () => {
    this.setState({
      poReceiptRollLinesList: new Array(),
    });
  };
  editPurchaseOrderReceiptRollLine = (val, rowData) => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let rollLineData = { ...rowData };
    this.setState({ purchaseOrderReceiptRollLineData: rollLineData });
    if (rowData.isFetched) {
      //changed from true --> False on both state's
      this.setState({
        isDisableRollLine: true,
        disableFormFields: true,
      });
      if (
        purchaseOrderReceiptData.receiptStatus ==
        LogicConstants.PURCHASEORDER_RECEIPT_UNAPPROVE_STATUS
      ) {
        this.setState({
          isDisableRollLine: false,
          disableFormFields: false,

          isShowSaveButton: true,
        });
      }
    }
  };
  onPurchaseOrderReceiptRollLineChange = (e) => {
    let purchaseOrderReceiptRollLineData =
      this.state.purchaseOrderReceiptRollLineData;
    let poReceiptRollLines_List = this.state.poReceiptRollLinesList;
    purchaseOrderReceiptRollLineData[e.target.name] = e.target.value;
    let rollNumber = 0;
    if (e.target.name == "vendorLotNumber") {
      if (!isEmptyArray(poReceiptRollLines_List)) {
        poReceiptRollLines_List.map((roll) => {
          if (roll.receiptRollLineNumber > 0) {
            if (roll.vendorLotNumber == e.target.value)
              rollNumber = roll.rollNumber;
          }
        });
      }
      rollNumber++;
      purchaseOrderReceiptRollLineData.rollNumber = rollNumber;
    }
    this.setState({
      purchaseOrderReceiptRollLineData: purchaseOrderReceiptRollLineData,
    });
  };
  validatePOReceiptLines = (PoLine) => {
    let isValidPoReceiptBean = false;
    let err_list = [];
    let errorMessage = "";
    if (PoLine == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (
        isEmptyString(PoLine.receivedQuantity) ||
        PoLine.receivedQuantity <= 0
      ) {
        let errMsg = "Invalid ReceivedQty";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(PoLine.vendorLotNumber)) {
        let errMsg = "Invalid VENDOR LOT";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidPoReceiptBean = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: false,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: true,
      });
    } else {
      isValidPoReceiptBean = true;
      this.setState({
        isShowAlert: false,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: false,
      });
    }
    return isValidPoReceiptBean;
  };
  multiAddPurchaseOrderReceiptRollLine = (e) => {
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    let receiptData = this.state.purchaseOrderReceiptData;
    let purchaseOrderReceiptRollLineData =
      this.state.purchaseOrderReceiptRollLineData;
    let poReceiptRollLines_List = this.state.poReceiptRollLinesList;
    let receivedQty = 0;
    let isValidLine = false;
    isValidLine = this.validatePOReceiptLines(purchaseOrderReceiptRollLineData);
    if (isValidLine) {
      let rollLineFound = false;
      if (!isEmptyArray(poReceiptRollLines_List)) {
        poReceiptRollLines_List.map((line, i) => {
          if (
            line.receiptRollLineNumber ==
            purchaseOrderReceiptRollLineData.receiptRollLineNumber
          ) {
            poReceiptRollLines_List[i] = purchaseOrderReceiptRollLineData;
            rollLineFound = true;
          }
        });
      }
      if (!rollLineFound) {
        poReceiptRollLines_List.push(purchaseOrderReceiptRollLineData);
      }
      if (!isEmptyArray(poReceiptRollLines_List)) {
        poReceiptRollLines_List.map((ln) => {
          receivedQty += parseFloat(ln.receivedQuantity);
        });
      }
      purchaseOrderReceiptLineData.receivedQuantity =
        parseFloat(receivedQty).toFixed(2);
      purchaseOrderReceiptLineData.totalRolls = poReceiptRollLines_List.length;

      this.setState({
        poReceiptRollLinesList: poReceiptRollLines_List,
        purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
      });
    }
    this.clearRollLineDetails();
  };
  addOrUpdatePurchaseOrderReceiptRollLine = (e) => {
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    let receiptData = this.state.purchaseOrderReceiptData;
    let purchaseOrderReceiptRollLineData =
      this.state.purchaseOrderReceiptRollLineData;
    let poReceiptRollLines_List = this.state.poReceiptRollLinesList;
    let receivedQty = 0;
    let isValidLine = false;
    isValidLine = this.validatePOReceiptLines(purchaseOrderReceiptRollLineData);
    if (isValidLine) {
      let rollLineFound = false;
      if (!isEmptyArray(poReceiptRollLines_List)) {
        poReceiptRollLines_List.map((line, i) => {
          if (
            line.receiptRollLineNumber ==
            purchaseOrderReceiptRollLineData.receiptRollLineNumber
          ) {
            poReceiptRollLines_List[i] = purchaseOrderReceiptRollLineData;
            rollLineFound = true;
          }
        });
      }
      if (!rollLineFound) {
        poReceiptRollLines_List.push(purchaseOrderReceiptRollLineData);
      }
      if (!isEmptyArray(poReceiptRollLines_List)) {
        poReceiptRollLines_List.map((ln) => {
          receivedQty += parseFloat(ln.receivedQuantity);
        });
      }
      purchaseOrderReceiptLineData.receivedQuantity =
        parseFloat(receivedQty).toFixed(2);
      purchaseOrderReceiptLineData.totalRolls = poReceiptRollLines_List.length;
      this.setState({
        poReceiptRollLinesList: poReceiptRollLines_List,
        purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
      });
      this.closeLinePopup();
    }
  };
  addNewRollLine = (e) => {
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    let poReceiptRollLines_List = this.state.poReceiptRollLinesList;
    let purchaseOrderReceiptRollLineData =
      this.state.purchaseOrderReceiptRollLineData;
    let rollLineNumber = 0;
    let rollNumber = 0;
    let vendorLotNumber = "";
    if (!isEmptyArray(poReceiptRollLines_List)) {
      poReceiptRollLines_List.map((roll) => {
        if (roll.receiptRollLineNumber > 0) {
          rollLineNumber = roll.receiptRollLineNumber;
          vendorLotNumber = roll.vendorLotNumber;
          rollNumber = roll.rollNumber;
          if (
            !isEmptyString(purchaseOrderReceiptRollLineData.vendorLotNumber)
          ) {
            if (roll.vendorLotNumber == vendorLotNumber)
              // rollNumber = rollLineNumber;
              rollNumber++;
          }
        }
      });
    }
    rollLineNumber++;

    let rollLineData = new PurchaseOrderReceiptRollLineBean();
    rollLineData.companyCode = purchaseOrderReceiptLineData.companyCode;
    rollLineData.purchaseOrderReceiptNumber =
      purchaseOrderReceiptLineData.purchaseOrderReceiptNumber;
    rollLineData.receiptRollLineNumber = rollLineNumber;
    rollLineData.receiptLineNumber = purchaseOrderReceiptLineData.lineNumber;
    rollLineData.rollNumber = rollNumber;
    rollLineData.locationCode = purchaseOrderReceiptLineData.locationCode;
    rollLineData.fabricStyleCode = purchaseOrderReceiptLineData.fabricStyleCode;
    rollLineData.fabricStyleName = purchaseOrderReceiptLineData.fabricStyleName;
    rollLineData.widthCode = purchaseOrderReceiptLineData.widthCode;
    rollLineData.uomCode = purchaseOrderReceiptLineData.uomCode;
    rollLineData.colorCode = purchaseOrderReceiptLineData.colorCode;
    rollLineData.skuNumber = purchaseOrderReceiptLineData.skuNumber;
    rollLineData.inventoryUomCode =
      purchaseOrderReceiptLineData.inventoryUomCode;
    rollLineData.uomConversionRate =
      purchaseOrderReceiptLineData.uomConversionRate;
    rollLineData.inTransitQuantity =
      purchaseOrderReceiptLineData.inTransitQuantity;
    if (!isEmptyString(vendorLotNumber))
      rollLineData.vendorLotNumber = vendorLotNumber;
    this.setState({ purchaseOrderReceiptRollLineData: rollLineData });
  };
  addNewEntry = () => {
    let purchaseOrderReceiptData = new PurchaseOrderReceiptBean();
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
    });
    this.setNewPurchaseOrderDefaultData(purchaseOrderReceiptData);
    this.openEntryForm();
  };
  setNewPurchaseOrderDefaultData = (purchaseOrderReceiptData) => {
    purchaseOrderReceiptData.companyCode = this.companyCode;
    purchaseOrderReceiptData.receiptStatus =
      LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS;
    purchaseOrderReceiptData.currencyCode = "USD";
    let pageTitle = this.moduleCaption + " - NEW";
    if (
      this.state.moduleKeyCode != NEW_ENTRY &&
      !isEmptyString(this.state.moduleKeyCode)
    ) {
      purchaseOrderReceiptData.code = this.state.moduleKeyCode;
    } else {
      purchaseOrderReceiptData.code = NEW_ENTRY;
    }
    if (this.state.moduleKeyCode == NEW_ENTRY) {
      this.isLocked = false;
    } else {
      this.isLocked = true;
    }
    purchaseOrderReceiptData.receiptDate = toFormattedDate_v1(new Date());
    purchaseOrderReceiptData.createdDate = new Date();
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
      pageTitle: pageTitle,
      isLoading: false,
    });
    this.state.purchaseOrderReceiptData = purchaseOrderReceiptData;
  };
  getPurchaseOrderLinesDatasFromExcel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Loading Excel Data",
    });
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    let selectedDocument = this.state.selectedDocument;
    let readrestInput = new RestPurchaseOrderReceiptExcelImportRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.purchaseOrderNumber =
      purchaseOrderReceiptLineData.purchaseOrderNumber;
    readrestInput.excelFileName = selectedDocument;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.getPurchaseOrderLinesDatasFromExcel(
        readrestInput,
        this.getPoLineDataExcelResponse,
        this.getPoLineDataExcelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  handleDataExcelResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowPopupAlert: true,
      });
    }
  };

  getPoLineDataExcelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleDataExcelResponse(response.data);
    let purchaseOrderReceiptElectronicInputBean =
      this.state.purchaseOrderReceiptElectronicInputBean;
    if (!isEmpty(response.data) && !isEmpty(response.data.einput)) {
      purchaseOrderReceiptElectronicInputBean = response.data.einput;
      this.setState({
        progressLoadingText: "Fetching Data...",
      });
      this.setState(
        {
          purchaseOrderReceiptElectronicInputBean:
            purchaseOrderReceiptElectronicInputBean,
        },
        () => {
          this.toGenerateRollLinesFromExcelInputBean();
        },
      );
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  getPoLineDataExcelError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("error :", error);
  };
  getMaxRollLineNumber = () => {
    let maxLineNumber = 0;
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    if (!isEmptyArray(this.state.poReceiptRollLinesList)) {
      this.state.poReceiptRollLinesList.map((line) => {
        if (line.receiptRollLineNumber > maxLineNumber) {
          maxLineNumber = line.receiptRollLineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  toGenerateRollLinesFromExcelInputBean = () => {
    let purchaseOrderReceiptElectronicInputBean =
      this.state.purchaseOrderReceiptElectronicInputBean;
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    if (!purchaseOrderReceiptLineData) {
      return;
    }
    if (!purchaseOrderReceiptLineData.fabricStyleCode) {
      return;
    }

    let receiptRollLines = [];
    receiptRollLines = this.state.poReceiptRollLinesList;
    var lineNumber = this.getMaxRollLineNumber();

    let rollLineNumber = 0;
    let receivedQuantity = 0;
    let rollLines = purchaseOrderReceiptElectronicInputBean.rollLines;
    if (rollLines != null && !isEmptyArray(rollLines)) {
      for (let list of rollLines) {
        if (
          list.fabricStyleCode ===
            purchaseOrderReceiptLineData.fabricStyleCode &&
          list.colorCode === purchaseOrderReceiptLineData.colorCode
        ) {
          rollLineNumber++;
          let rollLineData = new PurchaseOrderReceiptRollLineBean();

          rollLineData.companyCode = purchaseOrderReceiptLineData.companyCode;
          rollLineData.purchaseOrderReceiptNumber =
            purchaseOrderReceiptLineData.purchaseOrderReceiptNumber;
          // if (!isEmptyArray(receiptRollLines)) {

          rollLineData.receiptRollLineNumber = ++lineNumber;
          // } else {

          //   rollLineData.receiptRollLineNumber = rollLineNumber;
          // }

          rollLineData.receiptLineNumber =
            purchaseOrderReceiptLineData.lineNumber;
          rollLineData.locationCode = purchaseOrderReceiptLineData.locationCode;
          rollLineData.fabricStyleCode =
            purchaseOrderReceiptLineData.fabricStyleCode;
          rollLineData.fabricStyleName =
            purchaseOrderReceiptLineData.fabricStyleName;
          rollLineData.widthCode = purchaseOrderReceiptLineData.widthCode;
          rollLineData.uomCode = purchaseOrderReceiptLineData.uomCode;
          rollLineData.colorCode = purchaseOrderReceiptLineData.colorCode;
          rollLineData.skuNumber = purchaseOrderReceiptLineData.skuNumber;
          rollLineData.inventoryUomCode =
            purchaseOrderReceiptLineData.inventoryUomCode;
          rollLineData.uomConversionRate =
            purchaseOrderReceiptLineData.uomConversionRate;
          rollLineData.inTransitQuantity =
            purchaseOrderReceiptLineData.inTransitQuantity;
          rollLineData.rollNumber = list.rollNumber;
          rollLineData.receivedQuantity = list.quantity;
          rollLineData.inventoryReceivedQuantity = list.quantity;
          rollLineData.vendorLotNumber = list.lotNumber;
          rollLineData.boxNumber = list.boxNumber;
          rollLineData.aisleInfoText = list.aisleInfoText;
          rollLineData.infoText = list.infoText;
          receivedQuantity = receivedQuantity + parseFloat(list.quantity);
          receiptRollLines.push(rollLineData);
        } else {
          let errMsg =
            "Load Roll from Excel File, No Matching inTransitRoll Data for this FabricStyle / Color";
          let errList = [];
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
    purchaseOrderReceiptLineData.totalRolls = rollLines.length;
    purchaseOrderReceiptLineData.receivedQuantity = receivedQuantity.toFixed(2);
    this.setState(
      {
        purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
        poReceiptRollLinesList: receiptRollLines,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      },
      () => {
        let isLoading = false;
      },
    );
  };
  // uploadExcelFile = (e) => {
  //   let file = e.target.files[0];
  //   let fileName = file.name;
  //   let fileData = new File([file], `${fileName}`, { type: file.type });
  //   let formData = new FormData();
  //   formData.append("file", fileData);
  //   this.setState({ selectedDocument: fileName });
  //   if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
  //     PurchaseOrderReceiptService.uploadExcelInput(
  //       formData,
  //       this.uploadRollLineExcelResponse,
  //       this.uploadRollLineExcelError
  //     );
  //   } else {
  //     let errMsg = "Access Denied";
  //     let errList = [];
  //     errList.push(errMsg);

  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //   }
  // };

  uploadExcelFile = (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];
    if (!file) return;

    const fileName = file.name;
    const fileData = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", fileData);

    this.setState({
      selectedDocument: fileName,
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Data..",
    });
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.uploadExcelInput(
        formData,
        this.uploadRollLineExcelResponse,
        this.uploadRollLineExcelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    // 👇 reset the input so user can select the same file again
    fileInput.value = "";
  };
  uploadRollLineExcelResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getPurchaseOrderLinesDatasFromExcel();
      }
    }
  };
  uploadRollLineExcelError = (error) => {};
  reArrangePurchaseReceiptLineNumbers = (LineList) => {
    let maxLineNumber = 0;
    LineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  cancelPurchaseReceiptLine = (receiptlineData) => {
    let purchaseOrderReceiptLineData = receiptlineData;
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let existingLine = this.getReceiptLinebyLineNumber(
      receiptlineData.lineNumber,
    );
    this.state.purchaseOrderReceiptLineData = { ...existingLine };
    if (!isEmpty(existingLine)) {
      if (!existingLine.isFetched) {
        const index = purchaseOrderReceiptData.lines.findIndex(
          (ln) => ln.lineNumber === existingLine.lineNumber,
        );
        if (index != -1) {
          purchaseOrderReceiptData.lines.splice(index, 1);
        }
        this.setState({
          purchaseOrderReceiptData: purchaseOrderReceiptData,
        });
      } else {
        this.openReasonCapture(3);
      }
    }
    this.reArrangePurchaseReceiptLineNumbers(purchaseOrderReceiptData.lines);
    this.setState({
      purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
    });
  };
  getReceiptLinebyLineNumber = (lineNumber) => {
    let receiptLine = null;
    if (this.state.purchaseOrderReceiptData === null) return receiptLine;
    else if (this.state.purchaseOrderReceiptData.lines === null)
      return receiptLine;
    else {
      this.state.purchaseOrderReceiptData.lines.map((line) => {
        if (line.lineNumber === lineNumber) {
          receiptLine = line;
          return receiptLine;
        }
      });
    }
    return receiptLine;
  };
  onLineChange = (e) => {
    let temp_addressBean = this.state.purchaseOrderReceiptLineData;
    if (temp_addressBean == null || temp_addressBean == "undefined") {
      temp_addressBean = new AddressBean();
    }
    temp_addressBean[e.target.name] = e.target.value;

    this.setState({ purchaseOrderReceiptLineData: temp_addressBean });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
    this.closePoIntransitModalCallBack(false);
  };
  lnkPOModule = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let code = purchaseOrderReceiptData.purchaseOrderNumber;
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderModule: true,
        moduleForPopup: (
          <PopupPurchaseOrderModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  lnkPOIntransitModule = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let code = purchaseOrderReceiptData.purchaseOrderInTransitNumber;
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderInTransitModule: true,
        moduleForPopup: (
          <PopupPurchaseInTransitModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  closePoIntransitModalCallBack = (isOpen) => {
    this.setState({
      isShowPurchaseOrderInTransitModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowPurchaseOrderModule: isOpen,
      isShowfabricAndCustomerSalesDetails: isOpen,
      moduleForPopup: [],
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
    });
  };
  showLinePopup = () => {
    this.setState({ isShowLinePopup: true });
  };
  closeLinePopup = () => {
    this.setState({ isShowLinePopup: false });
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  rollLineLocationOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteRolllineLocationLists = true;
    let tempCriteria = this.state.purchaseOrderReceiptRollLineData;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteRolllineLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteRolllineLocationList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteRolllineLocationList;
      let tempCriteria = this.state.purchaseOrderReceiptRollLineData;
      tempCriteria.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptRollLineData: tempCriteria,
        rollLineLocationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readRollLineLocationBySearchString(e.target.value);
    }
    this.readRollLineLocation(locationCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptRollLineData: tempCriteria });
  };
  rollLineLocationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readRollLineLocation(locationCode);
    this.state.isShowAutoCompleteRolllineLocationList = false;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteRolllineLocationList;
    this.setState({
      rollLineLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayRollLineLocationAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteRolllineLocationList: isShowAutoCompleteList,
    });
  };
  readRollLineLocation = (locationCode) => {
    let tempCriteria = this.state.purchaseOrderReceiptRollLineData;
    let locationBean = null;
    let locationData = null;
    this.state.wareHouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempCriteria.locationCode = locationBean.code;
      this.state.isShowAutoCompleteRolllineLocationList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteRolllineLocationList;
      this.setState({
        purchaseOrderReceiptRollLineData: tempCriteria,
        isShowAutoCompleteRolllineLocationList: showAutoCompleteList,
      });
    }
  };
  readRollLineLocationBySearchString = (searchString) => {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((location) => {
        let locationBean = {
          code: location.code,
          description: location.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      rollLineLocationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteLocationList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readLocationBySearchString(e.target.value);
    }
    this.readLocation(locationCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.state.isShowAutoCompleteLocationList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayLocationAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLocationList: isShowAutoCompleteList,
    });
  };
  readLocation = (locationCode) => {
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let locationBean = null;
    let locationData = null;
    this.state.wareHouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempCriteria.locationCode = locationBean.code;
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      this.setState({
        purchaseOrderReceiptData: tempCriteria,
        isShowAutoCompleteLocationList: showAutoCompleteList,
      });
    }
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((location) => {
        let locationBean = {
          code: location.code,
          description: location.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  fobCityOnChange = (e) => {
    let fOBCity = e.target.value;
    this.state.isShowAutoCompleteFobCityList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
    if (isEmpty(fOBCity)) {
      this.state.isShowAutoCompleteFobCityList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.fOBCity = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        FobCityPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fOBCity" &&
      showAutoCompleteList === true &&
      fOBCity !== ""
    ) {
      this.readFobCityBySearchString(e.target.value);
    }
    this.readFobCity(fOBCity);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };

  fobCityEnterKeyEventHandler = (e) => {
    let fOBCity = e.target.value;
    this.readFobCity(fOBCity);
    this.state.isShowAutoCompleteFobCityList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
    this.setState({
      FobCityPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayFobCityAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteFobCityList: isShowAutoCompleteList,
    });
  };
  readFobCity = (fOBCity) => {
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let fobCityBean = null;
    let fobCityData = null;
    this.state.fOBCities.map((ln) => {
      if (ln.code === fOBCity) {
        fobCityBean = ln;
        fobCityData = new BaseBean();
        fobCityData.code = ln.code;
        fobCityData.description = ln.description;
      }
    });
    if (!isEmpty(fobCityBean)) {
      tempCriteria.fOBCity = fobCityBean.code;
      this.state.isShowAutoCompleteFobCityList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
      this.setState({
        purchaseOrderReceiptData: tempCriteria,
        isShowAutoCompleteFobCityList: showAutoCompleteList,
      });
    }
  };
  readFobCityBySearchString = (searchString) => {
    let fobCityData = this.state.fOBCities;
    let simpleAutoCompleteList = new Array();
    if (fobCityData.length > 0 && fobCityData != null) {
      fobCityData.map((fobCity) => {
        let fobCityBean = {
          code: fobCity.code,
          description: fobCity.description,
        };
        simpleAutoCompleteList.push(fobCityBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      FobCityPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  shipmentTermOnChange = (e) => {
    let shipmentTermsCode = e.target.value;
    this.state.isShowAutoCompleteShipmentTermList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
    if (isEmpty(shipmentTermsCode)) {
      this.state.isShowAutoCompleteShipmentTermList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.shipmentTermsCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        shipmentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "shipmentTermsCode" &&
      showAutoCompleteList === true &&
      shipmentTermsCode !== ""
    ) {
      this.readShipmentTermBySearchString(e.target.value);
    }
    this.readShipmentTerm(shipmentTermsCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };

  shipmentTermEnterKeyEventHandler = (e) => {
    let shipmentTermsCode = e.target.value;
    this.readShipmentTerm(shipmentTermsCode);
    this.state.isShowAutoCompleteShipmentTermList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
    this.setState({
      shipmentTermPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayShipmentTermAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteShipmentTermList: isShowAutoCompleteList,
    });
  };
  readShipmentTerm = (shipmentTermsCode) => {
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let shipmentTermBean = null;
    let shipmentTermData = null;
    this.state.shipmentTerms.map((ln) => {
      if (ln.code === shipmentTermsCode) {
        shipmentTermBean = ln;
        shipmentTermData = new BaseBean();
        shipmentTermData.code = ln.code;
        shipmentTermData.description = ln.description;
      }
    });
    if (!isEmpty(shipmentTermBean)) {
      tempCriteria.shipmentTermsCode = shipmentTermBean.code;
      this.state.isShowAutoCompleteShipmentTermList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
      this.setState({
        purchaseOrderReceiptData: tempCriteria,
        isShowAutoCompleteShipmentTermList: showAutoCompleteList,
      });
    }
  };
  readShipmentTermBySearchString = (searchString) => {
    let shipmentTermData = this.state.shipmentTerms;
    let simpleAutoCompleteList = new Array();
    if (shipmentTermData.length > 0 && shipmentTermData != null) {
      shipmentTermData.map((shipmentTerm) => {
        let shipmentTermBean = {
          code: shipmentTerm.code,
          description: shipmentTerm.description,
        };
        simpleAutoCompleteList.push(shipmentTermBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      shipmentTermPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  shipViaOnChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.isShowAutoCompleteShipViaList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
    if (isEmpty(shipViaCode)) {
      this.state.isShowAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.shipViaCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "shipViaCode" &&
      showAutoCompleteList === true &&
      shipViaCode !== ""
    ) {
      this.readShipViaBySearchString(e.target.value);
    }
    this.readShipVia(shipViaCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };
  shipViaEnterKeyEventHandler = (e) => {
    let shipViaCode = e.target.value;
    this.readShipVia(shipViaCode);
    this.state.isShowAutoCompleteShipViaList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
    this.setState({
      shipViaPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayShipViaAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteShipViaList: isShowAutoCompleteList,
    });
  };
  readShipVia = (shipViaCode) => {
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let shipViaBean = null;
    let shipViaData = null;
    this.state.shipVias.map((ln) => {
      if (ln.code === shipViaCode) {
        shipViaBean = ln;
        shipViaData = new BaseBean();
        shipViaData.code = ln.code;
        shipViaData.description = ln.description;
      }
    });
    if (!isEmpty(shipViaBean)) {
      tempCriteria.shipViaCode = shipViaBean.code;
      this.state.isShowAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
      this.setState({
        purchaseOrderReceiptData: tempCriteria,
        isShowAutoCompleteShipViaList: showAutoCompleteList,
      });
    }
  };
  readShipViaBySearchString = (searchString) => {
    let shipViaData = this.state.shipVias;
    let simpleAutoCompleteList = new Array();
    if (shipViaData.length > 0 && shipViaData != null) {
      shipViaData.map((shipVia) => {
        let shipViaBean = {
          code: shipVia.code,
          description: shipVia.description,
        };
        simpleAutoCompleteList.push(shipViaBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      shipViaPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  poIntransitOnChange = (e) => {
    let purchaseOrderInTransitNumber = e.target.value;
    this.state.isShowAutoCompletePoIntransitList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompletePoIntransitList;
    if (isEmpty(purchaseOrderInTransitNumber)) {
      this.state.isShowAutoCompletePoIntransitList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePoIntransitList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.purchaseOrderInTransitNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        poIntransitPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderInTransitNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderInTransitNumber !== ""
    ) {
      this.readPOIntransitBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };
  poIntransitEnterKeyEventHandler = (e) => {
    let purchaseOrderInTransitNumber = e.target.value;
    this.readPurchaseInTransit(purchaseOrderInTransitNumber);
    this.state.isShowAutoCompletePoIntransitList = false;
    let showAutoCompleteList = this.state.isShowAutoCompletePoIntransitList;
    this.setState({
      poIntransitPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayPOIntransitAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePoIntransitList: isShowAutoCompleteList,
    });
  };

  loadPaymentdetail = () => {
    let PaymentCriteria = new VendorInvoicePaymentSearchCriteria();

    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;

    PaymentCriteria.companyCode = this.companyCode;
    PaymentCriteria.purchaseOrderReceiptNumber = purchaseOrderReceiptData.code;
    PaymentCriteria.purchaseOrderNumber =
      purchaseOrderReceiptData.purchaseOrderNumber;
    PaymentCriteria.vendorCode = purchaseOrderReceiptData.vendorCode;
    let inputRequest = new RestVendorInvoicePaymentListRequest();
    inputRequest.searchCriteria = PaymentCriteria;
    let pageList = new PageListBean();
    inputRequest.pageInput = pageList;
    this.getPaymentLines(inputRequest);
  };
  getPaymentLines = (inputRequest) => {
    AccountPayableService.getVendorInvoicePaymentDetailsList(
      inputRequest,
      this.getPaymentDetailsPageResponse,
      this.errorCallBack,
    );
  };
  getPaymentDetailsPageResponse = (response) => {
    if (
      response.data != null &&
      response.data.vendorInvoicePaymentDetailPageList != null &&
      response.data.vendorInvoicePaymentDetailPageList
        .vednorInvoicePaymentDetails != null
    ) {
      let PurchasePaymentDetalis =
        response.data.vendorInvoicePaymentDetailPageList
          .vednorInvoicePaymentDetails;

      let PurchasePayment = PurchasePaymentDetalis.map((ln) => {
        // let AmountDue =new Array();
        let AmountDue = ln.approvedAmount - ln.paymentAmount;

        return {
          ...ln,
          AmountDue,
        };
      });

      this.setState({
        purchasePaymentDetailList: PurchasePayment,
      });
    }
  };

  getHeaderView() {
    return (
      <PurchaseOrderReceiptForm
        {...this.state}
        back={this.back}
        save={this.save}
        clearError={this.clearError}
        savePurchaseOrderReceipt={this.savePurchaseOrderReceipt}
        onChange={this.onChange}
        onPurchaseOrderChange={this.onPurchaseOrderChange}
        purchaseOrderEnterKeyEventHandler={
          this.purchaseOrderEnterKeyEventHandler
        }
        displayAutoCompletePurchaseOrderList={
          this.displayAutoCompletePurchaseOrderList
        }
        onDateChange={this.onDateChange}
        onVendorCodeChange={this.onVendorCodeChange}
        editPurchaseOrderReceiptLine={this.editPurchaseOrderReceiptLine}
        editPurchaseOrderReceiptRollLine={this.editPurchaseOrderReceiptRollLine}
        onPurchaseOrderReceiptLineChange={this.onPurchaseOrderReceiptLineChange}
        onPurchaseOrderReceiptRollLineChange={
          this.onPurchaseOrderReceiptRollLineChange
        }
        addOrUpdatePurchaseOrderReceiptRollLine={
          this.addOrUpdatePurchaseOrderReceiptRollLine
        }
        addOrUpdatePurchaseOrderReceiptLine={
          this.addOrUpdatePurchaseOrderReceiptLine
        }
        addNewRollLine={this.addNewRollLine}
        getPurchaseOrderLinesDatasFromExcel={
          this.getPurchaseOrderLinesDatasFromExcel
        }
        uploadExcelFile={this.uploadExcelFile}
        cancelPurchaseReceiptLine={this.cancelPurchaseReceiptLine}
        closePoReceiptLinePopup={this.closePoReceiptLinePopup}
        displayCancelErrorMsg={this.displayCancelErrorMsg}
        readPurchaseOrder={this.readPurchaseOrder}
        loadReceiptLines={this.loadReceiptLines}
        alertMsgList={this.state.alertMessage}
        alertErrorType={this.state.alertType}
        isShowAlert={this.state.isShowAlert}
        hideAlertCallBack={this.hideAlertCallBack}
        closeRollLineCallBack={this.closeRollLineCallBack}
        deleteReceiptRollLine={this.deleteReceiptRollLine}
        openLinePopup={this.openLinePopup}
        closeAlertModalCallBack={this.closeAlertModalCallBack}
        hidePopupAlertCallBack={this.hidePopupAlertCallBack}
        hideAlertCallBacklvl1={this.hideAlertCallBacklvl1}
        hideAlertCallBacklvl5={this.hideAlertCallBacklvl5}
        onLineChange={this.onLineChange}
        lnkPOModule={this.lnkPOModule}
        lnkPOIntransitModule={this.lnkPOIntransitModule}
        closePoIntransitModalCallBack={this.closePoIntransitModalCallBack}
        closeModalCallBack={this.closeModalCallBack}
        showLinePopup={this.showLinePopup}
        closeLinePopup={this.closeLinePopup}
        rollLineLocationOnChange={this.rollLineLocationOnChange}
        rollLineLocationEnterKeyEventHandler={
          this.rollLineLocationEnterKeyEventHandler
        }
        displayRollLineLocationAutoCompleteList={
          this.displayRollLineLocationAutoCompleteList
        }
        wareHouses={this.state.wareHouses}
        locationOnChange={this.locationOnChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        displayLocationAutoCompleteList={this.displayLocationAutoCompleteList}
        fobCityOnChange={this.fobCityOnChange}
        fobCityEnterKeyEventHandler={this.fobCityEnterKeyEventHandler}
        displayFobCityAutoCompleteList={this.displayFobCityAutoCompleteList}
        shipmentTermOnChange={this.shipmentTermOnChange}
        shipmentTermEnterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
        displayShipmentTermAutoCompleteList={
          this.displayShipmentTermAutoCompleteList
        }
        shipViaOnChange={this.shipViaOnChange}
        shipViaEnterKeyEventHandler={this.shipViaEnterKeyEventHandler}
        displayShipViaAutoCompleteList={this.displayShipViaAutoCompleteList}
        poIntransitOnChange={this.poIntransitOnChange}
        poIntransitEnterKeyEventHandler={this.poIntransitEnterKeyEventHandler}
        displayPOIntransitAutoCompleteList={
          this.displayPOIntransitAutoCompleteList
        }
        poReceiptRollLinesList={this.state.poReceiptRollLinesList}
        clearRollLineDetails={this.clearRollLineDetails}
        onFilterChange={this.onFilterChange}
        filterRollLinenClick={this.filterRollLinenClick}
        resetIntansitRollLines={this.resetIntansitRollLines}
        filterPurchaseList={this.state.filterPurchaseList}
        isSearchCriteria={this.state.isSearchCriteria}
        isResetCriteria={this.state.isResetCriteria}
        isShowFilterList={this.state.isShowFilterList}
        openFabricAndCustomerDetailsInq={this.openFabricAndCustomerDetailsInq}
        openFabricPurchaseDetails={this.openFabricPurchaseDetails}
        multiAddPurchaseOrderReceiptRollLine={
          this.multiAddPurchaseOrderReceiptRollLine
        }
        // toGenerateRollLinesFromExcelInputBean={
        //   this.toGenerateRollLinesFromExcelInputBean
        // }
        // overallExcelOnClick={this.overallExcelOnClick}
        uploadOverallExcelFile={this.uploadOverallExcelFile}
        resetExcelUploadView={this.resetExcelUploadView}
        isVendorInvoiceShow={this.state.isVendorInvoiceShow}
      />
    );
  }
  getPurchaseReceiptHistory() {
    return (
      <PurchaseOrderReceiptHistoryDetailsForm
        {...this.state}
        purchaseOrderReceiptData={this.state.purchaseOrderReceiptData}
      />
    );
  }

  getPurchaseReceiptApproveReceiptLines() {
    return (
      <PurchaseOrderReceiptApproveReceiptLinesForm
        {...this.state}
        // purchaseOrderReceiptData1={this.state.purchaseOrderReceiptData1}
        // purchaseOrderReceiptApproval={this.state.purchaseOrderReceiptApproval}
        // purchaseOrderReceiptData2={this.state.purchaseOrderReceiptData2}
        // isDisabledFields={this.state.isDisabledFields}
        addReceiptLines={this.addReceiptLines}
        // addOrUpdateMultipleColor={this.addOrUpdateMultipleColor}
        closeAlertReceiptApprovalModalCallBack={
          this.closeAlertReceiptApprovalModalCallBack
        }
        // selectColor={this.selectColor}
        // unSelectColor={this.unSelectColor}
        purchaseOrderReceiptApprovalList={
          this.state.purchaseOrderReceiptApprovalList
        }
        onSelectedApprovalLines={this.onSelectedApprovalLines}
        poReceiptApprovalOnChange={this.poReceiptApprovalOnChange}
        createApprovalLines={this.createApprovalLines}
        hideAlertCallBackApproval={this.hideAlertCallBackApproval}
        getApprovalPageList={this.getApprovalPageList}
        selectAllList={this.selectAllList}
        unSelectAllList={this.unSelectAllList}
        viewApprovedDetails={this.viewApprovedDetails}
        aprovalonChange={this.aprovalonChange}
      />
    );
  }
  getPurchaseReceiptPaymentDetailLines() {
    this.loadPaymentdetail();
    return (
      <PurchaseOrderReceiptPayamentDetailForm
        {...this.state}
        loadPaymentdetail={this.loadPaymentdetail}
        purchasePaymentDetailList={this.state.purchasePaymentDetailList}
      />
    );
  }
  //Document And Image
  //-----------------------------------*************************************-------------------------------
  // getImageFormView = () => {
  //   return (
  //     <div>Hi</div>
  //     // <Images
  //     //   {...this.state}
  //     //   // setImgUrl={this.setImgUrl}
  //     //   // setImgData={this.setImgData}
  //     //   // uploadImage={this.uploadImage}
  //     //   // uploadDoc={this.uploadDoc}
  //     //   // deleteImage={this.deleteImage}
  //     //   // deleteDoc={this.deleteDoc}
  //     //   showToast={this.showToast}
  //     //   setMultiImageUrl={this.setMultiImageUrl}
  //     //   setMultiImgData={this.setMultiImgData}
  //     //   uploadMutiImage={this.uploadMutiImage}
  //     //   deleteMutipleImage={this.deleteMutipleImage}
  //     //   addImageLines={this.addImageLines}
  //     //   clearImageLines={this.clearImageLines}
  //     // />
  //   );
  // };

  getDocumentFormView = () => {
    return (
      <div>
        <MutilpleDocuments
          {...this.state}
          purchaseOrderReceiptData={this.state.purchaseOrderReceiptData}
          documents={this.state.documents}
          // onChange={this.onChange}
          showToast={this.showToast}
          uploadMutiDouments={this.uploadMutiDouments}
          uploadMutiDoumentsUrl={this.uploadMutiDoumentsUrl}
          deleteMultiDocument={this.deleteMultiDocument}
        />
      </div>
    );
  };
  getImageFormView() {
    return (
      <ImageForm
        {...this.state}
        purchaseOrderReceiptData={this.state.purchaseOrderReceiptData}
        showToast={this.showToast}
        setMultiImageUrl={this.setMultiImageUrl}
        setMultiImgData={this.setMultiImgData}
        uploadMutiImage={this.uploadMutiImage}
        deleteMutipleImage={this.deleteMutipleImage}
        addImageLines={this.addImageLines}
        clearImageLines={this.clearImageLines}
      />
    );
  }
  setMultiImageUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Url: url,
      });
    }, 300);
  };
  setMultiImgData = (data) => {
    // this.setState({

    setTimeout(() => {
      this.setState({
        images: data,
      });
    }, 400);
    //   images: data,
    // });
  };
  uploadMutiImage = (images) => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let receiptImages = new Array();
    let imageData = null;
    for (const img of images) {
      if (!img.isFetched && !img.isDeleted) {
        imageData = new PurchaseOrderReceiptImageBean();
        // imageData.imagePart = imagePart;
        if (!isEmpty(img.imageCode)) {
          imageData.imageCode = img.imageCode;
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
          imageData.isFetched = true;
          imageData.isApplied = true;
        } else {
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
        }
        imageData.companyCode = this.companyCode;
        imageData.pickTicketNumber = purchaseOrderReceiptData.code;
        receiptImages.push(imageData);
      } else {
        if (img.isFetched == true) {
          receiptImages.push(img);
        }
      }
    }
    purchaseOrderReceiptData.receiptImages = receiptImages;

    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
      images: images,
    });
  };
  deleteMutipleImage = (tempIndex) => {
    let orderImages = this.state.purchaseOrderReceiptData.receiptImages;
    if (!isEmptyArray(orderImages)) {
      for (let j = 0; j < orderImages.length; j++) {
        if (j === tempIndex) {
          if (orderImages[j].isFetched == true) {
            orderImages[j].deleted = true; // Change the value at index 2
            orderImages[j].isDeleted = true;
          } else {
            orderImages.splice(j, 1); // Change the value at index 2
            this.state.images.splice(j, 1);
          }
        }
      }
    }
    this.state.purchaseOrderReceiptData.receiptImages = orderImages;
  };
  addImageLines = (imageEntity) => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    purchaseOrderReceiptData.receiptImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = imageEntity.tags;
        det.notesCommunication = imageEntity.notesCommunication;
      }
    });
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
    });
  };
  // clearImageLines
  clearImageLines = (imageEntity) => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    purchaseOrderReceiptData.receiptImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = "";
        det.notesCommunication = "";
      }
    });
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
    });
  };
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadMutiDouments = (docs) => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let documents = new Array();
    let docmentData = null;
    for (const doc of docs) {
      if (!doc.isFetched) {
        docmentData = new PurchaseOrderReceiptDocumentBean();
        docmentData.documentOriginalName = doc.name;
        docmentData.documentName = doc.name;
        docmentData.companyCode = this.companyCode;
        docmentData.purchaseOrderReceiptNumber = purchaseOrderReceiptData.code;
        docmentData.documentPath = DOCUMENT_CHANGED;
        documents.push(docmentData);
      } else {
        documents.push(doc);
      }
    }
    purchaseOrderReceiptData.receiptDocuments = documents;
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
      documents: docs,
    });
  };
  uploadMutiDoumentsUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Docs: url,
      });
    }, 400);
  };

  deleteMultiDocument = (rowData) => {
    let docs = this.state.purchaseOrderReceiptData.receiptDocuments;
    if (!isEmptyArray(docs)) {
      for (let j = 0; j < docs.length; j++) {
        if (docs[j].documentName === rowData.documentName) {
          if (docs[j].isFetched == true) {
            docs[j].deleted = true; // Change the value at index 2
            docs[j].isDeleted = true;
          } else {
            docs.splice(j, 1); // Change the value at index 2
            this.state.documents.splice(j, 1);
          }
        }
      }
    }
    this.state.purchaseOrderReceiptData.receiptDocuments = docs;
  };

  openFabricAndCustomerDetailsInq = (e, code) => {
    let vendorCode = this.state.purchaseOrderReceiptData.vendorCode;
    if (e.detail == 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowfabricAndCustomerSalesDetails: true,
          moduleForPopup: (
            <PopupPurchaseAndSlesDetailsInq
              fabricStyleCode={code}
              vendorCode={vendorCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openFabricPurchaseDetails = (e, row) => {
    let tempData = { ...row };
    this.getSkuDetails(row);
    this.getPurchaseDetails(row);

    this.setState({
      isShowPurchaseHistoryPopup: true,
      purchaseOrderReceiptLineData: tempData,
    });
  };
  getSkuDetails = (row) => {
    let skuCriteria = new SKUBatchInventorySearchCriteria();
    skuCriteria.companyCode = this.companyCode;
    skuCriteria.fabricStyleCode = row.fabricStyleCode;
    skuCriteria.colorCode = row.colorCode;
    skuCriteria.purchaseReceitpNumber = row.purchaseOrderReceiptNumber;
    // qtyCriteria.totalOnHandQuantity = rowData.totalOnHandQuantity;
    // qtyCriteria.uomCode = rowData.uomCode;
    let pageInput = new RestPageListBean();
    // pageInput.pageSize = 20;
    // pageInput.currentPage = 1;
    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.pageInput = pageInput;
    listRequest.searchCriteria = skuCriteria;
    // if (
    //   SecurityAccessManager.PurchaseOrderReceiptMaintenanceView_IsAccessible()
    // ) {
    InventoryService.getSkuBatchInventoryPageList(
      listRequest,
      this.loadPurchaseSkuHistoryResponse,
      this.errorCallBack,
    );
    // } else {
    //   let errMsg = "Access Denied";
    //   let errList = [];
    //   errList.push(errMsg);

    //   this.setState({
    //     alertMessage: errList,
    //     alertType: "danger",
    //     isShowAlert: true,
    //   });
    // }
  };

  loadPurchaseSkuHistoryResponse = (response) => {
    let listDatas = [];
    let totalOnHandQty = 0;
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories,
        )
      ) {
        listDatas = response.data.skuBatchInventoryPageList.skuBatchInventories;

        totalOnHandQty = listDatas.reduce((acc, curr) => {
          return acc + curr.onHandQuantity || 0;
        }, 0);
        this.setState({
          purchaseSkuHistory: listDatas,
          totalOnHandQty: totalOnHandQty,
        });
      }
    }
  };
  getPurchaseDetails = (row) => {
    let purchaseHistory = new FabricStylePurchaseReceiptHistoryCriteriaBean();
    purchaseHistory.companyCode = this.companyCode;
    purchaseHistory.fabricStyleCode = row.fabricStyleCode;
    purchaseHistory.fabricStyleColorCode = row.colorCode;
    purchaseHistory.purchaseOrderReceiptNumber = row.purchaseOrderReceiptNumber;

    ReportService.getFabricStylePurchaseReceiptHistoryInfos(
      purchaseHistory,
      this.loadPurchaseHistoryResponse,
      this.errorCallBack,
    );
  };
  loadPurchaseHistoryResponse = (response) => {
    let listDatas = [];
    let totalShippedQty = 0;
    if (response.data != null && response.data.inquiryResult != null) {
      if (!isEmptyArray(response.data.inquiryResult.infos)) {
        listDatas = response.data.inquiryResult.infos;
        totalShippedQty = listDatas.reduce((acc, curr) => {
          return acc + curr.shippedQuantity || 0;
        }, 0);
        this.setState({
          purchaseFabricHistory: listDatas,
          totalShippedQty: totalShippedQty,
        });
      }
    }
  };

  purchaseSkuColumns = () => {
    const columns = new Array();
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyle", "fabricStyleCode", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Name", "fabricStyleName", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Color", "fabricStyleColorCode", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RollSku", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Po#", "purchaseOrderNumber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("PR#", "purchaseOrderReceiptNumber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );

    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    return columns;
  };
  purchaseHistoryColumns = () => {
    const columns = new Array();
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("FabricStyle", "fabricStyleCode", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Name", "fabricStyleName", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Color", "colorCode", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewCustomerModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RollSku", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "lotNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Po#", "purchaseOrderNumber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("PR#", "purchaseOrderReceiptNumber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );

    columns.push(
      new ColumnDefinition()
        .setDetails("ShippedQty", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );

    return columns;
  };

  //-----------------------------------*************************************-------------------------------
  getModuleListView = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    if (purchaseOrderReceiptData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadPurchaseOrderReceiptPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockPurchaseOrderReceipt(purchaseOrderReceiptData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadPurchaseOrderReceiptPage();
    }
  };
  resetView = () => {
    let purchaseReceiptData = this.state.purchaseOrderReceiptData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.code = null;
      this.unlockPurchaseOrderReceipt(purchaseReceiptData.code);
    } else {
      this.isLocked = false;
    }
    let purchaseOrderReceiptData = new PurchaseOrderReceiptBean();
    let purchaseOrderReceiptApproval =
      new PurchaseOrderReceiptApprovalResponseBean();
    let purchaseOrderReceiptData2 = new Array();
    let purchaseOrderReceiptData1 = new Array();
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
      purchaseOrderReceiptData1: purchaseOrderReceiptData1,
      purchaseOrderReceiptData2: purchaseOrderReceiptData2,
      purchaseOrderReceiptApproval: purchaseOrderReceiptApproval,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isFocus: false,
      isFocusLookup: true,
      isShowPORButton: true,
      isDisablePoIntransit: false,
      selectedNodeKey: "headerView",
      purchaseOrderReceiptApprovalList: [],
      purchaseOrderReceiptApproval: new PurchaseOrderReceiptApprovalBean(),
      receiptApprovalList: [],

      isShowPurchaseHistoryPopup: false,
      purchaseSkuHistory: [],
      purchaseFabricHistory: [],
      totalOnHandQty: 0,
      totalShippedQty: 0,
      selectedDocument: "",
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editPurchaseOrderReceipt(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  getCriteriaString = () => {
    let criteriaString = "";
    let moduleCaption = this.moduleCaption;
    if (this.state.criteria == null) {
      return <div />;
    } else {
      if (!isEmptyString(this.state.criteria.purchaseOrderReceiptNumber))
        criteriaString =
          criteriaString +
          moduleCaption +
          "PR# : " +
          this.state.criteria.purchaseOrderReceiptNumber +
          " ; ";
      if (
        !isEmptyString(this.state.criteria.purchaseOrderReceiptNumberStartsWith)
      )
        criteriaString =
          criteriaString +
          moduleCaption +
          "purchaseOrderReceiptNumberStartsWith : " +
          this.state.criteria.purchaseOrderReceiptNumberStartsWith +
          " ; ";
      if (
        !isEmptyString(this.state.criteria.purchaseOrderReceiptNumberContains)
      )
        criteriaString =
          criteriaString +
          moduleCaption +
          "purchaseOrderReceiptNumberContains: " +
          this.state.criteria.purchaseOrderReceiptNumberContains +
          " ; ";

      if (!isEmptyString(this.state.criteria.vendorCode))
        criteriaString =
          criteriaString +
          "vendorCode : " +
          this.state.criteria.vendorCode +
          " ; ";
      if (!isEmptyString(this.state.criteria.vendorName))
        criteriaString =
          criteriaString +
          "vendorName : " +
          this.state.criteria.vendorName +
          " ; ";
    }
    return <div>{criteriaString}</div>;
  };
  moduleExit = () => {
    let purchaseReceiptData = this.state.purchaseOrderReceiptData;
    if (purchaseReceiptData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockPurchaseOrderReceipt(purchaseReceiptData.code);
      } else {
        this.isLocked = false;
      }
      this.props.onModuleExit();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  hideAlertCallBacklvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl1: isDisplayed });
  };
  hideAlertCallBacklvl2 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl2: isDisplayed });
  };
  hideAlertCallBacklvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl5: isDisplayed });
  };
  generateExcel = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Generating Excel",
      });
      this.downloadReport(2, this.state.purchaseOrderReceiptData.code);
    }
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF",
    });
    this.downloadReport(1, this.state.purchaseOrderReceiptData.code);
  };
  downloadReportResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  downloadReportError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  downloadReport = (reportType, code) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let requestInput = new PurchaseOrderReceiptPrintRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.purchaseOrderReceiptNumber = code;
    requestInput.input = reportBean;
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.PurchaseOrderReceiptMaintenancePDFReport_IsAccessible()
      ) {
        ReportService.generatePurchaseOrderReceiptPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.downloadReportError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.PurchaseOrderReceiptMaintenanceExcelReport_IsAccessible()
      ) {
        ReportService.generatePurchaseOrderReceiptPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.downloadReportError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  closeAlertProgressBarModalCallBack = (isShowPopup) => {
    this.setState({
      isShowProgressBarPopup: isShowPopup,
    });
  };
  displayCancelErrorMsg = () => {
    let errList = [];
    let errmsg = "Already Existing Line";
    errList.push(errmsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
    });
  };
  loadReceiptLines = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    purchaseOrderReceiptData.lines = [];
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
    });
    if (!isEmptyString(purchaseOrderReceiptData.purchaseOrderNumber)) {
      this.readPurchaseOrder(purchaseOrderReceiptData.purchaseOrderNumber);
    }
  };
  closeRollLineCallBack = (closeRollLineCallBack) => {
    this.setState({
      isDisableRollLine: false,
      disableFormFields: false,
      isShowLinePopup: false,
    });
  };
  /********** New 16/8/22 *********/
  openLinePopup = () => {
    let purchaseOrderRollLineBeanFilter =
      new PurchaseOrderReceiptRollLineBeanFilter();
    let tempArray = [];
    this.setState({
      isShowPopup: true,
      purchaseOrderRollLineBeanFilter: purchaseOrderRollLineBeanFilter,
      filterPurchaseList: tempArray,
      isSearchCriteria: false,
      isResetCriteria: true,
      isShowFilterList: false,
    });
  };
  hidePopupAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowPopupAlert: isDisplayed,
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.state.poReceiptRollLinesList = [];
    this.setReceiptDataValues();
    this.setState({
      isShowPopup: isShowPopup,
      isShowPopupAlert: isShowPopup,
      isShowPopupAlertlvl1: isShowPopup,
      isShowPopupAlertlvl5: isShowPopup,
    });
    //  this.resetIntansitRollLines(e);
  };
  closeAlertModalCallBacklvl2 = (isShowPopup) => {
    this.setState({
      invoiceServiceLineList: [],
      isShowCreateInvoicePopup: isShowPopup,
      isShowPopupAlertlvl2: isShowPopup,
      isShowPurchaseHistoryPopup: isShowPopup,
      //  purchaseOrderReceiptLineData: null,
    });
  };
  setReceiptDataValues = () => {
    let receiptLineData = this.state.purchaseOrderReceiptLineData;
    let receivedQty = 0;
    receiptLineData.receiptRollLines.map((ln) => {
      receivedQty += parseFloat(ln.receivedQuantity);
    });
    receiptLineData.receivedQuantity = receivedQty.toFixed(2);
    receiptLineData.totalRolls = receiptLineData.receiptRollLines.length;
    this.setState({
      purchaseOrderReceiptLineData: receiptLineData,
    });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let purchaseOrderReceiptList = this.state.purchaseOrderReceiptListData;
    if (sortField && !isEmptyArray(purchaseOrderReceiptList)) {
      const sorted = [...purchaseOrderReceiptList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ purchaseOrderReceiptListData: sorted });
    }
  };
  createInvoiceError = (error) => {
    ShowError("Error : " + error);
  };
  clearRollLineDetails = () => {
    let rollData = new PurchaseOrderReceiptRollLineBean();
    this.setState({ purchaseOrderReceiptRollLineData: rollData });
    this.addNewRollLine();
  };
  openCreateInvoicePopup = (e) => {
    if (e.detail == 1) this.setState({ isShowCreateInvoicePopup: true });
  };
  createInvoiceResponse = (response) => {
    if (response.data != null && response.data.invoice != null) {
      this.handleResponse(response.data);
    }
  };
  createInvoiceFromPO = (e) => {
    if (e.detail == 1) {
      let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
      let serviceLines = this.state.invoiceServiceLineList;
      let request = new PurchaseReceiptToInvoiceInputBean();
      request.purchaseReceipts = purchaseOrderReceiptData;
      request.serviceLines = serviceLines;
      if (
        SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()
      ) {
        PurchaseOrderReceiptService.createInvoiceFromPurchaseOrderReceipt(
          request,
          this.createInvoiceResponse,
          this.createInvoiceError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
      this.closeAlertModalCallBacklvl2(false);
    }
  };
  getLineNumber = () => {
    let maxLineNumber = 0;
    let invoiceServiceLineList = this.state.invoiceServiceLineList;
    if (!isEmptyArray(invoiceServiceLineList)) {
      invoiceServiceLineList.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.serviceCode)) {
        let errMsg = "ServiceCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.amount)) {
        let errMsg = "Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.uomCode)) {
        let errMsg = "UomCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.unitPrice)) {
        let errMsg = "Price is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.quantity)) {
        let errMsg = "Qty is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlertlvl2: true,
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  addLines = (e) => {
    if (e.detail == 1) {
      let invoiceServiceLineList = this.state.invoiceServiceLineList;
      let invoiceServiceLineData = this.state.invoiceServiceLineData;
      invoiceServiceLineData.companyCode = this.companyCode;
      // invoiceServiceLineData.companyCode = "3PL";
      let isValid = false;
      isValid = this.validate(invoiceServiceLineData);

      if (isValid) {
        var lineNumber = this.getLineNumber();
        let isLineFound = false;
        if (!isEmptyArray(invoiceServiceLineList)) {
          invoiceServiceLineList.map((ln, i) => {
            if (ln.lineNumber == invoiceServiceLineData.lineNumber) {
              invoiceServiceLineData.isFetched = ln.isFetched;
              invoiceServiceLineList[i] = invoiceServiceLineData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          invoiceServiceLineData.lineNumber = ++lineNumber;
          invoiceServiceLineList.push(invoiceServiceLineData);
        }
        this.setState({
          invoiceServiceLineList: invoiceServiceLineList,
        });
        this.clearLines(e);
      }
    }
  };
  clearLines = (e) => {
    if (e.detail == 1) {
      let invoiceServiceLineData = new InvoiceServiceLineBean();
      this.setState({ invoiceServiceLineData: invoiceServiceLineData });
    }
  };
  reArrangeLines = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  deleteService = (e, rowData) => {
    if (e.detail == 1) {
      let invoiceServiceLineList = this.state.invoiceServiceLineList;
      var index = invoiceServiceLineList.indexOf(rowData);
      if (index > -1) {
        invoiceServiceLineList.splice(index, 1);
        this.reArrangeLines(invoiceServiceLineList);
        this.setState({ invoiceServiceLineList: invoiceServiceLineList });
      }
    }
  };
  editService = (e, data, rowData) => {
    if (e.detail == 1) {
      let invoiceServiceLineData = new InvoiceServiceLineBean();
      let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
      invoiceServiceLineData = { ...rowData };
      invoiceServiceLineData.companyCode = purchaseOrderReceiptData.companyCode;
      this.setState({ invoiceServiceLineData: invoiceServiceLineData });
    }
  };
  serviceLineOnchange = (e) => {
    let invoiceServiceLineData = this.state.invoiceServiceLineData;
    invoiceServiceLineData[e.target.name] = e.target.value;
    if (e.target.name == "quantity") {
      invoiceServiceLineData.amount =
        invoiceServiceLineData.unitPrice * e.target.value;
    }
    this.setState({ invoiceServiceLineData: invoiceServiceLineData });
  };

  /******* Reason AutoComplete ****** */

  invoiceUomOnChange = (e) => {
    let uomCode = e.target.value;
    this.state.isShowAutoCompleteInvoiceUomList = true;
    let tempData = this.state.invoiceServiceLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
    if (isEmpty(uomCode)) {
      this.state.isShowAutoCompleteInvoiceUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
      let tempData = this.state.invoiceServiceLineData;
      tempData.uomCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteInvoiceUomList: showAutoCompleteList,
        invoiceServiceLineData: tempData,
        invoiceUomPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "uomCode" &&
      showAutoCompleteList === true &&
      uomCode !== ""
    ) {
      this.readInvoiceUomBySearchString(e.target.value);
      this.readInvoiceUom(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ serviceDetail: tempData });
  };
  invoiceUomEnterKeyEvent = (e) => {
    this.readInvoiceUom(e.target.value);
    this.state.isShowAutoCompleteInvoiceUomList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
    this.setState({
      invoiceUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteInvoiceUomList: showAutoCompleteList,
    });
  };
  displayInvoiceUomAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteInvoiceUomList: isShowAutoCompleteList,
    });
  };
  readInvoiceUomBySearchString = (searchString) => {
    let uomData = this.state.uoms;
    let simpleAutoCompleteList = new Array();
    if (uomData.length > 0 && uomData != null) {
      uomData.map((obj) => {
        let uomBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(uomBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      invoiceUomPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readInvoiceUom = (uomCode) => {
    let tempData = this.state.invoiceServiceLineData;
    let uomBean = null;
    let uomData = null;
    this.state.uoms.map((ln) => {
      if (ln.code === uomCode) {
        uomBean = ln;
        uomData = new BaseBean();
        uomData.code = ln.code;
        uomData.description = ln.description;
      }
    });
    if (!isEmpty(uomBean)) {
      tempData.uomCode = uomBean.code;
      this.state.isShowAutoCompleteInvoiceUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
      this.setState({
        serviceDetail: tempData,
        isShowAutoCompleteInvoiceUomList: showAutoCompleteList,
      });
    }
  };

  serviceOnChange = (e) => {
    let serviceCode = e.target.value;
    this.state.isShowAutoCompleteServiceList = true;
    let tempData = this.state.invoiceServiceLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    if (isEmpty(serviceCode)) {
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      let tempData = this.state.invoiceServiceLineData;
      tempData.serviceCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteServiceList: showAutoCompleteList,
        invoiceServiceLineData: tempData,
        servicePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "serviceCode" &&
      showAutoCompleteList === true &&
      serviceCode !== ""
    ) {
      this.readServiceBySearchString(e.target.value);
      this.readService(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ invoiceServiceLineData: tempData });
  };
  serviceEnterKeyEvent = (e) => {
    this.readService(e.target.value);
    this.state.isShowAutoCompleteServiceList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    this.setState({
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: showAutoCompleteList,
    });
  };
  displayServiceAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteServiceList: isShowAutoCompleteList,
    });
  };
  readServiceBySearchString = (searchString) => {
    let serviceData = this.state.services;
    let simpleAutoCompleteList = new Array();
    if (serviceData.length > 0 && serviceData != null) {
      serviceData.map((obj) => {
        let serivceBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(serivceBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      servicePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readService = (serviceCode) => {
    let tempData = this.state.invoiceServiceLineData;
    let serivceBean = null;
    let serviceData = null;
    this.state.services.map((ln) => {
      if (ln.code === serviceCode) {
        serivceBean = ln;
        serviceData = new BaseBean();
        serviceData.code = ln.code;
        serviceData.description = ln.description;
      }
    });
    if (!isEmpty(serivceBean)) {
      tempData.serviceCode = serivceBean.code;
      tempData.serviceName = serivceBean.description;
      tempData.uomCode = serivceBean.uomCode;
      tempData.unitPrice = serivceBean.price;
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      this.setState({
        invoiceServiceLineData: tempData,
        isShowAutoCompleteServiceList: showAutoCompleteList,
      });
    }
  };

  onFilterChange = (e) => {
    let criteria = this.state.purchaseOrderRollLineBeanFilter;
    criteria[e.target.name] = e.target.value;
    this.setState({ purchaseOrderRollLineBeanFilter: criteria });
  };
  criteriaAllocatedError = () => {
    let errMsg = "No Matching Data Found";
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowPopupAlert: true,
      isSearchCriteria: false,
      isResetCriteria: true,
    });
  };
  filterRollLinenClick = (e) => {
    if (e.detail === 1) {
      let rollLineList = [...this.state.poReceiptRollLinesList];
      let rollLineData = { ...this.state.purchaseOrderRollLineBeanFilter };
      let purchaseRollLines = [];
      purchaseRollLines = rollLineList;
      if (
        isEmptyString(rollLineData.vendorLotNumber) &&
        isEmptyString(rollLineData.rollNumber) &&
        rollLineData.receivedQuantity == 0
      ) {
        let errMsg = "Please Enter Filter Select Criteria";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowPopupAlert: true,
          isSearchCriteria: false,
          isResetCriteria: true,
          isShowFilterList: false,
        });
        // }
      } else {
        let rollList = [];
        rollLineList.map((ln) => {
          if (
            !isEmptyString(rollLineData.vendorLotNumber) &&
            isEmptyString(rollLineData.rollNumber) &&
            rollLineData.receivedQuantity == 0
          ) {
            if (ln.vendorLotNumber == rollLineData.vendorLotNumber) {
              rollList.push(ln);
            }
          } else if (
            !isEmptyString(rollLineData.vendorLotNumber) &&
            !isEmptyString(rollLineData.rollNumber) &&
            rollLineData.receivedQuantity == 0
          ) {
            if (
              ln.vendorLotNumber == rollLineData.vendorLotNumber &&
              ln.rollNumber == rollLineData.rollNumber
            ) {
              rollList.push(ln);
            }
          } else if (
            !isEmptyString(rollLineData.vendorLotNumber) &&
            isEmptyString(rollLineData.rollNumber) &&
            rollLineData.receivedQuantity != 0
          ) {
            if (
              ln.vendorLotNumber == rollLineData.vendorLotNumber &&
              ln.receivedQuantity == rollLineData.receivedQuantity
            ) {
              rollList.push(ln);
            }
          } else if (
            !isEmptyString(rollLineData.vendorLotNumber) &&
            !isEmptyString(rollLineData.rollNumber) &&
            rollLineData.receivedQuantity != 0
          ) {
            if (
              ln.vendorLotNumber == rollLineData.vendorLotNumber &&
              ln.rollNumber == rollLineData.rollNumber &&
              ln.receivedQuantity == rollLineData.receivedQuantity
            ) {
              rollList.push(ln);
            }
          } else if (
            isEmptyString(rollLineData.vendorLotNumber) &&
            !isEmptyString(rollLineData.rollNumber) &&
            rollLineData.receivedQuantity != 0
          ) {
            if (
              ln.rollNumber == rollLineData.rollNumber &&
              ln.receivedQuantity == rollLineData.receivedQuantity
            ) {
              rollList.push(ln);
            }
          } else if (
            isEmptyString(rollLineData.vendorLotNumber) &&
            !isEmptyString(rollLineData.rollNumber) &&
            rollLineData.receivedQuantity == 0
          ) {
            if (ln.rollNumber == rollLineData.rollNumber) {
              rollList.push(ln);
            }
          } else if (
            isEmptyString(rollLineData.vendorLotNumber) &&
            isEmptyString(rollLineData.rollNumber) &&
            rollLineData.receivedQuantity != 0
          ) {
            if (ln.receivedQuantity == rollLineData.receivedQuantity) {
              rollList.push(ln);
            }
          }
        });

        this.setState({
          filterPurchaseList: rollList,
          isSearchCriteria: true,
          isResetCriteria: false,
          isShowFilterList: true,
        });
      }
    }
  };
  resetIntansitRollLines = (e) => {
    if (e.detail === 1) {
      let purchaseOrderRollLineBeanFilter =
        new PurchaseOrderReceiptRollLineBeanFilter();
      //let filterPurchaseList = this.state.filterPurchaseList;
      let tempArray = [];
      this.setState({
        purchaseOrderRollLineBeanFilter: purchaseOrderRollLineBeanFilter,
        filterPurchaseList: tempArray,
        isSearchCriteria: false,
        isResetCriteria: true,
        isShowFilterList: false,
      });
      //   this.hidePopupAlertCallBack();
    }
  };
  addReceiptLines = (e) => {
    let approvalCriteria = new PurchaseOrderReceiptApprovalCriteriaBean();

    approvalCriteria.companyCode = this.companyCode;
    approvalCriteria.purchaseOrderNumber =
      this.state.purchaseOrderReceiptData.purchaseOrderNumber;
    approvalCriteria.purchaseOrderReceiptNumber =
      this.state.purchaseOrderReceiptData.code;
    let approvalBean = new PurchaseOrderReceiptApprovalBean();
    approvalBean.companyCode = this.companyCode;
    approvalBean.purchaseOrderReceiptNumber =
      this.state.purchaseOrderReceiptData.code;
    this.setState({
      purchaseOrderReceiptApproval: approvalBean,
    });
    this.getApprovalLines(approvalCriteria);
    // if (e.detail == 1) {

    this.setState({
      isShowReceiptApprovalPopup: true,
      isCreateButtonDisabled: false,
    });
    // }
  };
  getApprovalLines = (approvalCriteria) => {
    PurchaseOrderReceiptService.getPurchaseOrderReceiptApprovalLines(
      approvalCriteria,
      this.getApprovalLinesPageResponse,
      this.errorCallBack,
    );
  };
  getApprovalLinesPageResponse = (response) => {
    let tempArray = [];
    if (
      response.data != null &&
      response.data.purchaseOrderReceiptApprovalBean != null &&
      response.data.purchaseOrderReceiptApprovalBean.receiptApprovalLines !=
        null
    ) {
      tempArray =
        response.data.purchaseOrderReceiptApprovalBean.receiptApprovalLines;
    }
    this.setState({
      purchaseOrderReceiptApprovalList: tempArray,
    });
  };

  closeAlertReceiptApprovalModalCallBack = (isShowPopup) => {
    this.setState({
      isShowReceiptApprovalPopup: isShowPopup,
      isShowApprovalAlert: isShowPopup,
    });
  };

  selectAllList = (e) => {
    if (e.detail === 1) {
      if (!isEmptyArray(this.state.purchaseOrderReceiptApprovalList)) {
        this.state.purchaseOrderReceiptApprovalList.map((select) => {
          select.isApplied = true;
        });
        this.approvalcalculation();
      }
    }
  };

  unSelectAllList = (e) => {
    if (e.detail === 1) {
      if (e.detail === 1) {
        if (!isEmptyArray(this.state.purchaseOrderReceiptApprovalList)) {
          this.state.purchaseOrderReceiptApprovalList.map((select) => {
            select.isApplied = false;
          });
        }
        this.approvalcalculation();
      }
    }
  };

  onSelectedApprovalLines = (evt, line) => {
    let selectedLine = { ...line };
    this.state.purchaseOrderReceiptApprovalList.map((select) => {
      if (
        select.receiptLineNumber == line.receiptLineNumber &&
        select.fabricStyleCode == line.fabricStyleCode &&
        select.skuNumber == line.skuNumber
      ) {
        select.isApplied = evt.target.value;
      }
    });
    this.approvalcalculation();
  };
  viewApprovedDetails = (e, rowData) => {
    //   let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let approveBean = new PurchaseOrderReceiptApprovalCriteriaBean();
    approveBean.companyCode = this.companyCode;
    approveBean.purchaseOrderReceiptApprovalNumber = rowData.code;
    approveBean.purchaseOrderReceiptNumber = rowData.purchaseOrderReceiptNumber;
    this.viewDetailsRequest(approveBean);
    // this.setState({
    //   isShowReceiptApprovalPopup: true,
    // })
  };

  viewDetailsRequest = (approveBean) => {
    PurchaseOrderReceiptService.readPurchaseOrderReceiptApproval(
      approveBean,
      this.viewDetailsResponse,
      this.errorCallBack,
    );
  };
  viewDetailsResponse = (response) => {
    let receiptApprovalList = [];
    //  let purchaseOrderReceiptApproval = null;

    let purchaseOrderReceiptApproval = new PurchaseOrderReceiptApprovalBean();
    if (
      response.data != null &&
      response.data.purchaseOrderReceiptApprovalBean
    ) {
      purchaseOrderReceiptApproval =
        response.data.purchaseOrderReceiptApprovalBean;
      receiptApprovalList = purchaseOrderReceiptApproval.receiptApprovalLines;
    }
    this.setState({
      purchaseOrderReceiptApproval: purchaseOrderReceiptApproval,
      purchaseOrderReceiptApprovalList: receiptApprovalList,
      isShowReceiptApprovalPopup: true,
      isCreateButtonDisabled: true,
    });
  };
  approvalcalculation = () => {
    let purchaseOrderReceiptApproval = this.state.purchaseOrderReceiptApproval;
    let totalreceivedQty = 0;
    let totaltotalAmount = 0;
    this.state.purchaseOrderReceiptApprovalList.map((selectLine) => {
      if (selectLine.isApplied) {
        totalreceivedQty =
          parseFloat(totalreceivedQty) + parseFloat(selectLine.quantity);
        totaltotalAmount =
          parseFloat(totaltotalAmount) + parseFloat(selectLine.amount);
      }
    });
    purchaseOrderReceiptApproval.totalQuantity = totalreceivedQty;
    purchaseOrderReceiptApproval.receiptAmount = totaltotalAmount;
    this.setState({
      purchaseOrderReceiptApproval: purchaseOrderReceiptApproval,
    });
  };

  poReceiptApprovalOnChange = (e) => {
    let criteria = this.state.purchaseOrderReceiptApproval;
    criteria[e.target.name] = e.target.value;
    this.setState({ purchaseOrderReceiptApproval: criteria });
  };

  closeMessageWarningModelCallBack = () => {
    this.setState({ isShowWarningMsgPopup: false });
  };

  warningMessageForVendor = () => {
    return new Promise((resolve) => {
      this.receiptWarningResolve = resolve;
      this.setState({ isShowWarningMsgPopup: true });
    });
  };

  onYesButtonClick = () => {
    this.setState({ isShowWarningMsgPopup: false, isNotExceed: true }, () => {
      this.closeMessageWarningModelCallBack();
      if (this.receiptWarningResolve) {
        this.receiptWarningResolve(true);
        this.receiptWarningResolve = null;
      }
    });
  };

  onNoButtonClick = () => {
    this.setState({ isShowWarningMsgPopup: false, isNotExceed: false }, () => {
      this.closeMessageWarningModelCallBack();
      if (this.receiptWarningResolve) {
        this.receiptWarningResolve(false);
        this.receiptWarningResolve = null;
      }
    });
  };
  validatePurchaseApprovalData = async (PurchaseApproval) => {
    let isValidApprovalData = false;

    let err_list = [];
    let errorMessage = "";
    if (PurchaseApproval == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(PurchaseApproval.approvedAmount)) {
        let errMsg = "ApprovedAmount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (PurchaseApproval.receiptApprovalLines.length < 1) {
        let errMsg = "Select Receipt Lines";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidApprovalData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowApprovalAlert: true,
      });
    } else {
      if (
        parseFloat(PurchaseApproval.approvedAmount) >
        parseFloat(PurchaseApproval.receiptAmount)
      ) {
        let receiptWarningMessage =
          "Approval amount exceeds The Total Receipt Amount.\nDo you want to continue?";

        this.setState({
          receiptWarningMessage: receiptWarningMessage,
        });
        //  this.warningMessageForVendor()
        const userConfirmed = await this.warningMessageForVendor();
        this.setState({ isNotExceed: userConfirmed });
        return userConfirmed;
      }

      isValidApprovalData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidApprovalData;
  };
  createApprovalLines = async () => {
    let criteria = { ...this.state.purchaseOrderReceiptApproval };
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    criteria.companyCode = this.companyCode;
    criteria.vendorCode = purchaseOrderReceiptData.vendorCode;
    criteria.purchaseOrderNumber = purchaseOrderReceiptData.purchaseOrderNumber;
    let selectedLines = [];
    this.state.purchaseOrderReceiptApprovalList.map((selectLine) => {
      if (selectLine.isApplied) {
        selectedLines.push(selectLine);
      }
    });
    criteria.receiptApprovalLines = selectedLines;
    let isValidData = false;
    isValidData = await this.validatePurchaseApprovalData(criteria);
    if (isValidData) {
      // if (this.state.isNotExceed) {
      PurchaseOrderReceiptService.createPurchaseOrderReceiptApproval(
        criteria,
        this.createdApprovalLineResponse,
        this.errorCallBack,
      );
      //}
    }
    // else {
    //   let errMsg = "Access Denied";
    //   let errList = [];
    //   errList.push(errMsg);

    //   this.setState({
    //     alertMessage: errList,
    //     alertType: "danger",
    //     isShowApprovalAlert: true,
    //   });
    // }
  };
  createdApprovalLineResponse = (response) => {
    this.handleResponse(response.data);
    this.setState({
      isShowReceiptApprovalPopup: false,
    });
    this.getApprovalPageList();
  };

  hideAlertCallBackApproval = (mslgType, isDisplayed) => {
    this.setState({
      isShowApprovalAlert: isDisplayed,
    });
  };
  getApprovalPageList = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let approveBean = new PurchaseOrderReceiptApprovalCriteriaBean();
    approveBean.companyCode = this.companyCode;
    approveBean.purchaseOrderReceiptNumber = purchaseOrderReceiptData.code;
    approveBean.purchaseOrderNumber =
      purchaseOrderReceiptData.purchaseOrderNumber;
    let po_pageList = new PageListBean();
    let request = new RestPurchaseOrderReceiptApprovalListRequest();
    request.criteriaBean = approveBean;
    request.pageInput = po_pageList;
    this.getReceiptApprvalLines(request);
  };
  getReceiptApprvalLines = (request) => {
    PurchaseOrderReceiptService.getPurchaseOrderReceiptApprovalPageList(
      request,
      this.getApprovedReceiptPageResponse,
      this.errorCallBack,
    );
  };
  getApprovedReceiptPageResponse = (response) => {
    let receiptApprovalList = [];
    if (
      response.data != null &&
      response.data.purchaseOrderReceiptApprovalPageListBean != null &&
      !isEmptyArray(
        response.data.purchaseOrderReceiptApprovalPageListBean
          .purchaseOrderApprovalReceipts,
      )
    ) {
      receiptApprovalList =
        response.data.purchaseOrderReceiptApprovalPageListBean
          .purchaseOrderApprovalReceipts;
    }
    this.setState({
      receiptApprovalList: receiptApprovalList,
    });
  };

  //

  openReturnPopup = () => {
    let debitMemoDataBean = new DebitMemoBean();
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    debitMemoDataBean.companyCode = this.companyCode;
    debitMemoDataBean.vendorCode = purchaseOrderReceiptData.vendorCode;
    debitMemoDataBean.vendorName = purchaseOrderReceiptData.vendorName;
    debitMemoDataBean.createdDate = toFormattedDate_v1(new Date());
    debitMemoDataBean.code = NEW_ENTRY;
    debitMemoDataBean.debitMemoStatus = LogicConstants.DEBIT_MEMO_OPEN_STATUS;
    debitMemoDataBean.debitMemoType = "RETURN";
    debitMemoDataBean.isUpdateInventory = true;
    this.getMultiReceiptRollSku();

    this.setState({
      isShowReturnPopup: true,
      debitMemoDataBean: debitMemoDataBean,
      rollSkuList: [],
    });
  };

  getMultiReceiptRollSku = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.purchaseOrderNumber = purchaseOrderReceiptData.purchaseOrderNumber;
    criteria.purchaseReceitpNumber = purchaseOrderReceiptData.code;
    let pageList = new PageListBean();
    let requestInput = new RestSkuBatchInventoryListRequest();
    requestInput.searchCriteria = criteria;
    requestInput.pageInput = pageList;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading Lines...",
    });
    this.loadMultipleRollSkuList(requestInput);
  };
  loadMultipleRollSkuList = (requestInput) => {
    //  if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
    InventoryService.getSkuBatchDetailsForPurchaseReceipt(
      requestInput,
      this.loadMultipleRollSkuResponse,
      this.errorCallBack,
    );
    //}
  };

  loadMultipleRollSkuResponse = (response) => {
    let rollSkuList = [];
    if (response.data.skuBatchInventoryPageList != null) {
      if (response.data.skuBatchInventoryPageList.skuBatchInventories != null) {
        rollSkuList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
      }
    }

    this.setState({
      rollSkuList: rollSkuList,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      // rollSkuLookupHandler: rollSkuLookupHandler,
    });
  };

  selectAllReturnList = (e) => {
    if (e.detail !== 1) return;
    this.setState((prev) => ({
      rollSkuList: prev.rollSkuList.map((item) => ({
        ...item,
        isSelected: true,
      })),
    }));
  };

  unSelectAllReturnList = (e) => {
    if (e.detail !== 1) return;
    this.setState((prev) => ({
      rollSkuList: prev.rollSkuList.map((item) => ({
        ...item,
        isSelected: false,
      })),
    }));
  };

  onSelectedQtyLines = (evt, line) => {
    let rollSkuList = { ...line };
    this.state.rollSkuList.map((select) => {
      if (select.rollSkuNumber == line.rollSkuNumber) {
        select.isSelected = evt.target.value;
      }
    });
  };

  MultiRetunLinesColumn = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", "isSelected", false)
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.onSelectedQtyLines,
          null,
        )
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)

        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)

        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SKU", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM#", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2 ", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PR#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RollSku", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReturnQty", "onHandQuantity", true)
        // .setHeaderDetails( )
        .setStyleDetails("right", "", "", "wt-2 ", "wt-2")
        .setInputDetails(
          false,
          true,
          false,
          this.onLineQtyReturnChange,
          null,
          this.onLineQtyBlur,
        ),
    );

    return columns;
  };

  onLineQtyReturnChange = (evt, data) => {
    this.state.rollSkuList.map((line) => {
      if (line.rollSkuNumber === data.rollSkuNumber) {
        line[evt.target.name] = evt.target.value;
        line.isSelected = true;
      }
    });
  };
  onLineQtyBlur = (evt, row) => {};

  closeAlertModalReturnCallBack = (isShowPopup) => {
    isShowPopup = false;
    this.setState(
      {
        isShowReturnPopup: isShowPopup,
      },
      () => {
        this.hideAlertCallBackReturn();
      },
    );
  };

  hideAlertCallBackReturn = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvlReturn: isDisplayed });
  };

  debitMemoOnChange = (e) => {
    let criteria = this.state.debitMemoDataBean;
    criteria[e.target.name] = e.target.value;
    this.setState({ debitMemoDataBean: criteria });
  };

  saveDebitMemo = () => {
    let rollSkuList = [...this.state.rollSkuList];
    let debitMemoDataBean = this.state.debitMemoDataBean;
    let rollSkuReturnLines = [];
    let lineNumber = 0;
    if (!isEmptyArray(rollSkuList)) {
      for (let list of rollSkuList) {
        if (list.isSelected) {
          let returnData = new DebitMemoReturnLineBean();
          returnData.fabricStyleCode = list.fabricStyleCode;
          returnData.fabricStyleName = list.fabricStyleName;
          returnData.colorCode = list.fabricStyleColorCode;
          returnData.lineNumber = ++lineNumber;
          returnData.skuNumber = list.skuNumber;
          returnData.uomCode = list.uomCode;
          returnData.boxNumber = list.boxNumber;
          returnData.vendorBatchNumber = list.vendorBatchNumber;
          returnData.rollNumber = list.rollNumber;
          returnData.locationCode = list.locationCode;
          returnData.widthCode = list.widthCode;
          returnData.lineTotalReturnQuantity = list.onHandQuantity;
          returnData.rollSkuNumber = list.rollSkuNumber;
          returnData.purchaseOrderNumber = list.purchaseOrderNumber;
          returnData.purchaseOrderReceiptNumber =
            list.purchaseOrderReceiptNumber;
          returnData.isUpdateInventory = true;
          rollSkuReturnLines.push(returnData);
        }
      }
      debitMemoDataBean.returnLines = rollSkuReturnLines;
    }
    debitMemoDataBean.openAmount = debitMemoDataBean.debitMemoAmount;
    let isValidLine = false;
    isValidLine = this.validateDebitMemo(debitMemoDataBean);
    if (isValidLine) {
      if (SecurityAccessManager.DebitMemoMaintenanceCreate_IsAccessible()) {
        DebitMemoService.createDebitMemo(
          debitMemoDataBean,
          this.saveDebitMemoResponse,
          this.errorCallBack,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlertLvlReturn: true,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        loadingText: "",
      });
    }
  };

  saveDebitMemoResponse = (response) => {
    this.handleResponse(response.data);
    this.closeAlertModalReturnCallBack();
    // if (response.data != null && !isEmpty(response.data.debitMemo)) {
    //   let debitMemoDataBean = response.data.debitMemo;
    //   let pageTitle = this.moduleCaption + " - EDIT";
    //   if (debitMemoDataBean != null) {
    //     this.setState({
    //       debitMemoDataBean: debitMemoDataBean,
    //       pageTitle: pageTitle,
    //       isLoading: false,
    //       loadingText: "",
    //     });

    //     // this.unlockPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
    //     // this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code, false);
    //     // if (!this.isLocked) {
    //     //   this.editDebitMemo(debitMemoDataBean.code);
    //     // } else {
    //     //   this.code = debitMemoDataBean.code;
    //     //   this.unlockDebitMemo(debitMemoDataBean.code);
    //     // }
    //   }
    // }
    // this.setState({
    //   isLoading: false,
    //   loadingText: "",
    // });
  };

  validateDebitMemo = (debitMemoBean) => {
    let isValidDebitMemoReceiptBean = false;
    let err_list = [];
    let errorMessage = "";
    if (debitMemoBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      //   if (isEmptyString(debitMemoBean.lines)) {
      //     let errMsg = "PO Receipt Lines is Required";
      //     errorMessage = errorMessage + errMsg;
      //     err_list.push(errMsg);
      //   }

      if (isEmptyString(debitMemoBean.vendorCode)) {
        let errMsg = "Vendor Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(debitMemoBean.vendorName)) {
        let errMsg = "Vendor Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      // if (debitMemoBean.debitMemoType === "PREPAID") {
      //     if (isEmptyString(debitMemoBean.purchaseOrderNumber)) {
      //         let errMsg = "PO Number is Required";
      //         errorMessage = errorMessage + errMsg;
      //         err_list.push(errMsg);
      //     }
      // }
      if (debitMemoBean.debitMemoType === "RETURN") {
        if (isEmptyArray(debitMemoBean.returnLines)) {
          let errMsg = "ReturnLines is Required";
          errorMessage = errorMessage + errMsg;
          err_list.push(errMsg);
        }
      }
      if (debitMemoBean.debitMemoAmount <= 0) {
        let errMsg = "DebitMemoAmount Required ";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidDebitMemoReceiptBean = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvlReturn: true,
        // isShowPopupAlert: false,
        // isShowPopupAlertlvl1: false,
        // isShowPopupAlertlvl5: false,
      });
    } else {
      isValidDebitMemoReceiptBean = true;
      this.setState({
        isShowAlert: false,
        // isShowPopupAlert: false,
        // isShowPopupAlertlvl1: false,
        // isShowPopupAlertlvl5: false,
      });
    }
    return isValidDebitMemoReceiptBean;
  };

  getPurchaseOrderReceiptOverallLinesDatasFromExcel = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;

    let selectedDocument = this.state.selectedDocument;
    let readrestInput = new RestPurchaseOrderReceiptExcelImportRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.purchaseOrderNumber =
      purchaseOrderReceiptData.purchaseOrderNumber;
    readrestInput.excelFileName = selectedDocument;

    PurchaseOrderReceiptService.getPurchaseOrderReceiptLinesOverallInputFromExcel(
      readrestInput,
      this.getPoReceiptLinesOverallDataExcelResponse,
      this.getPoReceiptLinesOverallDataExcelError,
    );
  };

  getPoReceiptLinesOverallDataExcelResponse = (response) => {
    let prlines = this.state.purchaseOrderReceiptData;

    if (response.data != null && response.data.einput != null) {
      let rollLinesList = response.data.einput.rollLines;

      for (let mainLines of prlines.lines) {
        let lineNumber = 1;
        let tempLInes = [];
        let receivedQuantity = 0;

        for (let list of rollLinesList) {
          const method = this.matchFabricAndColor(
            mainLines.fabricStyleCode,
            mainLines.colorCode,
            list.fabricStyleCode,
            list.colorCode,
          );

          if (method) {
            let rollLines = new PurchaseOrderReceiptRollLineBean();
            rollLines.companyCode = this.companyCode;
            rollLines.fabricStyleCode = list.fabricStyleCode;
            rollLines.receiptRollLineNumber = lineNumber++;
            rollLines.colorCode = list.colorCode;
            rollLines.vendorLotNumber = list.lotNumber;
            rollLines.receivedQuantity = list.quantity;
            rollLines.rollNumber = list.rollNumber;
            rollLines.boxNumber = list.boxNumber;
            rollLines.skuNumber = mainLines.skuNumber;
            rollLines.fabricStyleName = mainLines.fabricStyleName;
            rollLines.widthCode = mainLines.widthCode;
            rollLines.uomCode = mainLines.uomCode;
            rollLines.locationCode = mainLines.locationCode;
            receivedQuantity += parseFloat(list.quantity);
            tempLInes.push(rollLines);
          }
        }

        mainLines.receiptRollLines = tempLInes;
        mainLines.totalRolls = tempLInes.length;
        mainLines.receivedQuantity = receivedQuantity.toFixed(2);
      }

      this.setState({
        purchaseOrderReceiptData: {
          ...this.state.purchaseOrderReceiptData,
          lines: prlines.lines,
        },
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };

  matchFabricAndColor(mainFab, mainCol, listFab, listCol) {
    // Method 1: exact lowercase
    if (
      mainFab?.toLowerCase() === listFab?.toLowerCase() &&
      mainCol?.toLowerCase() === listCol?.toLowerCase()
    ) {
      return "exact";
    }

    // Method 2: trimmed lowercase
    if (
      mainFab?.trim().toLowerCase() === listFab?.trim().toLowerCase() &&
      mainCol?.trim().toLowerCase() === listCol?.trim().toLowerCase()
    ) {
      return "trim";
    }

    // Method 3: trim + remove all whitespace
    if (
      mainFab?.trim().replace(/\s+/g, "").toLowerCase() ===
        listFab?.trim().replace(/\s+/g, "").toLowerCase() &&
      mainCol?.trim().replace(/\s+/g, "").toLowerCase() ===
        listCol?.trim().replace(/\s+/g, "").toLowerCase()
    ) {
      return "nospace";
    }

    return null;
  }

  getPoReceiptLinesOverallDataExcelResponse_old = (response) => {
    let prlines = this.state.purchaseOrderReceiptData;
    // let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    if (response.data != null) {
      if (response.data.einput != null) {
        let rollLinesList = response.data.einput.rollLines;

        for (let mainLines of prlines.lines) {
          let lineNumber = 1;
          let tempLInes = [];
          let receivedQuantity = 0;
          for (let list of rollLinesList) {
            if (
              mainLines.fabricStyleCode?.trim().toLowerCase() ===
                list.fabricStyleCode?.trim().toLowerCase() &&
              mainLines.colorCode?.trim().toLowerCase() ===
                list.colorCode?.trim().toLowerCase()
            ) {
              let rollLines = new PurchaseOrderReceiptRollLineBean();
              rollLines.companyCode = this.companyCode;
              rollLines.fabricStyleCode = list.fabricStyleCode;
              rollLines.receiptRollLineNumber = lineNumber++;
              rollLines.colorCode = list.colorCode;
              rollLines.vendorLotNumber = list.lotNumber;
              rollLines.receivedQuantity = list.quantity;
              rollLines.rollNumber = list.rollNumber;
              rollLines.boxNumber = list.boxNumber;
              // rollLines.locationCode = list.locationCode;
              receivedQuantity = receivedQuantity + parseFloat(list.quantity);
              tempLInes.push(rollLines);
            }
          }
          mainLines.receiptRollLines = tempLInes;
          mainLines.totalRolls = tempLInes.length;
          mainLines.receivedQuantity = receivedQuantity.toFixed(2);
        }

        //   Finally update state
        // this.setState({
        //   purchaseOrderReceiptData: {
        //     ...this.state.purchaseOrderReceiptData,
        //     lines: prlines.lines,
        //   },
        // });
        this.setState({
          purchaseOrderReceiptData: {
            ...this.state.purchaseOrderReceiptData,
            lines: prlines.lines,
          },
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        setTimeout(() => {
          this.setState({
            isShowRollInfoPopup: true,
          });
        }, 200);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  // getRollLineNumber() {
  //   let maxLineNumber = 0;
  //   let lines = this.state.purchaseOrderReceiptData.lines;
  //   if (lines.length > 0)
  //     lines.map((line) => {
  //       if (line.lineNumber > maxLineNumber) {
  //         maxLineNumber = line.lineNumber;
  //       }
  //     });
  //   return maxLineNumber;
  // }
  getPoReceiptLinesOverallDataExcelError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  handlePoReceiptLinesOverallDataExcelResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowPopupAlert: true,
      });
    }
  };

  uploadOverallExcelFile = (e) => {
    this.resetExcelUploadView(); // <--- clear old Excel data first

    // let file = e.target.files[0];
    // if (!file) return;

    // let fileName = file.name || "";
    // let fileData = new File([file], `${fileName}`, { type: file.type });
    // let formData = new FormData();
    // formData.append("file", fileData);

    const fileInput = e.target;
    const file = fileInput.files[0];
    if (!file) return;

    const fileName = file.name;
    const fileData = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", fileData);

    this.setState({
      selectedDocument: fileName,
      isShowProgressBarPopup: true,
      progressLoadingText: "Uploading Excel file, please wait...",
    });

    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.uploadExcelInput(
        formData,
        this.uploadOverallReceiptLinesExcelResponse,
        this.uploadOverallReceiptLinesExcelError,
      );
    } else {
      this.setState({
        alertMessage: ["Access Denied"],
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
      });
    }
    fileInput.value = "";
  };

  uploadOverallReceiptLinesExcelResponse = (response) => {
    if (response.data != null && response.data.success == true) {
      this.setState({
        progressLoadingText: "Reading data from Excel...",
      });
      this.getPurchaseOrderReceiptOverallLinesDatasFromExcel();
    } else {
      let errMsg = "Response Null";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  uploadOverallReceiptLinesExcelError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  resetExcelUploadView = () => {
    let prData = this.state.purchaseOrderReceiptData;

    // Clear previous roll lines from all main lines
    if (prData && prData.lines && prData.lines.length > 0) {
      for (let line of prData.lines) {
        line.receiptRollLines = [];
        line.totalRolls = 0;
        line.receivedQuantity = 0;
      }
    }

    this.setState({
      selectedDocument: "",
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      purchaseOrderReceiptData: {
        ...prData,
        lines: prData.lines,
      },
    });
  };
  closeAlertModalCallBackLvl6 = () => {
    this.setState({
      isShowRollInfoPopup: false,
    });
  };
  hideAlertCallBackLvl6 = () => {
    this.setState({
      isShowAlertLvl6: false,
    });
  };

  render() {
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let invoiceServiceLineList = this.state.invoiceServiceLineList;
    let serviceDetail = this.state.invoiceServiceLineData;

    let purchaseSkuHistory = this.state.purchaseSkuHistory;
    let purchaseFabricHistory = this.state.purchaseFabricHistory;

    let purchaseTempData = this.state.purchaseOrderReceiptLineData;

    let totalOnHandQty = this.state.totalOnHandQty;

    let totalShippedQty = this.state.totalShippedQty;

    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let debitMemoDataBean = this.state.debitMemoDataBean;

    let rollSkuList = this.state.rollSkuList;

    return (
      <div>
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <MessageBoxComponent
          isShowPopup={this.state.isShowWarningMsgPopup}
          ref={this.warningMessageDialogRef}
          warningMesage={this.state.receiptWarningMessage}
          title="Warning Message"
          onYesButtonClick={this.onYesButtonClick}
          onNoButtonClick={this.onNoButtonClick}
          closeMessageModelCallBack={this.closeMessageWarningModelCallBack}
        />
        <ReasonCaptureComponent
          ref={this.receiptLineCancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="Receipt Line Cancel Reason"
          onChange={this.onReasonChange}
          onClick={this.onLineCancelReasonContinue}
          isShowPopup={this.state.isShowLineCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.rollLineCancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="Receipt Roll Line Cancel"
          onChange={this.onReasonChange}
          onClick={this.onRollLineCancelReasonContinue}
          isShowPopup={this.state.isShowRollLineCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        {this.state.isSpecialViewMode == false ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editPurchaseOrderReceipt}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.purchaseOrderReceiptLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />
        {!this.state.isPurchaseOrderReceiptListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              pageTitle={this.state.pageTitle}
              back={this.back}
              save={this.save}
              isShowSaveButton={this.state.isShowSaveButton}
              clearError={this.clearError}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              generatePDF={this.generatePDF}
              isShowPDFButton={this.state.isShowPDFReportButton}
              extend_toolbar={
                <>
                  {this.state.isShowExcelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.generateExcel(e)}
                    >
                      Excel
                    </Button>
                  )}
                  {this.state.isShowApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approvePurchaseOrderReceipt(e)}
                    >
                      Approve
                    </Button>
                  )}
                  {this.state.isShowCancelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.cancelPurchaseOrderReceipt(e)}
                    >
                      Cancel
                    </Button>
                  )}
                  {this.state.isShowCreateInvoiceButton && this.state.is3PL && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.openCreateInvoicePopup(e)}
                    >
                      CreateInvoice
                    </Button>
                  )}

                  {this.state.isShowReturnButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.openReturnPopup(e)}
                    >
                      Return
                    </Button>
                  )}
                </>
              }
            />
          )}

        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          !this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          this.state.isPurchaseOrderReceiptEntryFormOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isPurchaseOrderReceiptApproveReceiptLinesFormOpen &&
          !this.state.isPaymentDetailViewOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          this.state.isPurchaseOrderReceiptEntryFormOpen &&
          !this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          !this.state.isPurchaseOrderReceiptApproveReceiptLinesFormOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getHeaderView()}

        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          !this.state.isPurchaseOrderReceiptEntryFormOpen &&
          !this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          !this.state.isPurchaseOrderReceiptApproveReceiptLinesFormOpen &&
          !this.state.isImageFormOpened &&
          this.state.isDocumentsFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getDocumentFormView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          !this.state.isPurchaseOrderReceiptEntryFormOpen &&
          !this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          !this.state.isPurchaseOrderReceiptApproveReceiptLinesFormOpen &&
          this.state.isImageFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getImageFormView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          !this.state.isPurchaseOrderReceiptEntryFormOpen &&
          this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          !this.state.isPurchaseOrderReceiptApproveReceiptLinesFormOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getPurchaseReceiptHistory()}

        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          !this.state.isPurchaseOrderReceiptEntryFormOpen &&
          !this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          this.state.isPurchaseOrderReceiptApproveReceiptLinesFormOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isDocumentsFormOpened &&
          !this.state.isPaymentDetailViewOpen &&
          this.getPurchaseReceiptApproveReceiptLines()}

        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          !this.state.isPurchaseOrderReceiptEntryFormOpen &&
          !this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          !this.state.isPurchaseOrderReceiptApproveReceiptLinesFormOpen &&
          !this.state.isImageFormOpened &&
          !this.state.isDocumentsFormOpened &&
          this.state.isPaymentDetailViewOpen &&
          this.getPurchaseReceiptPaymentDetailLines()}
        {this.state.isPurchaseOrderReceiptListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <PurchaseOrderReceiptListForm
              {...this.state}
              filterPurchaseOrder={this.filterPurchaseOrder}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editPurchaseOrderReceipt={this.editPurchaseOrderReceipt}
              onChange={this.onCriteriaChange}
              resetfilteredPurchaseOrder={this.resetfilteredPurchaseOrder}
              handleSortingChange={this.handleSortingChange}
            />
          )}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel6"}
          isModulePopup={false}
          isShowPopup={this.state.isShowRollInfoPopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl6}
          title={"Roll Info"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl6}
              hideAlertCallBack={this.hideAlertCallBackLvl6}
            />
          }
          content={
            <div>
              <table id="custom-table">
                <thead>
                  <tr>
                    <th>LineNumber</th>
                    <th>FabricStyle</th>
                    <th>Color</th>
                    <th>RollCount</th>
                  </tr>
                </thead>
                {!isEmptyArray(purchaseOrderReceiptData.lines) ? (
                  <tbody>
                    {purchaseOrderReceiptData.lines.map((ln, index) => (
                      <tr key={index}>
                        <td>{ln.lineNumber}</td>
                        <td>{ln.fabricStyleCode}</td>
                        <td>{ln.colorCode}</td>
                        {!isEmptyArray(ln.receiptRollLines) ? (
                          <td>{ln.receiptRollLines.length}</td>
                        ) : null}
                      </tr>
                    ))}
                  </tbody>
                ) : null}
              </table>
            </div>
          }
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowReturnPopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.closeAlertModalReturnCallBack}
          title={"Return"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvlReturn}
              hideAlertCallBack={this.hideAlertCallBackReturn}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.saveDebitMemo(e)}
              >
                Save-DebitMemo
              </Button>

              {/* <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.clearAdjustment(e)}
                >
                  Clear
                </Button> */}
            </div>
          }
          content={
            <div>
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>Date</FormLabel>
                  </Col>
                  <Col sm="2">
                    <DatePickerComponent_adv
                      name="createdDate"
                      value={debitMemoDataBean.createdDate}
                      onChange={this.onChange}
                      // disabled={isDisableFields}
                      isMandatory={true}
                      //isModifyView={isModify}
                    />
                  </Col>

                  <Col sm="1">
                    <FormLabel>VendorCode</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="vendorCode"
                      value={debitMemoDataBean.vendorCode}
                      disabled={true}
                    ></InputTextbox>
                  </Col>

                  <Col sm="3">
                    <InputTextbox
                      // onChange={this.onChange}
                      disabled={true}
                      name="vendorName"
                      placeholder="VendorName"
                      value={debitMemoDataBean.vendorName}
                    ></InputTextbox>
                  </Col>

                  <Col sm="1">
                    <FormLabel>DebitMemoType</FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      name="debitMemoType"
                      value={debitMemoDataBean.debitMemoType}
                      disabled={true}
                    ></InputTextbox>
                  </Col>
                </Row>

                <Row>
                  <Col sm="1">
                    <FormLabel> DebitMemo Amount </FormLabel>{" "}
                  </Col>
                  <Col sm="2">
                    <NumberFormatInputbox
                      className="text-right"
                      onChange={this.debitMemoOnChange}
                      name="debitMemoAmount"
                      placeholder="debitMemoAmount"
                      value={debitMemoDataBean.debitMemoAmount}
                      //  disabled={isDisableFields}
                      decimalScale={2}
                      isMandatory={true}
                    />
                  </Col>

                  <Col sm="1">
                    <FormLabel>UpdateInv</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputCheckbox
                      name="isUpdateInventory"
                      type="checkbox"
                      checked={debitMemoDataBean.isUpdateInventory}
                      onChange={this.debitMemoOnChange}
                      // disabled={isDisabledFields}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      onClick={(e) => this.selectAllReturnList(e)}
                    >
                      SelectAll
                    </Button>
                  </Col>

                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      onClick={(e) => this.unSelectAllReturnList(e)}
                    >
                      UnSelectAll
                    </Button>
                  </Col>
                </Row>
                <div className="mt-3">
                  <CustomTable
                    data={rollSkuList}
                    columns={this.MultiRetunLinesColumn()}
                    label={"Return Lines"}
                  />
                </div>
              </div>
            </div>
            // <div>
            //   <Row>
            //     <Col sm="1">
            //       <FormLabel>Date</FormLabel>
            //     </Col>
            //     <Col sm="3">
            //       <DatePickerComponent_adv
            //         value={cmData.creditMemoDate}
            //         disabled={true}
            //       />
            //     </Col>
            //     <Col sm="1">
            //       <FormLabel>Customer</FormLabel>
            //     </Col>
            //     <Col sm="3">
            //       <InputTextbox value={cmData.customerCode} disabled={true} />
            //     </Col>
            //     <Col sm="4">
            //       <InputTextbox value={cmData.customerName} disabled={true} />
            //     </Col>
            //   </Row>
            //   <Row>
            //     <Col sm="1">
            //       <FormLabel>Type</FormLabel>
            //     </Col>
            //     <Col sm="3">
            //       <InputTextbox value={cmData.creditType} disabled={true} />
            //     </Col>
            //     <Col sm="1">
            //       <FormLabel>Bill TO</FormLabel>
            //     </Col>
            //     <Col sm="3">
            //       <InputTextbox value={cmData.billToCode} disabled={true} />
            //     </Col>
            //     <Col sm="1">
            //       <FormLabel>Invoice</FormLabel>
            //     </Col>
            //     <Col sm="3">
            //       <InputTextbox
            //         value={cmData.invoiceNumber}
            //         disabled={true}
            //       />
            //     </Col>
            //   </Row>
            //   <Row>
            //     <Col sm="1">
            //       <FormLabel>Created Source</FormLabel>
            //     </Col>
            //     <Col sm="3">
            //       <InputTextbox
            //         value={cmData.createdSourceType}
            //         disabled={true}
            //       />
            //     </Col>
            //     <Col sm="1">
            //       <FormLabel>Currency</FormLabel>
            //     </Col>
            //     <Col sm="3">
            //       <InputTextbox
            //         className="summary_input text-right"
            //         value={cmData.customerCurrencyCode}
            //         disabled={true}
            //       />
            //     </Col>
            //   </Row>
            //   <Row>
            //     <Col>
            //       <FormLabel>Non Merchandise Line Detail</FormLabel>
            //     </Col>
            //   </Row>
            //   <Row>
            //     <Col sm="2">
            //       <FormLabel>SubType</FormLabel>
            //     </Col>
            //     <Col sm="4">
            //       <InputTextbox
            //         onChange={this.creditsubtypeOnChange}
            //         placeholder="creditSubType"
            //         name="creditSubType"
            //         value={adjustNonMerchandiseData.creditSubType}
            //         lookupRequired={true}
            //         lookupHandler={this.state.creditSubTypeLookupHandler}
            //         showCriteriaDialog={true}
            //         enterKeyEventHandler={this.creditsubtypeEnterKeyEvent}
            //         autoCompleteListData={
            //           this.state.creditsubtypePageListForAutoCompleteList
            //         }
            //         enableAutoCompleteTextBox={true}
            //         displayAutoCompleteList={
            //           this.displayCreditsubtypeAutoCompleteList
            //         }
            //         showAutoCompleteList={
            //           this.state.isShowAutoCompleteCreditsubtypeList
            //         }
            //       />
            //     </Col>
            //     <Col sm="2">
            //       <FormLabel>Amount</FormLabel>
            //     </Col>
            //     <Col sm="4">
            //       <NumberFormatInputbox
            //         name="lineTotalAmount"
            //         className="summary_input text-right"
            //         value={adjustNonMerchandiseData.lineTotalAmount}
            //         onChange={this.adjustOnChange}
            //         decimalScale={2}
            //       />
            //     </Col>
            //   </Row>
            //   <Row>
            //     <Col sm="2">
            //       <FormLabel>Doc.Type</FormLabel>
            //     </Col>
            //     <Col sm="4">
            //       <InputTextbox
            //         name="documentType"
            //         value={adjustNonMerchandiseData.documentType}
            //         onChange={this.adjustOnChange}
            //       />
            //     </Col>

            //     <Col sm="2">
            //       <FormLabel>Document#</FormLabel>
            //     </Col>
            //     <Col sm="4">
            //       <InputTextbox
            //         name="documentNumber"
            //         value={adjustNonMerchandiseData.documentNumber}
            //         onChange={this.adjustOnChange}
            //       />
            //     </Col>
            //   </Row>
            //   <Row>
            //     <Col>
            //       <FormLabel>Adjustment reason</FormLabel>
            //     </Col>
            //   </Row>
            //   <Row>
            //     <Col>
            //       <textarea
            //         style={textArea_Style}
            //         className="form-control"
            //         type="text"
            //         name="code"
            //         value={adjustNonMerchandiseData.code}
            //         onChange={this.adjustOnChange}
            //       />
            //     </Col>
            //   </Row>
            // </div>
          }
        />

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCreateInvoicePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl2}
          title={"SERVICE DETAILS ENTRY"}
          lineFunctionalityForm={this.lineFunctionalityForm}
          closeOnDocumentClick={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlertlvl2}
              hideAlertCallBack={this.hideAlertCallBacklvl2}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.createInvoiceFromPO(e)}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col className="align-items-left" sm="2">
                  {" "}
                  <FormLabel>CompanyCode</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="companyCode"
                    readOnly={true}
                    value={this.state.purchaseOrderReceiptData.companyCode}
                    disabled={true}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>PR#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="code"
                    readOnly={true}
                    value={this.state.purchaseOrderReceiptData.code}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Service Details</FormLabel>
                </Col>
              </Row>
              <div className="div_Custom_1">
                <Table id="fabrics_tables_default">
                  <thead>
                    <tr>
                      <th>Line#</th>
                      <th>Service</th>
                      <th>Description</th>
                      <th>Uom</th>
                      <th>Qty</th>
                      <th>Price</th>
                      <th>Amount</th>
                      <th></th>
                    </tr>
                  </thead>
                  {invoiceServiceLineList != null ? (
                    <tbody>
                      {invoiceServiceLineList.map((ln, index) => (
                        <tr key={index}>
                          <td className="hyperLinkText  text-end">
                            <Button
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.editService(e, ln.lineNumber, ln)
                              }
                            >
                              {ln.lineNumber}
                            </Button>
                          </td>
                          <td>{ln.serviceCode}</td>
                          <td>{ln.serviceName}</td>
                          <td>{ln.uomCode}</td>
                          <td className="text-end">{ln.quantity}</td>
                          <td className="text-end">
                            {toCommaSeperatedAmount(ln.unitPrice)}
                          </td>
                          <td className="text-end">
                            {toCommaSeperatedAmount(ln.amount)}
                          </td>
                          <td>
                            {!ln.isFetched &&
                              this.state.isDisableButtons != true && (
                                <Button
                                  size="sm"
                                  onClick={(e) => this.deleteService(e, ln)}
                                >
                                  <DeleteIcon />
                                </Button>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </Table>
                {invoiceServiceLineList.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
              <Row>
                <Col className="align-items-left" sm="">
                  <FormLabel>Service Line Detail</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Ln#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="lineNumber"
                    type="text"
                    onChange={this.serviceLineOnchange}
                    readOnly={true}
                    value={serviceDetail.lineNumber}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Service</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.serviceOnChange}
                    placeholder="serviceCode"
                    name="serviceCode"
                    value={serviceDetail.serviceCode}
                    lookupRequired={true}
                    lookupHandler={this.state.serviceLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.serviceEnterKeyEvent}
                    autoCompleteListData={
                      this.state.servicePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayServiceAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteServiceList
                    }
                    disabled={this.state.isDisabledFields}
                  />
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="serviceName"
                    type="text"
                    onChange={this.serviceLineOnchange}
                    readOnly={true}
                    value={serviceDetail.serviceName}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>UOM</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.serviceLineOnchange}
                    // placeholder="uomCode"
                    name="uomCode"
                    value={serviceDetail.uomCode}
                    // lookupRequired={true}
                    // lookupHandler={this.state.uomLookupHandler}
                    // showCriteriaDialog={true}
                    // enterKeyEventHandler={this.invoiceUomEnterKeyEvent}
                    // autoCompleteListData={
                    //   this.state.invoiceUomPageListForAutoCompleteList
                    // }
                    // enableAutoCompleteTextBox={true}
                    // displayAutoCompleteList={
                    //   this.displayInvoiceUomAutoCompleteList
                    // }
                    // showAutoCompleteList={
                    //   this.state.isShowAutoCompleteInvoiceUomList
                    // }
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Price</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={serviceDetail.unitPrice}
                    onChange={this.serviceLineOnchange}
                    className=" text-right"
                    decimalScale={2}
                    name={"unitPrice"}
                    // readOnly = {true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Qty</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={serviceDetail.quantity}
                    onChange={this.serviceLineOnchange}
                    className=" text-right"
                    decimalScale={2}
                    name={"quantity"}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Amount</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={serviceDetail.amount}
                    onChange={this.serviceLineOnchange}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"amount"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <Button
                    size="sm"
                    id="fabric_Add_Button"
                    className="header_buttons enterFocus"
                    onClick={(e) => this.addLines(e)}
                  >
                    Add/Update
                  </Button>
                  <Button
                    id="fabric_Add_Button"
                    size="sm1"
                    onClick={(e) => this.clearLines(e)}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </div>
          }
        />

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowPurchaseHistoryPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl2}
          title={"Inventory Sales History"}
          lineFunctionalityForm={this.lineFunctionalityForm}
          closeOnDocumentClick={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlertlvl2}
              hideAlertCallBack={this.hideAlertCallBacklvl2}
            />
          }
          headerButtonContainer={<div className="floatLeft"></div>}
          content={
            <div>
              <Row>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>CompanyCode</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="companyCode"
                    readOnly={true}
                    value={purchaseTempData.companyCode}
                    disabled={true}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>Fabric</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    readOnly={true}
                    value={purchaseTempData.fabricStyleCode}
                    disabled={true}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>Fabric Name</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    readOnly={true}
                    value={purchaseTempData.fabricStyleName}
                    disabled={true}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>Color</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="colorCode"
                    readOnly={true}
                    value={purchaseTempData.colorCode}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>PurchaseOrder</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="purchaseOrderNumber"
                    readOnly={true}
                    value={purchaseTempData.purchaseOrderNumber}
                    disabled={true}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>PurchaseOrderReceipt</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="purchaseOrderReceiptNumber"
                    readOnly={true}
                    value={purchaseTempData.purchaseOrderReceiptNumber}
                    disabled={true}
                  />{" "}
                </Col>

                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>ToatlOnhandQty</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={totalOnHandQty}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"totalOnHandQty"}
                    disabled={true}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>TotalShippedQty</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={totalShippedQty}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"totalShippedQty"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>Received Qty</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={purchaseTempData.receivedQuantity}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"receivedQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row>

              <div className="div_inline">
                <div className="div_40_no_overflow_2">
                  <CustomTable
                    data={purchaseSkuHistory}
                    columns={this.purchaseSkuColumns()}
                    label={"Inventory Details"}
                  />
                </div>
                <div className="div_60_no_overflow_2">
                  <CustomTable
                    data={purchaseFabricHistory}
                    columns={this.purchaseHistoryColumns()}
                    label={"Inventory Sales History Details"}
                  />
                </div>
              </div>
            </div>
          }
        />
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="PurchaseReceipt Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowfabricAndCustomerSalesDetails}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
      </div>
    );
  }
}
class PurchaseOrderReceiptListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      criteria: new PurchaseOrderReceiptSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  filterPurchaseOrder = (e) => {
    if (e.detail == 1) this.props.filterPurchaseOrder();
  };
  resetfilteredPurchaseOrder = (e) => {
    if (e.detail == 1) {
      let criteria = this.props.criteria;

      this.props.resetfilteredPurchaseOrder(criteria);
    }
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handlePurchaseOrderCodeChange = (event) => {
    this.setState({ filter: event.target.value });
  };
  editPurchaseOrderReceipt = (e, val, row) => {
    if (e.detail == 1) this.props.editPurchaseOrderReceipt(val, false);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterPurchaseOrder();
    }
  };

     purchaseReceiptPageColumns = () => {
        const columns = new Array();
        columns.push(
          new ColumnDefinition()
            .setDetails("POReceipt#", "code", true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3")
            .setClickDetails(true, false, this.editPurchaseOrderReceipt, null),
        );
              columns.push(
          new ColumnDefinition()
            .setDetails("Purchase Order", "purchaseOrderNumber", true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3")
           
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Vendor", "vendorCode", true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3"),
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("VendorName", "vendorName", true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3"),
        );
              columns.push(
          new ColumnDefinition()
            .setDetails("ReceiptDate", "receiptDate", true, false, true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3"),
        );
  
  
        columns.push(
          new ColumnDefinition()
            .setDetails("Status", "receiptStatus", true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3")
            .setStatusDetails(true, this.getCaption),
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("ShipmentTerm", "shipmentTermsCode", true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3"),
  
        );
              columns.push(
          new ColumnDefinition()
            .setDetails("Location", "locationCode", true)
            .setStyleDetails("left", "", "", "wt-3", "wt-3"),
  
        );
  
    
        return columns;
      };
      getCaption = (status) => {
        return ModuleUtils.getPurchaseOrderReceiptStatusCaption(status);
      };
    
  render() {
    let purchaseOrderReceiptList = new Array();
    if (!isEmptyArray(this.props.purchaseOrderReceiptListData))
      purchaseOrderReceiptList = this.props.purchaseOrderReceiptListData;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                name="searchName"
                type="text"
                placeholder="Enter Value to Filter.."
                value={criteria.searchName}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterPurchaseOrder(e)}>
                Filter
              </Button>
              <Button onClick={(e) => this.resetfilteredPurchaseOrder(e)}>
                Reset
              </Button>
            </span>
          </div> */}
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.onChange}
                name="receiptStatus"
                value={criteria.receiptStatus}
              >
                <option value={""}>All</option>
                <option value={"A"}>Approved</option>
                <option value={"U"}>UnApproved</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                name="searchName"
                type="text"
                placeholder="Enter Value to Filter.."
                value={criteria.searchName}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterPurchaseOrder(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetfilteredPurchaseOrder(e)}
              >
                Reset
              </Button>
            </div>
          </div>
          <div className="module_header_secondary_buttons">
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>

         <div className="mt-3">
                  <CustomTable
                    data={purchaseOrderReceiptList}
                    columns={this.purchaseReceiptPageColumns()}
                    enableHighlight={true} // Boolean flag controlling highlight execution
                    //  searchText={pickTicketCriteria.searchName} // Search input text
                  />
                </div>
        {/* <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  POReceipt
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "purchaseOrderNumber")
                  }
                >
                  Purchase Order
                  {this.props.order === "desc" &&
                  this.props.sortField === "purchaseOrderNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorCode")}>
                  Vendor
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorName")}>
                  VendorName
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "receiptDate")}>
                  ReceiptDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "receiptDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "receiptStatus")}
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "receiptStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "shipmentTermsCode")
                  }
                >
                  ShipmentTerm
                  {this.props.order === "desc" &&
                  this.props.sortField === "shipmentTermsCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "locationCode")}
                >
                  Location
                  {this.props.order === "desc" &&
                  this.props.sortField === "locationCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {purchaseOrderReceiptList != null ? (
              <tbody>
                {purchaseOrderReceiptList.map((inv, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editPurchaseOrderReceipt(e, inv.code)
                        }
                      >
                        {inv.code}
                      </Button>
                    </td>
                    <td>{inv.purchaseOrderNumber}</td>
                    <td>{inv.vendorCode}</td>
                    <td>{inv.vendorName}</td>
                    <td>{ModuleUtils.getDateFormat_v1(inv.receiptDate)}</td>
                    <td>
                      {ModuleUtils.getPurchaseOrderReceiptStatusCaption(
                        inv.receiptStatus,
                      )}
                    </td>
                    <td>{inv.shipmentTermsCode}</td>
                    <td>{inv.locationCode}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {purchaseOrderReceiptList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div> */}
      </div>
    );
  }
}
class PurchaseOrderReceiptForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
    this.purchaseOrderRef = React.createRef();
    this.fobCityRef = React.createRef();
    this.warehouseRef = React.createRef();
    this.paymentTermRef = React.createRef();
    this.shipmentTermRef = React.createRef();
    this.shipViaRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus = () => {
    if (this.props.moduleKeyCode === NEW_ENTRY) {
      this.purchaseOrderRef.current.focus();
    }
  };
  initLookupHandlers = () => {
    let intStatus = "A";
    let poStatus = "A";
    let purchaseOrderNumber =
      this.props.purchaseOrderReceiptData.purchaseOrderNumber;
    let paymentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.paymentTerms,
      "Payment Term",
    );
    this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let shipmentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipmentTerms,
      "ShipmentTerms",
    );
    this.setState({ shipmentTermLookupHandler: shipmentTermLookupHandler });
    let fobCityLookupHandler = new GenericAttributeLookupHandler(
      this.props.fOBCities,
      "FobCity",
    );
    this.setState({ fobCityLookupHandler: fobCityLookupHandler });
    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipVias,
      "ShipVia",
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });
    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "Purchase Order",
      "",
      LogicConstants.PURCHASE_ORDER_APPROVE_STATUS,
    );
    this.setState({ purchaseOrderLookupHandler: purchaseOrderLookupHandler });
  };
  closePurchaseOrderEntryForm() {
    this.props.closePurchaseOrderEntryForm();
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onPurchaseOrderChange = (e) => {
    this.props.onPurchaseOrderChange(e);
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    this.props.purchaseOrderEnterKeyEventHandler(e);
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.props.displayAutoCompletePurchaseOrderList(showAutoCompleteList);
  };
  onDateChange = (e) => {
    this.props.onDateChange(e);
  };
  onVendorCodeChange = (e) => {
    this.props.onVendorCodeChange(e);
  };
  showLookup = () => {
    this.props.openLinePopup();
  };
  closeLookup = () => {
    this.props.addOrUpdatePurchaseOrderReceiptLine();
  };
  addOrUpdatePurchaseOrderReceiptLine = (e) => {
    if (e.detail == 1) {
      this.props.addOrUpdatePurchaseOrderReceiptLine(e);
      this.props.closeAlertModalCallBack(false);
    }
  };
  editPurchaseOrderReceiptLine = (e, val, row) => {
    if (e.detail == 1) {
      this.props.editPurchaseOrderReceiptLine(val, row);
      this.showLookup();
    }
  };
  deleteReceiptLine = (e, val, rowData) => {
    if (rowData.lineStatus != LogicConstants.SALES_ORDER_LINE_CANCEL_STATUS)
      if (e.detail == 1) this.cancelPurchaseReceiptLine(rowData);
  };
  cancelPurchaseReceiptLine = (receiptLineData) => {
    this.props.cancelPurchaseReceiptLine(receiptLineData);
  };
  editPurchaseOrderReceiptRollLine = (val, rowData) => {
    this.props.editPurchaseOrderReceiptRollLine(val, rowData);
  };
  onPurchaseOrderReceiptLineChange = (e) => {
    this.props.onPurchaseOrderReceiptLineChange(e);
  };
  onPurchaseOrderReceiptRollLineChange = (e) => {
    this.props.onPurchaseOrderReceiptRollLineChange(e);
  };
  addOrUpdatePurchaseOrderReceiptRollLine = (e) => {
    this.props.addOrUpdatePurchaseOrderReceiptRollLine(e);
  };
  addNewRollLine = (e) => {
    this.props.addNewRollLine(e);
  };
  getPurchaseOrderLinesDatasFromExcel = (e) => {
    this.props.getPurchaseOrderLinesDatasFromExcel(e);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  lnkPOModule = (e) => {
    if (e.detail == 1) this.props.lnkPOModule();
  };
  lnkPOIntransitModule = (e) => {
    if (e.detail == 1) this.props.lnkPOIntransitModule();
  };
  closePoIntransitModalCallBack = (isOpen) => {
    this.props.closePoIntransitModalCallBack(isOpen);
  };
  closeModalCallBack = (isOpen) => {
    this.props.closeModalCallBack(isOpen);
  };
  loadReceiptLines = (e) => {
    if (e.detail <= 1) this.props.loadReceiptLines();
  };
  rollLineLocationOnChange = (e) => {
    this.props.rollLineLocationOnChange(e);
  };
  rollLineLocationEnterKeyEventHandler = (e) => {
    this.props.rollLineLocationEnterKeyEventHandler(e);
  };
  displayRollLineLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayRollLineLocationAutoCompleteList(showAutoCompleteList);
  };
  locationOnChange = (e) => {
    this.props.locationOnChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayLocationAutoCompleteList(showAutoCompleteList);
  };
  fobCityOnChange = (e) => {
    this.props.fobCityOnChange(e);
  };
  fobCityEnterKeyEventHandler = (e) => {
    this.props.fobCityEnterKeyEventHandler(e);
  };
  displayFobCityAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayFobCityAutoCompleteList(showAutoCompleteList);
  };
  shipmentTermOnChange = (e) => {
    this.props.shipmentTermOnChange(e);
  };
  shipmentTermEnterKeyEventHandler = (e) => {
    this.props.shipmentTermEnterKeyEventHandler(e);
  };
  displayShipmentTermAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayShipmentTermAutoCompleteList(showAutoCompleteList);
  };
  shipViaOnChange = (e) => {
    this.props.shipViaOnChange(e);
  };
  shipViaEnterKeyEventHandler = (e) => {
    this.props.shipViaEnterKeyEventHandler(e);
  };
  displayShipViaAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayShipViaAutoCompleteList(showAutoCompleteList);
  };
  poIntransitOnChange = (e) => {
    this.props.poIntransitOnChange(e);
  };
  poIntransitEnterKeyEventHandler = (e) => {
    this.props.poIntransitEnterKeyEventHandler(e);
  };
  displayPOIntransitAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayPOIntransitAutoCompleteList(showAutoCompleteList);
  };
  onFilterChange = (e) => {
    this.props.onFilterChange(e);
  };
  filterRollLinenClick = (e) => {
    this.props.filterRollLinenClick(e);
  };
  resetIntansitRollLines = (e) => {
    this.props.resetIntansitRollLines(e);
  };

  overallExcelOnClick = (e) => {
    if (e.detail == 1) {
      const input = document.getElementById("file-input");
      if (input) {
        input.click();
      }
    }
  };

  getShortcutComponent = (row) => {
    return (
      <ShortCutMenuPopup
        value={row.fabricStyleCode}
        menuItems={
          <ul>
            <li
              className="shortcut-menu-item"
              onClick={(e) =>
                this.props.openFabricAndCustomerDetailsInq(
                  e,
                  row.fabricStyleCode,
                )
              }
            >
              Inventory and Customer Details
            </li>

            <li
              className="shortcut-menu-item"
              onClick={(e) => this.props.openFabricPurchaseDetails(e, row)}
            >
              Inventory And Sales History
            </li>
          </ul>
        }
      />
    );
  };
  getCaption = (status) => {
    return ModuleUtils.getPurchaseOrderReceiptLineStatusCaption(status);
  };
  prLineColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setHeaderDetails(true, null, null, false)
        .setStyleDetails("", "", "", "wt-4", "wt-4")

        .setShortCutPopDetails(this.getShortcutComponent, true),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "lineNumber", true)

        .setStyleDetails("right", "", "", "wt-2", " wt-2")

        .setClickDetails(true, false, this.editPurchaseOrderReceiptLine, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "min-wt-5", "min-wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "min-wt-5 ", "min-wt-5 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "min-wt-5 ", "min-wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "purchaseOrderQuantity", true)
        .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpnOrderQty", "openOrderQuantity", true)
        .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RcdToDT", "receivedQuantityToDate", true)
        .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedQty", "receivedQuantity", true)
        .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InTransitQty", "inTransitQuantity", true)
        .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CurrentInTransitQty", "openInTransistQuantity", true)
        .setStyleDetails("right", "", "", "wt-5 ", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "lineStatus", true)
        .setStatusDetails(true, this.getCaption)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)

        .setClickDetails(false, true, this.deleteReceiptLine, <DeleteIcon />)
        .setDisabled(!this.props.isDisableButtons),
    );
    return columns;
  };

  render() {
    let purchaseOrderReceiptData = new PurchaseOrderReceiptBean();
    purchaseOrderReceiptData = this.props.purchaseOrderReceiptData;

    let purchaseOrderReceiptLineData = this.props.purchaseOrderReceiptLineData;
    let purchaseOrderReceiptRollLineData =
      this.props.purchaseOrderReceiptRollLineData;
    let vendor_List = this.props.vendor_List;
    let disableFormFields = this.props.disableFormFields;
    let lines = [];
    if (purchaseOrderReceiptData != null) {
      lines = purchaseOrderReceiptData.lines;
    }
    if (!lines) {
      lines = new Array();
    }
    let isDisabledFields = this.props.isDisabledFields;
    const textAreaStyle = {
      maxHeight: "9em",
      width: "45em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    let is3PL = this.props.is3PL;
    let isTexco = this.props.isTexco;
    let purchaseOrderRollLineBeanFilter =
      this.props.purchaseOrderRollLineBeanFilter;
      let isVendorInvoiceShow = this.props.isVendorInvoiceShow;
    return (
      <div>
        <div>
          <MultiViewPopup
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.props.isShowPurchaseOrderModule}
            closeModalCallBack={this.closeModalCallBack}
            module={this.props.moduleForPopup}
          ></MultiViewPopup>
          <MultiViewPopup
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.props.isShowPurchaseOrderInTransitModule}
            closeModalCallBack={this.closePoIntransitModalCallBack}
            module={this.props.moduleForPopup}
          ></MultiViewPopup>
          <div>
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.props.isShowPopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel1"}
              closeAlertModalCallBack={this.props.closeAlertModalCallBack}
              title={"LINE DETAIL"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              alertContainerBox={
                <AlertToolBox
                  alertMsgList={this.props.alertMessage}
                  alertErrorType={this.props.alertType}
                  isShowAlert={this.props.isShowPopupAlert}
                  hideAlertCallBack={this.props.hidePopupAlertCallBack}
                />
              }
              headerButtonContainer={
                <div className="floatLeft">
                  {this.props.isDisableButtons && (
                    <Button
                      className="header_buttons"
                      size="sm"
                      onClick={(e) =>
                        this.addOrUpdatePurchaseOrderReceiptLine(e)
                      }
                    >
                      Add/Update
                    </Button>
                  )}
                </div>
              }
              content={
                <div className="header_div">
                  <PurchaeOrderReceiptLinePopUpForm
                    is3PL={this.props.is3PL}
                    isDisableButtons={this.props.isDisableButtons}
                    disableFormFields={this.props.disableFormFields}
                    fabricStyle_List={this.props.fabricStyle_List}
                    purchaseOrderReceiptData={purchaseOrderReceiptData}
                    purchaseOrderReceiptLineData={purchaseOrderReceiptLineData}
                    purchaseOrderReceiptRollLineData={
                      purchaseOrderReceiptRollLineData
                    }
                    addOrUpdatePurchaseOrderReceiptRollLine={
                      this.addOrUpdatePurchaseOrderReceiptRollLine
                    }
                    onLineChange={this.onPurchaseOrderReceiptLineChange}
                    onRollLineChange={this.onPurchaseOrderReceiptRollLineChange}
                    editPurchaseOrderReceiptRollLine={
                      this.editPurchaseOrderReceiptRollLine
                    }
                    addNewRollLine={this.addNewRollLine}
                    getPurchaseOrderLinesDatasFromExcel={
                      this.getPurchaseOrderLinesDatasFromExcel
                    }
                    uploadExcelFile={this.uploadExcelFile}
                    poReceiptRollLinesList={this.props.poReceiptRollLinesList}
                    isDisableRollLine={this.props.isDisableRollLine}
                    closeRollLineCallBack={this.props.closeRollLineCallBack}
                    displayCancelErrorMsg={this.props.displayCancelErrorMsg}
                    deleteReceiptRollLine={this.props.deleteReceiptRollLine}
                    alertMessage={this.props.alertMessage}
                    alertType={this.props.alertType}
                    isShowPopupAlertlvl5={this.props.isShowPopupAlertlvl5}
                    hideAlertCallBacklvl5={this.props.hideAlertCallBacklvl5}
                    isShowLinePopup={this.props.isShowLinePopup}
                    showLinePopup={this.props.showLinePopup}
                    closeLinePopup={this.props.closeLinePopup}
                    rollLineLocationOnChange={this.rollLineLocationOnChange}
                    rollLineLocationEnterKeyEventHandler={
                      this.rollLineLocationEnterKeyEventHandler
                    }
                    displayRollLineLocationAutoCompleteList={
                      this.displayRollLineLocationAutoCompleteList
                    }
                    rollLineLocationPageListForAutoCompleteList={
                      this.props.rollLineLocationPageListForAutoCompleteList
                    }
                    isShowAutoCompleteRolllineLocationList={
                      this.props.isShowAutoCompleteRolllineLocationList
                    }
                    clearRollLineDetails={this.props.clearRollLineDetails}
                    wareHouses={this.props.wareHouses}
                    onFilterChange={this.onFilterChange}
                    filterRollLinenClick={this.filterRollLinenClick}
                    resetIntansitRollLines={this.resetIntansitRollLines}
                    purchaseOrderRollLineBeanFilter={
                      this.props.purchaseOrderRollLineBeanFilter
                    }
                    filterPurchaseList={this.props.filterPurchaseList}
                    isSearchCriteria={this.props.isSearchCriteria}
                    isResetCriteria={this.props.isResetCriteria}
                    isShowFilterList={this.props.isShowFilterList}
                    multiAddPurchaseOrderReceiptRollLine={
                      this.props.multiAddPurchaseOrderReceiptRollLine
                    }
                    isTexco={this.props.isTexco}
                  />
                </div>
              }
            />
          </div>
          <div className="header_div">
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Date#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  name="createdDate"
                  value={purchaseOrderReceiptData.createdDate}
                  onChange={this.onChange}
                  disabled={true}
                />
              </Col>
              <Col className="so-align-items-left" sm="1">
                {" "}
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.lnkPOModule(e)}
                >
                  PO#
                </FormLabel>
                <Col>
                  <ShortCutMenuPopup
                    value={purchaseOrderReceiptData.purchaseOrderNumber}
                    menuItems={
                      <ul>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) => this.lnkPOModule(e)}
                        >
                          {" "}
                          PurchaseOrder Info{" "}
                        </li>
                      </ul>
                    }
                  />
                </Col>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  onChange={this.onPurchaseOrderChange}
                  ref={this.purchaseOrderRef}
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                  name="purchaseOrderNumber"
                  placeholder="purchaseOrderNumber"
                  value={purchaseOrderReceiptData.purchaseOrderNumber}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.purchaseOrderLookupHandler}
                  enterKeyEventHandler={this.purchaseOrderEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.purchaseOrderPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePurchaseOrderList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompletePurchaseOrderList
                  }
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.lnkPOIntransitModule(e)}
                >
                  PurchaseInTransit#
                </FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  onChange={this.poIntransitOnChange}
                  ref={this.shipViaRef}
                  placeholder="purchaseOrderInTransitNumber"
                  name="purchaseOrderInTransitNumber"
                  value={purchaseOrderReceiptData.purchaseOrderInTransitNumber}
                  lookupRequired={this.props.isShowInTransitLookup}
                  lookupHandler={this.props.purchaseInTransitLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.poIntransitEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.poIntransitPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayPOIntransitAutoCompleteList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompletePoIntransitList
                  }
                  readOnly={disableFormFields}
                  disabled={this.props.isDisablePoIntransit}
                />
              </Col>
              <Col sm="1">
                <FormLabel>ShipVia#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.shipViaOnChange}
                  ref={this.shipViaRef}
                  placeholder="shipViaCode"
                  name="shipViaCode"
                  value={purchaseOrderReceiptData.shipViaCode}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.shipViaLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.shipViaEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.shipViaPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayShipViaAutoCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteShipViaList
                  }
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Vendor</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="vendorCode"
                  type="text"
                  placeholder="Enter vendorCode"
                  value={purchaseOrderReceiptData.vendorCode}
                  disabled={true}
                />
              </Col>
              <Col sm="3">
                <InputTextbox
                  name="vendorName"
                  type="text"
                  placeholder="Enter vendorName"
                  value={purchaseOrderReceiptData.vendorName}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Factory#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="factoryCode"
                  type="text"
                  placeholder="Enter factoryCode"
                  value={purchaseOrderReceiptData.factoryCode}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Location#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.locationOnChange}
                  ref={this.warehouseRef}
                  placeholder="LocationCode"
                  name="locationCode"
                  value={purchaseOrderReceiptData.locationCode}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.warehouseLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.locationEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.locationPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayLocationAutoCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteLocationList
                  }
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                  isMandatory={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>PackingSlip#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="packingSlipNumber"
                  type="text"
                  placeholder="Enter packingSlipNumber"
                  value={purchaseOrderReceiptData.packingSlipNumber}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>ShipmentTerm#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.shipmentTermOnChange}
                  ref={this.shipmentTermRef}
                  placeholder="shipmentTermsCode"
                  name="shipmentTermsCode"
                  value={purchaseOrderReceiptData.shipmentTermsCode}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.shipmentTermLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.shipmentTermPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayShipmentTermAutoCompleteList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteShipmentTermList
                  }
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>FobCity#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.fobCityOnChange}
                  ref={this.fobCityRef}
                  placeholder="fOBCity"
                  name="fOBCity"
                  value={purchaseOrderReceiptData.fOBCity}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.fobCityLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.fobCityEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.FobCityPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayFobCityAutoCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteFobCityList
                  }
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Customer#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="customerCode"
                  value={purchaseOrderReceiptData.customerCode}
                  onChange={this.onChange}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>BillOfLading#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="billOfLading"
                  type="text"
                  placeholder="Enter billOfLading"
                  value={purchaseOrderReceiptData.billOfLading}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Receipt Date</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  name="receiptDate"
                  value={purchaseOrderReceiptData.receiptDate}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Payment Status</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="paymentStatus"
                  className="summary_input text-right"
                  value={ModuleUtils.getPurchaseOrderReceiptPaymentStatusCaption(
                    purchaseOrderReceiptData.paymentStatus,
                  )}
                  // value={purchaseOrderReceiptData.paymentStatus}
                  disabled={true}
                />
              </Col>
              {is3PL && (
                <Col sm="1">
                  <FormLabel>Container#</FormLabel>{" "}
                </Col>
              )}
              {is3PL && (
                <Col sm="2">
                  <InputTextbox
                    name="containerNumber"
                    type="text"
                    value={purchaseOrderReceiptData.containerNumber}
                    onChange={this.onChange}
                    disabled={disableFormFields}
                  />
                </Col>
              )}
              {is3PL && (
                <Col sm="1">
                  <FormLabel>CustRef#</FormLabel>{" "}
                </Col>
              )}
              {is3PL && (
                <Col sm="2">
                  <InputTextbox
                    name="customerReferenceNumber"
                    type="text"
                    value={purchaseOrderReceiptData.customerReferenceNumber}
                    onChange={this.onChange}
                    disabled={disableFormFields}
                  />
                </Col>
              )}
            </Row>
            {isTexco && (
              <Row>
                <Col className="align-fabricStyles-left" sm="1">
                  <FormLabel>VendorInvoice#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="vendorInvoiceNumber"
                    value={purchaseOrderReceiptData.vendorInvoiceNumber}
                    onChange={this.onChange}
                      disabled={isVendorInvoiceShow}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Eta Date</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <DatePickerComponent_adv
                    name="etaDate"
                    value={purchaseOrderReceiptData.etaDate}
                    onChange={this.onChange}
                    //  disabled={disableUpdatableFields}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>Etd Date</FormLabel>{" "}
                </Col>

                <Col sm="2">
                  <DatePickerComponent_adv
                    name="etdDate"
                    value={purchaseOrderReceiptData.etdDate}
                    onChange={this.onChange}
                    // disabled={disableUpdatableFields}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col sm="1">
                <FormLabel>ManufacturerLot</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="ManufacturerBatchNumber"
                  type="text"
                  value={purchaseOrderReceiptData.manufacturerBatchNumber}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                />
              </Col>
              <Col sm="3">
                {this.props.isShowPORButton ? (
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    size="sm"
                    onClick={(e) => this.loadReceiptLines(e)}
                  >
                    Load Receipt Lines From PO
                  </Button>
                ) : null}
              </Col>
              <Col sm="1">
                <FormLabel>comments</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="comments"
                  type="text"
                  placeholder="Enter comments"
                  onChange={this.onChange}
                  value={purchaseOrderReceiptData.comments}
                  disabled={disableFormFields}
                />
              </Col>
            </Row>
          </div>
          <div className="header_div">
            <div className="div_Custom_4">
              <CustomTable
                columns={this.prLineColumns()}
                data={lines}
                label={"Receipt Lines"}
                isResizable={true}
                isShowLabelButton={true}
                isShowExcelResetButton={true}
                labelButtonRender={"Load From Excel"}
                labelButtonClickHandler={(e) => this.overallExcelOnClick(e)}
                renderExcelResetButton={"Reset Excel Upload"}
                excelResetButtonClickHandler={(e) =>
                  this.props.resetExcelUploadView(e)
                }
              />
              <input
                type="file"
                id="file-input"
                style={{ display: "none" }}
                onChange={(e) => this.props.uploadOverallExcelFile(e)}
                accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
              />
              {/* <Button
                onClick={this.props.resetExcelUploadView}
                disabled={this.state.isShowProgressBarPopup}
              >
                Reset Excel Upload
              </Button> */}

              {/* <div>
                <Table id="fabrics_tables_default">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Line#</th>
                      <th>{is3PL ? "Item#" : "FabricStyle#"}</th>
                      <th>{is3PL ? "ItemName" : "FabricStyleName"}</th>
                      <th>Color#</th>
                      <th>UOM#</th>
                      <th>OrdQty</th>
                      <th>opnOrderQty</th>
                      <th>RcdToDT</th>
                      <th>ReceivedQty</th>
                      <th>InTransitQty</th>
                      <th>CurrentInTransitQty</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  {lines != null ? (
                    <tbody>
                      {lines.map((ln, index) => (
                        <tr key={index}>
                          <td>
                            {" "}
                            <ShortCutMenuPopup
                              value={ln.fabricStyleCode}
                              // popupData = {this.state.tempPopUpData }
                              menuItems={
                                <ul>
                                  <li
                                    className="shortcut-menu-item"
                                    onClick={(e) =>
                                      this.props.openFabricAndCustomerDetailsInq(
                                        e,
                                        ln.fabricStyleCode
                                      )
                                    }
                                  >
                                    Fabric and Customer Details
                                  </li>
                                  <li
                                    className="shortcut-menu-item"
                                    onClick={(e) =>
                                      this.props.openFabricAndCustomerDetailsInq(
                                        e,
                                        ln.fabricStyleCode
                                      )
                                    }
                                  >
                                    Fabric and Customer Details
                                  </li>
                                </ul>
                              }
                            />
                          </td>
                          <td className="hyperLinkText">
                            <Button
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.editPurchaseOrderReceiptLine(
                                  e,
                                  ln.lineNumber,
                                  ln
                                )
                              }
                            >
                              {ln.lineNumber}
                            </Button>
                          </td>
                          <td>{ln.fabricStyleCode}</td>
                          <td>{ln.fabricStyleName}</td>
                          <td>{ln.colorCode}</td>
                          <td>{ln.uomCode}</td>
                          <td>{ln.purchaseOrderQuantity}</td>
                          <td>{ln.openOrderQuantity}</td>
                          <td>{ln.receivedQuantityToDate}</td>
                          <td>{ln.receivedQuantity}</td>
                          <td>{ln.inTransitQuantity}</td>
                          <td>{ln.openInTransistQuantity}</td>
                          <td>
                            {ModuleUtils.getPurchaseOrderReceiptLineStatusCaption(
                              ln.lineStatus
                            )}
                          </td>
                          <td>
                            {ln.lineStatus !=
                              LogicConstants.PURCHASEORDER_RECEIPT_LINE_CANCEL_STATUS && (
                                <Button
                                  size="sm"
                                  onClick={(e) =>
                                    this.deleteReceiptLine(e, ln.lineNumber, ln)
                                  }
                                  disabled={!this.props.isDisableButtons}
                                >
                                  <DeleteIcon />
                                </Button>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </Table>
                {lines.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>*/}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class PurchaeOrderReceiptLinePopUpForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  onFilterChange = (e) => {
    this.props.onFilterChange(e);
  };
  filterRollLinenClick = (e) => {
    this.props.filterRollLinenClick(e);
  };
  resetIntansitRollLines = (e) => {
    this.props.resetIntansitRollLines(e);
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  onRollLineUpdate = (e) => {
    if (e.detail == 1) this.props.addOrUpdatePurchaseOrderReceiptRollLine(e);
    // this.closeLinePopup();
  };
  onRollLineMultiAdd = (e) => {
    if (e.detail == 1) this.props.multiAddPurchaseOrderReceiptRollLine(e);
  };

  clearRollLineDetails = (e) => {
    if (e.detail == 1) this.props.clearRollLineDetails();
  };
  onRollLineChange = (e) => {
    this.props.onRollLineChange(e);
  };
  editPurchaseOrderReceiptRollLine = (e, val, row) => {
    if (e.detail == 1) {
      this.props.editPurchaseOrderReceiptRollLine(val, row);
      this.showLinePopup();
    }
  };
  deleteReceiptRollLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteReceiptRollLine(rowData);
  };
  addNewRollLine = (e) => {
    if (e.detail == 1) {
      this.props.addNewRollLine(e);
      this.showLinePopup();
    }
  };
  showLinePopup = () => {
    this.props.showLinePopup();
  };
  closeLinePopup = () => {
    this.props.closeLinePopup();
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeRollLineCallBack(isShowPopup);
  };
  rollLineLocationOnChange = (e) => {
    this.props.rollLineLocationOnChange(e);
  };
  rollLineLocationEnterKeyEventHandler = (e) => {
    this.props.rollLineLocationEnterKeyEventHandler(e);
  };
  displayRollLineLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayRollLineLocationAutoCompleteList(showAutoCompleteList);
  };
  onExcelClick = (e) => {
    if (e.detail == 1) {
      const input = document.getElementById("file-input-old");
      if (input) {
        input.click();
      }
    }
  };
  onKeyPress = (e) => {
    if (e.keyCode == 120) {
      this.props.multiAddPurchaseOrderReceiptRollLine();
    }
  };
  render() {
    let purchaseOrderReceiptData = this.props.purchaseOrderReceiptData;
    let purchaseOrderReceiptLineData = this.props.purchaseOrderReceiptLineData;
    let purchaseOrderReceiptRollLineData =
      this.props.purchaseOrderReceiptRollLineData;
    let disableFormFields = this.props.disableFormFields;
    let isSearchCriteria = this.props.isSearchCriteria;
    let isResetCriteria = this.props.isResetCriteria;
    let isShowFilterList = this.props.isShowFilterList;
    let receiptRollLines = [];
    if (!isSearchCriteria) {
      if (!isEmptyArray(this.props.poReceiptRollLinesList)) {
        receiptRollLines = this.props.poReceiptRollLinesList;
      }
    }
    if (isSearchCriteria) {
      if (!isEmptyArray(this.props.filterPurchaseList)) {
        receiptRollLines = this.props.filterPurchaseList;
      }
    }

    // if (!isEmptyArray(this.props.filterPurchaseList)) {
    //   receiptRollLines = this.props.filterPurchaseList;
    // }

    var poButtonLine = {
      alignContent: "center",
      width: "100%",
    };
    let is3PL = this.props.is3PL;
    let purchaseOrderRollLineBeanFilter =
      this.props.purchaseOrderRollLineBeanFilter;
    return (
      <div className="header_div">
        {" "}
        <div>
          <Row>
            <Col sm="1">
              <FormLabel>Line#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="lineNumber"
                type="text"
                placeholder="Enter LineNumber"
                value={purchaseOrderReceiptLineData.lineNumber}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>CompanyCode#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="companyCode"
                type="text"
                placeholder="Enter companyCode"
                value={purchaseOrderReceiptLineData.companyCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>POReceipt#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="purchaseOrderReceiptNumber"
                type="text"
                placeholder="Enter purchaseOrderReceiptNumber"
                value={purchaseOrderReceiptLineData.purchaseOrderReceiptNumber}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Location#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="locationCode"
                type="text"
                placeholder="Enter companyCode"
                value={purchaseOrderReceiptData.locationCode}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>{is3PL ? "Item" : "FabricStyleCode"}</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleCode"
                type="text"
                placeholder="Enter fabricStyleCode"
                value={purchaseOrderReceiptLineData.fabricStyleCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                name="fabricStyleName"
                type="text"
                placeholder="Enter FabricStyleName"
                value={purchaseOrderReceiptLineData.fabricStyleName}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Color</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="colorCode"
                type="text"
                placeholder="Enter Color"
                value={purchaseOrderReceiptLineData.colorCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Width</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="widthCode"
                type="text"
                placeholder="Enter Width"
                value={purchaseOrderReceiptLineData.widthCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>OrderQty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"purchaseOrderQuantity"}
                onChange={this.onLineChange}
                placeholder="Enter purchaseOrderQuantity"
                value={purchaseOrderReceiptLineData.purchaseOrderQuantity}
                className="qty_input summary_input"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
            <Col sm="1">
              <FormLabel>OpenOrder Qty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"openOrderQuantity"}
                placeholder="Enter openOrderQuantity"
                value={purchaseOrderReceiptLineData.openOrderQuantity}
                className="qty_input summary_input"
                decimalScale={2}
                onBlur={this.onBlur}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Total Recd</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"receivedQuantity"}
                onChange={this.onLineChange}
                placeholder="Enter receivedQuantityToDate"
                value={purchaseOrderReceiptLineData.receivedQuantity}
                className="qty_input  summary_input"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Total Rolls</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={purchaseOrderReceiptLineData.totalRolls}
                className="qty_input summary_input"
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>UOM</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="uomCode"
                type="text"
                placeholder="Enter uomCode"
                value={purchaseOrderReceiptLineData.uomCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>RcdToDT</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"receivedQuantityToDate"}
                onChange={this.onLineChange}
                value={purchaseOrderReceiptLineData.receivedQuantityToDate}
                className="qty_input  summary_input"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
            <Col sm="1">
              <FormLabel>InTransitQty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"openInTransistQuantity"}
                onChange={this.onLineChange}
                placeholder="Enter openInTransistQuantity"
                value={purchaseOrderReceiptLineData.openInTransistQuantity}
                //className="text-right"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Current InTransitQty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"inTransitQuantity"}
                onChange={this.onLineChange}
                placeholder="Enter inTransitQuantity"
                value={purchaseOrderReceiptLineData.inTransitQuantity}
                // className="text-right"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
          </Row>
          {this.props.isTexco && (
            <Row>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>Pieces Received</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="linePiecesReceived"
                  value={purchaseOrderReceiptLineData.linePiecesReceived}
                  onChange={this.onChange}
                  disabled={true}
                  //disabled={disableUpdatableFields}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Cost</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="lineCostPrice"
                  value={purchaseOrderReceiptLineData.lineCostPrice}
                  onChange={this.onChange}
                  disabled={true}
                  //  disabled={disableUpdatableFields}
                />
              </Col>

              <Col sm="1">
                <FormLabel>TotalAmountReceived</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="lineTotalAmountReceived"
                  value={purchaseOrderReceiptLineData.lineTotalAmountReceived}
                  onChange={this.onChange}
                  disabled={true}
                  // disabled={disableUpdatableFields}
                />
              </Col>
            </Row>
          )}
          <div style={poButtonLine}>
            <Row>
              <Col sm="2">
                <FormLabel className="label_head">
                  {" "}
                  Received Line Rolls
                </FormLabel>
              </Col>
              <Col sm="2">
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.onExcelClick(e)}
                >
                  Load From Excel
                </Button>
                <input
                  type="file"
                  id="file-input-old"
                  style={{ display: "none" }}
                  onChange={(e) => this.uploadExcelFile(e)}
                  accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                />
              </Col>
              <Col sm="3">
                {this.props.isDisableButtons && (
                  <Button
                    className="header_buttons"
                    onClick={(e) => this.addNewRollLine(e)}
                  >
                    Add Roll Line
                  </Button>
                )}
              </Col>
            </Row>

            <Row>
              <FormLabel className="label_head">Select Criteria</FormLabel>
            </Row>

            <Row>
              <Col sm="1">
                <FormLabel>Lot</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onFilterChange}
                  name="vendorLotNumber"
                  value={purchaseOrderRollLineBeanFilter.vendorLotNumber}
                  isMandatory={true}
                ></InputTextbox>
              </Col>

              <Col sm="1">
                <FormLabel>Roll</FormLabel>
                {/* {this.props.is3PL ? (
                  <FormLabel>Inventory#</FormLabel>
                ) : (
                  <FormLabel>RollSKU#</FormLabel>
                )} */}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onFilterChange}
                  name="rollNumber"
                  value={purchaseOrderRollLineBeanFilter.rollNumber}
                  isMandatory={true}
                ></InputTextbox>
              </Col>

              <Col sm="1">
                <FormLabel>ReceivedQty</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  name={"receivedQuantity"}
                  onChange={this.onFilterChange}
                  value={purchaseOrderRollLineBeanFilter.receivedQuantity}
                  //className="text-right"
                  //  decimalScale={2}
                  isMandatory={true}
                />
              </Col>

              <div
              // style={{
              //   display: "flex",
              //   alignItems: "center",
              //   justifyContent: "center",
              // }}

              //            let isSearchCriteria = this.props.isSearchCriteria;
              // let isResetCriteria = this.props.isResetCriteria;
              // let isShowFilterList = this.props.isShowFilterList;
              >
                {/* {this.state.isAllocatedSearchCriteria && ( */}
                <Button
                  className=""
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.filterRollLinenClick(e)}
                  disabled={isSearchCriteria}
                >
                  Filter
                </Button>
                {/* // )} */}

                {/* {this.state.isAllocatedResetCriteria && ( */}
                <Button
                  className=""
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.resetIntansitRollLines(e)}
                  disabled={isResetCriteria}
                >
                  Reset
                </Button>
                {/* )} */}
              </div>
            </Row>
          </div>
          <div>
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.props.isShowLinePopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel5"}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"Roll LINE DETAIL"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              alertContainerBox={
                <AlertToolBox
                  alertMsgList={this.props.alertMessage}
                  alertErrorType={this.props.alertType}
                  isShowAlert={this.props.isShowPopupAlertlvl5}
                  hideAlertCallBack={this.props.hideAlertCallBacklvl5}
                />
              }
              headerButtonContainer={
                <div className="floatLeft">
                  <Button
                    className="header_buttons"
                    size="sm"
                    onClick={(e) => this.onRollLineMultiAdd(e)}
                    disabled={this.props.isDisableRollLine}
                  >
                    Add+ [f9]
                  </Button>

                  <Button
                    className="header_buttons"
                    size="sm"
                    onClick={(e) => this.onRollLineUpdate(e)}
                    disabled={this.props.isDisableRollLine}
                  >
                    Add/Update
                  </Button>

                  <Button
                    className="header_buttons"
                    size="sm"
                    onClick={(e) => this.clearRollLineDetails(e)}
                    disabled={this.props.isDisableRollLine}
                  >
                    clear
                  </Button>
                </div>
              }
              content={
                <div
                  className="sales_line_pop"
                  tabIndex="0"
                  onKeyDown={this.onKeyPress}
                >
                  <div>
                    <PurchaeOrderReceiptRollLinePopUpForm
                      disableFormFields={disableFormFields}
                      fabricStyle_List={this.props.fabricStyle_List}
                      purchaseOrderReceiptData={purchaseOrderReceiptData}
                      purchaseOrderReceiptLineData={
                        purchaseOrderReceiptLineData
                      }
                      purchaseOrderReceiptRollLineData={
                        purchaseOrderReceiptRollLineData
                      }
                      onLineChange={this.onRollLineChange}
                      showLinePopup={this.showLinePopup}
                      closeLinePopup={this.closeLinePopup}
                      isDisableRollLine={this.props.isDisableRollLine}
                      rollLineLocationOnChange={this.rollLineLocationOnChange}
                      rollLineLocationEnterKeyEventHandler={
                        this.rollLineLocationEnterKeyEventHandler
                      }
                      displayRollLineLocationAutoCompleteList={
                        this.displayRollLineLocationAutoCompleteList
                      }
                      rollLineLocationPageListForAutoCompleteList={
                        this.props.rollLineLocationPageListForAutoCompleteList
                      }
                      isShowAutoCompleteRolllineLocationList={
                        this.props.isShowAutoCompleteRolllineLocationList
                      }
                      wareHouses={this.props.wareHouses}
                      is3PL={this.props.is3PL}
                    />
                  </div>
                </div>
              }
            />
          </div>
          <div className="div_Custom_2">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>Line#</th>
                  <th>Location#</th>
                  <th>Roll#</th>
                  <th>{this.props.is3PL ? "Inventory#" : "RollSKU#"}</th>
                  <th>ReceivedQty</th>
                  <th>InTransitQty</th>
                  <th>VENDOR LOT#</th>
                  <th>Box#</th>
                  <th>InvRcdQty#</th>
                  <th>InfoText</th>
                  <th>Bin Location#</th>
                  <th>Delete</th>
                </tr>
              </thead>
              {receiptRollLines != null ? (
                <tbody>
                  {receiptRollLines.map((roll, index) => (
                    <tr key={index}>
                      <td className="hyperLinkText text-end">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.editPurchaseOrderReceiptRollLine(
                              e,
                              roll.receiptRollLineNumber,
                              roll,
                            )
                          }
                        >
                          {roll.receiptRollLineNumber}
                        </Button>
                      </td>
                      <td>{roll.locationCode}</td>
                      <td className="text-end">{roll.rollNumber}</td>
                      <td>{roll.rollSkuNumber}</td>
                      <td className="text-end">{roll.receivedQuantity}</td>
                      <td className="text-end">{roll.inTransitQuantity}</td>
                      <td>{roll.vendorLotNumber}</td>
                      <td>{roll.boxNumber}</td>
                      <td className="text-end">
                        {roll.inventoryReceivedQuantity}
                      </td>
                      <td>{roll.infoText}</td>
                      <td>{roll.aisleInfoText}</td>
                      <td>
                        <Button
                          size="sm"
                          onClick={(e) => this.deleteReceiptRollLine(e, roll)}
                          disabled={!this.props.isDisableButtons}
                        >
                          <DeleteIcon />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
            {receiptRollLines.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
class PurchaeOrderReceiptRollLinePopUpForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      warehouseLookupHandler: null,
    };
    this.receivedQtyRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    //this.receivedQtyRef?.current?.focus();
    // setTimeout(() => {
    //  this.setFocus()
    // }, 200);
  }

  initLookupHandlers = () => {
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
  };
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  onClick = (e) => {
    this.props.onClick(e);
  };
  rollLineLocationOnChange = (e) => {
    this.props.rollLineLocationOnChange(e);
  };
  rollLineLocationEnterKeyEventHandler = (e) => {
    this.props.rollLineLocationEnterKeyEventHandler(e);
  };
  displayRollLineLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayRollLineLocationAutoCompleteList(showAutoCompleteList);
  };
  render() {
    let purchaseOrderReceiptRollLineData =
      this.props.purchaseOrderReceiptRollLineData;
    let disableFormFields = this.props.disableFormFields;
    let isDisableRollLine = this.props.isDisableRollLine;
    // this.receivedQtyRef.current.focus();
    return (
      <div>
        <Row>
          <Col sm="2">
            <FormLabel>Line#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="lineNumber"
              type="text"
              placeholder="Enter LineNumber"
              value={purchaseOrderReceiptRollLineData.receiptRollLineNumber}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Received Qty</FormLabel>
          </Col>
          <Col sm="4">
            <NumberFormatInputbox
              ref={this.receivedQtyRef}
              name={"receivedQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter receivedQuantity"
              value={purchaseOrderReceiptRollLineData.receivedQuantity}
              className="text-right"
              decimalScale={2}
              disabled={disableFormFields}
              onBlur={this.onBlur}
              isMandatory={true}
              // autoFocus = {true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Location#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              onChange={this.rollLineLocationOnChange}
              placeholder="LocationCode"
              name="locationCode"
              value={purchaseOrderReceiptRollLineData.locationCode}
              lookupRequired={true}
              lookupHandler={this.state.warehouseLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.rollLineLocationEnterKeyEventHandler}
              autoCompleteListData={
                this.props.rollLineLocationPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.displayRollLineLocationAutoCompleteList
              }
              showAutoCompleteList={
                this.props.isShowAutoCompleteRolllineLocationList
              }
              readOnly={disableFormFields}
              disabled={disableFormFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>VENDOR LOT#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="vendorLotNumber"
              type="text"
              placeholder="Enter VENDOR LOT "
              value={purchaseOrderReceiptRollLineData.vendorLotNumber}
              disabled={disableFormFields}
              onChange={this.onLineChange}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Box#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="boxNumber"
              type="text"
              placeholder="Enter boxNumber"
              value={purchaseOrderReceiptRollLineData.boxNumber}
              disabled={disableFormFields}
              onChange={this.onLineChange}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Roll#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="rollNumber"
              type="text"
              placeholder="Enter rollNumber"
              value={purchaseOrderReceiptRollLineData.rollNumber}
              onChange={this.onLineChange}
              disabled={disableFormFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>
              {this.props.is3PL ? "Inventory#" : "RollSKU#"}
            </FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="rollSkuNumber"
              type="text"
              // placeholder="Enter rollSkuNumber"
              placeholder={
                this.props.is3PL ? "Enter Inventory#" : "Enter rollSKU#"
              }
              value={purchaseOrderReceiptRollLineData.rollSkuNumber}
              onChange={this.onLineChange}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Intransit Qty</FormLabel>
          </Col>
          <Col sm="4">
            <NumberFormatInputbox
              name={"inTransitQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter inTransitQuantity"
              value={purchaseOrderReceiptRollLineData.inTransitQuantity}
              className="text-right"
              decimalScale={2}
              disabled={true}
              onBlur={this.onBlur}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>InvUOM</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="inventoryUomCode"
              type="text"
              placeholder="Enter inventoryUomCode"
              value={purchaseOrderReceiptRollLineData.inventoryUomCode}
              onChange={this.onLineChange}
              disabled={disableFormFields}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Inv Rcd Qty</FormLabel>
          </Col>
          <Col sm="4">
            <NumberFormatInputbox
              name={"inventoryReceivedQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter inventoryReceivedQuantity"
              value={purchaseOrderReceiptRollLineData.inventoryReceivedQuantity}
              className="qty_input text-right summary_input"
              decimalScale={2}
              disabled={true}
              onBlur={this.onBlur}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>InfoText</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="infoText"
              type="text"
              placeholder="Enter infoText"
              value={purchaseOrderReceiptRollLineData.infoText}
              onChange={this.onLineChange}
              disabled={disableFormFields}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Bin Loc#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="aisleInfoText"
              type="text"
              placeholder="Enter aisleInfoText"
              value={purchaseOrderReceiptRollLineData.aisleInfoText}
              onChange={this.onLineChange}
              disabled={disableFormFields}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
class PurchaseOrderReceiptHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }

  statusTrackColumn = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "createdDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("OrderAmount#", "totalOrderAmount", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "previousStatus", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
        .setStatusDetails(true, this.status),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PreviousStatus", "currentStatus", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
        .setStatusDetails(true, this.prevStatus),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DoneBy", "createdBy", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    return columns;
  };
  status = (currentStatus) => {
    return ModuleUtils.getPurchaseOrderReceiptStatusCaption(currentStatus);
  };
  prevStatus = (previousStatus) => {
    return ModuleUtils.getPurchaseOrderReceiptStatusCaption(previousStatus);
  };
  // DateGridColumnStatusDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Date",
  //       "createdDate",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       false,
  //       false,
  //       true,
  //       ModuleUtils.getDateFormat_v1
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "OrderAmount#",
  //       "totalOrderAmount"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Status",
  //       "previousStatus",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       false,
  //       false,
  //       true,
  //       ModuleUtils.getPurchaseOrderReceiptStatusCaption
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PreviousStatus",
  //       "currentStatus",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       false,
  //       false,
  //       true,
  //       ModuleUtils.getPurchaseOrderReceiptStatusCaption
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("DoneBy", "createdBy")
  //   );
  //   return columnList;
  // };
  // DateGridColumnChangeHistoryDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Date",
  //       "updatedDate",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       false,
  //       false,
  //       true,
  //       ModuleUtils.getDateFormat_v1
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("UpdatedBy#", "updatedBy")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Change", "description")
  //   );
  //   return columnList;
  // };

  ChangeTrackColumn = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "updatedDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("UpdatedBy#", "updatedBy", true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Change", "description", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
      //  .setStatusDetails(true, this.status)
    );
    return columns;
  };
  render() {
    let purchaseOrderReceiptData = this.props.purchaseOrderReceiptData;
    let statusTracks = purchaseOrderReceiptData.statusTracks;
    if (!statusTracks) {
      statusTracks = new Array();
    }
    let changeHistoryTracks = purchaseOrderReceiptData.changeHistoryTracks;
    if (!changeHistoryTracks) {
      changeHistoryTracks = new Array();
    }
    var styles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "300px",
          maxHeight: "300px",
        },
      },
    };
    return (
      <div>
        <div className="header_div">
          <div className="div_Custom_3">
            <CustomTable
              data={statusTracks}
              columns={this.statusTrackColumn()}
              label={"Status Tracks Table"}
            />
          </div>
          <div className="div_Custom_3">
            <CustomTable
              data={changeHistoryTracks}
              columns={this.ChangeTrackColumn()}
              label={"Change Tracks Table"}
            />
          </div>
        </div>
      </div>
    );
  }
}

class PurchaseOrderReceiptApproveReceiptLinesForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.getApprovalPageList();
  }
  createApprovalLines = (e) => {
    if (e.detail === 1) this.props.createApprovalLines();
  };
  closeAlertReceiptApprovalModalCallBack = (isShowPopup) => {
    this.props.closeAlertReceiptApprovalModalCallBack(isShowPopup);
  };
  getApprovalPageList = () => {
    this.props.getApprovalPageList();
  };
  selectColor = (color) => {
    this.props.selectColor(color);
  };
  unSelectColor = (purchaseOrderReceiptData1) => {
    this.props.unSelectColor(purchaseOrderReceiptData1);
  };
  selectAllList = (e) => {
    this.props.selectAllList(e);
  };
  unSelectAllList = (e) => {
    this.props.unSelectAllList(e);
  };

  onSelectedApprovalLines = (evt, line) => {
    this.props.onSelectedApprovalLines(evt, line);
  };
  poReceiptApprovalOnChange = (e) => {
    this.props.poReceiptApprovalOnChange(e);
  };
  hideAlertCallBackApproval = () => {
    this.props.hideAlertCallBackApproval();
  };
  approvalLinesColumn = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isApplied", false)
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.onSelectedApprovalLines,
          null,
        )
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LineNumber", "receiptLineNumber", true)
        .setStyleDetails("left", "", "", "wt-2 ", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedQuantity", "quantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "amount", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    return columns;
  };
  viewApprovedDetails = (e, code, rowData) => {
    if (e.detail === 1) {
      this.props.viewApprovedDetails(e, rowData);
    }
  };

  headerLinesapprovalColumn = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("ApprovedNumber", "code", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewApprovedDetails, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("CreatedDate", "createdDate", true, false, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("ApprovedAmount", "approvedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalQuantity", "totalQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceiptAmount", "receiptAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("PO ReceiptNumber", "purchaseOrderReceiptNumber", true, true)
    //     .setStyleDetails("Right", "", "", "wt-4 ", "wt-4 ")
    // );
    return columns;
  };

  aprovalonChange = (e) => {
    this.props.aprovalonChange(e);
  };

  render() {
    const textAreaStyle = {
      height: "5em",
      width: "100em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };

    let purchaseOrderReceiptData = this.props.purchaseOrderReceiptData;
    let statusTracks = [];

    let purchaseOrderReceiptApprovalList =
      this.props.purchaseOrderReceiptApprovalList;
    let purchaseOrderReceiptApproval = this.props.purchaseOrderReceiptApproval;
    let receiptApprovalList = this.props.receiptApprovalList;
    let isCreateButtonDisabled = this.props.isCreateButtonDisabled;
    return (
      <div>
        <Row>
          <Col sm="1">
            <FormLabel>Company</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="companyCode"
              value={purchaseOrderReceiptData.companyCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>PurchaseOrder</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="purchaseOrderNumber"
              value={purchaseOrderReceiptData.purchaseOrderNumber}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>PurchaseOrderReceipt</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              value={purchaseOrderReceiptData.code}
              disabled={true}
            />
          </Col>
        </Row>

        <Row>
          {/* <Col sm="6" className="title_text_div">
            <FormLabel>PurchaseOrder Receipt Lines</FormLabel>
          </Col> */}
          {/* <div > */}
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              onClick={(e) => this.props.addReceiptLines(e)}
            >
              Add Approval{" "}
            </Button>
          </Col>
          {/* </div> */}
        </Row>
        <div>
          <CustomTable
            data={receiptApprovalList}
            columns={this.headerLinesapprovalColumn()}
            // isShowLabelButton = {true}
            // labelButtonRender = "Select Receipt Lines"
            // labelButtonClickHandler={(e) => this.props.addReceiptLines(e)}
            label={"Approved Lines"}
          />
        </div>

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={false}
          isShowPopup={this.props.isShowReceiptApprovalPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertReceiptApprovalModalCallBack}
          title={"PurchaseOrderReceiptApproval"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowApprovalAlert}
              hideAlertCallBack={this.hideAlertCallBackApproval}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.createApprovalLines(e)}
                disabled={isCreateButtonDisabled}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="2">
                  <FormLabel>Company</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="companyCode"
                    value={purchaseOrderReceiptData.companyCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <FormLabel>PurchaseOrder</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="purchaseOrderNumber"
                    value={purchaseOrderReceiptData.purchaseOrderNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <FormLabel>PurchaseOrderReceipt</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="code"
                    value={purchaseOrderReceiptData.code}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>TotalReceivedQuantity</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    name="totalQuantity"
                    value={purchaseOrderReceiptApproval.totalQuantity}
                    onChange={this.poReceiptApprovalOnChange}
                    disabled={true}
                    decimalScale={2}
                    className="qty_input text-right summary_input"
                  />
                </Col>
                <Col sm="2">
                  <FormLabel>TotalAmount</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    name="receiptAmount"
                    value={purchaseOrderReceiptApproval.receiptAmount}
                    onChange={this.poReceiptApprovalOnChange}
                    disabled={true}
                    decimalScale={2}
                    className="qty_input text-right summary_input"
                  />
                </Col>
                <Col sm="2">
                  <FormLabel>Approval Amount</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    name="approvedAmount"
                    value={purchaseOrderReceiptApproval.approvedAmount}
                    onChange={this.poReceiptApprovalOnChange}
                    className="text-right"
                    decimalScale={2}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Comments</FormLabel>
                </Col>
                <Col sm="12">
                  {" "}
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="notesCommunication"
                    type="text"
                    placeholder="Enter comments"
                    onChange={this.aprovalonChange}
                    value={purchaseOrderReceiptApproval.notesCommunication}
                    disabled={false}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.selectAllList(e)}
                  >
                    SelectAll
                  </Button>
                </Col>

                <Col sm="1">
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    onClick={(e) => this.unSelectAllList(e)}
                  >
                    UnSelectAll
                  </Button>
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={purchaseOrderReceiptApprovalList}
                  columns={this.approvalLinesColumn()}
                  label={"Received Lines"}
                />
              </div>
            </div>
          }
        />
      </div>
    );
  }
}

class PurchaseOrderReceiptPayamentDetailForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    //  this.loadPaymentdetail();
  }
  // loadPaymentdetail = () => {
  //   this.props.loadPaymentdetail();
  // };
  purchasePaymentDetailsColumn = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Line", "lineNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CheckTransaction", "checkTransactionNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Type", "paymentType", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Document#", "documentNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("BankName", "issuedBankName", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PaymentDate", "paymentDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("POReceiptNumber", "purchaseReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("ApprovalNumber", "approvalNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CurrencyCode", "currencyCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorCode", "vendorCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Applied Amount", "paymentAmount", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ApprovedAmount", "approvedAmount", true, true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AmountDue", "AmountDue", true, true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5"),
    );
    return columns;
  };
  render() {
    let purchasePaymentDetailList = this.props.purchasePaymentDetailList;
    return (
      <div className="header_div">
        <div className="div_Custom_3">
          <CustomTable
            data={purchasePaymentDetailList}
            columns={this.purchasePaymentDetailsColumn()}
            label={"purchasePaymentDetailList"}
          />
        </div>
      </div>
    );
  }
}

// class MultiColorPopup extends React.Component {
//   static contextType = AppContext;
//   constructor(props) {
//     super(props);
//     //
//   }
//   componentDidMount() {
//     //
//   }
//   selectColor = (e, color) => {
//     if (e.detail == 1) this.props.selectColor(color);
//   };
//   unSelectColor = (e, purchaseOrderReceiptData1) => {
//     if (e.detail == 1) this.props.unSelectColor(purchaseOrderReceiptData1);
//   };
//   hideAlertCallBack = (isDisplayed) => {
//     this.props.hideAlertCallBack(isDisplayed);
//   };
//   render() {
//     let selectedMultipleColorList = this.props.temp_selectedMultipleColorList;
//     let colorList = this.props.multipleColorList;
//     let colorData = this.props.colorData;
//     let purchaseOrderReceiptData = this.props.purchaseOrderReceiptData.lines;
//     let purchaseOrderReceiptData1 = this.props.purchaseOrderReceiptData1;
//     const is3PL = this.props.is3PL;
//     let purchaseOrderReceiptApproval = this.props.purchaseOrderReceiptApproval;
//     let purchaseOrderReceiptApprovalList = this.props.purchaseOrderReceiptApprovalList;

//     return (
//       <div className="header_div">
//         <div>
//           <Row>
//             <Col sm="1">
//               <FormLabel>Company</FormLabel>{" "}
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//               // name="companyCode"
//               // value={purchaseOrderReceiptData.companyCode}
//               // disabled={true}
//               />{" "}
//             </Col>
//             <Col sm="1">
//               {is3PL ? (
//                 <FormLabel>Item</FormLabel>
//               ) : (
//                 <FormLabel>FabricStyle</FormLabel>
//               )}
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 name="fabricStyleCode"
//               // value={fabricStyleData.code}
//               // disabled={true}
//               />{" "}
//             </Col>
//             <Col sm="3">
//               <InputTextbox
//                 name="fabricStyleCode"
//               // value={fabricStyleData.description}
//               // disabled={true}
//               />{" "}
//             </Col>
//           </Row>
//           <div className="multi-clr-div">
//             <div className="multi-clr-tble">
//               <Table id="fabrics_tables">
//                 <thead>
//                   <tr>
//                     <th></th>
//                     <th>ColorCode</th>
//                     <th>ColorName</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {purchaseOrderReceiptApprovalList.map((color, index) => (
//                     <tr key={index}>
//                       <td>
//                         <Button
//                           variant="secondry"
//                           onClick={(e) => this.selectColor(e, color)}
//                         >
//                           <AddIcon />
//                         </Button>
//                       </td>
//                       <td>{color.fabricStyleCode}</td>
//                       <td>{color.fabricStyleName}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//             <div className="multi-clr-tble">
//               <Table id="fabrics_tables">
//                 <thead>
//                   <tr>
//                     <th></th>
//                     <th>ColorCode</th>
//                     <th>ColorDesc</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {purchaseOrderReceiptData1.map((color, index) => (
//                     <tr key={index}>
//                       {color.isFetched == true ? (
//                         <td>
//                           <Button
//                             variant="secondry"
//                             onClick={(e) => this.unSelectColor(e, color)}
//                           >
//                             <CancelIcon />
//                           </Button>
//                         </td>
//                       ) : (
//                         <td></td>
//                       )}
//                       <td>{color.fabricStyleCode}</td>
//                       <td>{color.fabricStyleName}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }
export function MutilpleDocuments(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewDocs] = useState(props.preview_Docs);
  const [documents, setDocuments] = useState([...props.documents]);
  const [tempIndex, setIndex] = useState(null);
  const documentData = props.purchaseOrderReceiptData.receiptDocuments || [];
  const [isDocumentUpload, setIsDocumentUpload] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;
  // const disabledImages =  props.isServiceLineDisablesFields;
  // useEffect(() => {
  //   setColumns(props.columns);
  // }, [props.columns]);

  const docHandler = (e) => {
    e.preventDefault();
    let tempDocs = e.target.files;
    let doc_list = [];
    let previewList = [];
    if (!isEmptyArray(documents)) {
      doc_list = [...documents];
    }
    if (!isEmptyArray(previewUrl)) {
      previewList = [...previewUrl];
    }
    for (let index = 0; index < tempDocs.length; index++) {
      let docUrl = "";
      doc_list.push(tempDocs[index]);
      docUrl = URL.createObjectURL(tempDocs[index]);
      previewList.push(docUrl);
    }
    setDocuments(doc_list);
    setPreviewDocs(previewList);
    setIsDocumentUpload(true);
  };

  useEffect(() => {
    setDocuments(documents);
  }, [documents]);

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    props.uploadMutiDouments(documents);
    props.uploadMutiDoumentsUrl(previewUrl);
    props.showToast("Uploaded Sucessfully", 1);
    setIsDocumentUpload(false);
  };
  const deleteDocs = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewDocs("");
      props.showToast("Image deleted sucessfully", 1);
      setDocuments(props.documents);
      setIsDocumentUpload(false);
    }
  };

  const deleteDocuments = (e, value, rowData,index) => {
    let documentDataList = documents;
    let fileUrl = previewUrl;
    documentDataList.map((list, index) => {
      if (list.documentName === rowData.documentName) {
        // list.deleted = true;
        // list.isDeleted = true;
        fileUrl.splice(index, 1);
      }
    });
    setPreviewDocs(fileUrl);
    props.uploadMutiDoumentsUrl(fileUrl);
    props.deleteMultiDocument(rowData);
    // setDocuments(documentDataList);
    // setPreviewDocs(fileUrl);
    // props.uploadMutiDouments(documentDataList);
    // props.uploadMutiDoumentsUrl(fileUrl);
  };
  const editDocument = (e, name, tempIndex,rowIndex) => {
    let docUrl = previewUrl;
    let tempUrl = "";
    if (!isEmptyArray(docUrl)) {
      for (let index = 0; index < docUrl.length; index++) {
        if (index === rowIndex) {
          tempUrl = docUrl[index];
        }
      }
      window.open(tempUrl);
    }
  };

     const documentColumns = () => {
        const columns = new Array();
        columns.push(
          new ColumnDefinition()
                  .setDetails("Document", "documentOriginalName", true)
            .setStyleDetails("left", "", "", "wt-10", "wt-10")
            .setClickDetails(true, false, editDocument, null)
            .setDocument(true)
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Document Name", "documentName", true)
            .setStyleDetails("left", "", "", "wt-10", "wt-10"),
        );
        columns.push(
          new ColumnDefinition()
     .setDetails("", <DeleteIcon />, false)
            .setStyleDetails("left", "2", "", "wt-2", "wt-2")
            .setClickDetails(false, true, deleteDocuments, <DeleteIcon />)
        );
    
        return columns;
      };
  
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        {/* <div className="div_80_no_overflow"> */}
        <div className="div_60_no_overflow">
          <div className="div_Equal_no_overflow">
            <form onSubmit={handleDocumentSubmit}>
              <div className="d-flex justify-content-around ">
                <div>
                  <label for="imgTag" className="d-flex justify-content-around">
                    <div className="img_label">
                      Attach Documents
                      <span className="img_icon">
                        <UploadDocIcon />
                      </span>
                    </div>

                    <input
                      type="file"
                      className="img-input"
                      id="imgTag"
                      multiple
                      accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                      onChange={docHandler}
                      // disabled={isShowDocLabel}
                      disabled={props.disableFormFields}
                    />
                  </label>
                </div>
                {isDocumentUpload && (
                  <div className="d-flex justify-content-around align-middle">
                    <div className="align-middle">
                      <button
                        id="fabric_Add_Button"
                        type="submit"
                        //  disabled={isShowDocLabel}
                        disabled={props.disableFormFields}
                      >
                        Upload
                      </button>
                    </div>
                    <div className="align-middle">
                      <Button
                        id="fabric_Add_Button"
                        onClick={(e) => deleteDocs(e)}
                        //disabled={isShowDocLabel}
                        disabled={props.disableFormFields}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="mt-3">
             <CustomTable
               data={documentData}
               columns={documentColumns()}
              // label={"Inquiry Data List"}
             />
           </div>
    
    </div>
  );
}
export function ImageForm(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.imgUrl);
  const [images, setImages] = useState([...props.images]);
  const [img_Url, setImageUrl] = useState([...props.preview_Url]);

  const [tempIndex, setIndex] = useState(null);
  const [tempImage, setTempImages] = useState([]);
  const [tempImg_Url, setTempImageUrl] = useState([]);
  const [isImagePreview, setIsImagePreview] = useState(false);
  const [isImageMainPreview, setIsImageMainPreview] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;
  const disabledImages = props.isServiceLineDisablesFields;
  const [imgDetails, setTempFile] = useState(null);
  const [hover, setHover] = useState(false);
  const [hoverData, setHoverData] = useState(
    new PurchaseOrderReceiptImageBean(),
  );
  const [aftUpload, setAftUpload] = useState(false);
  const receiptImages = props.purchaseOrderReceiptData.receiptImages;
  const [imageEntity, setImagesEntity] = useState(
    new PurchaseOrderReceiptImageBean(),
  );
  const handleChange = (e) => {
    let tempImages = e.target.files;
    if (!isEmptyArray(tempImages)) {
      setIsImageMainPreview(true);
    }
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let img_list = [];
    let previewList = [];
    if (!isEmptyArray(images)) {
      img_list = [...images];
    }
    if (!isEmptyArray(img_Url)) {
      previewList = [...img_Url];
    }
    for (let index = 0; index < tempImages.length; index++) {
      // const element = tempImages[i];
      let imgUrl = "";
      if (tempImages[index].size <= max_size) {
        img_list.push(tempImages[index]);
        imgUrl = URL.createObjectURL(tempImages[index]);
        previewList.push(imgUrl);
      } else {
        props.showToast("image size is greater", 2);
      }
    }
    setImages(img_list);
    setImageUrl(previewList);
  };
  useEffect(() => {
    setImageUrl(img_Url);
  }, [img_Url]);
  useEffect(() => {
    setImages(images);
  }, [images]);
  useEffect(() => {
    setIsImageMainPreview(isImageMainPreview);
  }, [isImageMainPreview]);
  const handleImageEditChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let images_temp = [];
    let url_temp = [];
    let imgUrl = "";
    if (e.target.files[0].size <= max_size) {
      images_temp = [...images];
      url_temp = [...img_Url];
      setIsImagePreview(true);
      setIsImageMainPreview(false);
      // })
      for (let i = 0; i < images_temp.length; i++) {
        if (i === tempIndex) {
          let file = e.target.files[0];
          setFile(file);
        }
      }
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          imgUrl = URL.createObjectURL(e.target.files[0]);
          url_temp[i] = imgUrl; // Change the value at index 2
        }
      }
    } else {
      props.showToast("image size is greater", 2);
    }
    setPreviewUrl(imgUrl);
    setTempImages(images_temp);
    setTempImageUrl(url_temp);
  };
  useEffect(() => {
    setIsImagePreview(isImagePreview);
  }, [isImagePreview]);
  const handleSubmit = (e) => {
    e.preventDefault();
    props.setMultiImageUrl(img_Url);
    props.setMultiImgData(images);
    props.uploadMutiImage(images);
    props.showToast("Uploaded Sucessfully", 1);
    setIsImageMainPreview(false);
  };
  const handleEditSubmit = (e) => {
    e.preventDefault();
    let tempFile = file;
    for (let i = 0; i < tempImage.length; i++) {
      if (i === tempIndex) {
        tempFile.imageCode = tempImage[i].imageCode;
        tempImage[i] = tempFile;
      }
    }
    props.setMultiImageUrl(tempImg_Url);
    props.setMultiImgData(tempImage);
    props.uploadMutiImage(tempImage);
    setImageUrl(tempImg_Url);
    props.showToast("Uploaded Sucessfully", 1);
    setIndex(null);
    setIsImagePreview(false);
    setPreviewUrl("");
  };
  const deleteImage = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewUrl("");
      // props.deleteImage();
      props.showToast("Image deleted sucessfully", 1);
      setIsImageMainPreview(false);
      setImages(props.images);
      setImageUrl(props.preview_Url);
    }
  };
  const imageview = (e, index, image) => {
    if (!isImageMainPreview) {
      const files = e.target.currentSrc;
      let imgDetails = null;
      const urls = files;
      setPreviewUrl(urls);
      setIndex(index);
      setIsImagePreview(false);
      // for (let i = 0; i < images.length; i++) {
      //   if (i === index) {
      //     imgDetails = images[i];
      //   }
      // }
      for (
        let i = 0;
        i < props.purchaseOrderReceiptData.receiptImages.length;
        i++
      ) {
        if (i === index) {
          imgDetails = props.purchaseOrderReceiptData.receiptImages[i];
        }
      }
      setTempFile(imgDetails);
      const updatedImageEntity = {
        ...imgDetails, // Spread the class instance to convert to plain object
        tags: imgDetails.tags !== "" ? imgDetails.tags : "",
        notesCommunication: imgDetails.notesCommunication || "",
      };
      setImagesEntity(updatedImageEntity);
      //
    }
  };
  const hoverview = (e, index) => {
    setAftUpload(true);
    if (!aftUpload) return; // Prevent hover logic if 'aftUpload' is false
    if (props.purchaseOrderReceiptData.isFetched) {
      const hoverDetails = props.purchaseOrderReceiptData.receiptImages[index]; // Get the hovered image by index
      if (hoverDetails) {
        setHoverData(hoverDetails); // Set hover data for the hovered image
      } else {
        setHoverData(new PurchaseOrderReceiptImageBean()); // Fallback to default or empty data
      }
    }
    setHover(true); // Set hover state to true when mouse is over the image
  };
  const deleteUploadedImage = (e) => {
    if (e.detail === 1) {
      let url_temp = [];
      url_temp = [...img_Url];
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          url_temp.splice(i, 1); // Change the value at index 2
        }
      }
      setImageUrl(url_temp);
      props.deleteMutipleImage(tempIndex);
      setPreviewUrl("");
      setTempImageUrl(url_temp);
      setIndex(null);
      setIsImagePreview(false);
    }
  };
  const onImageChange = (e) => {
    const updatedImageEntity = {
      ...imageEntity, // Spread the existing properties
      [e.target.name]: e.target.value, // Update the property based on input name
    };
    setImagesEntity(updatedImageEntity);
    // this.setState({ imageEntity: criteria });
    // props.onImageChange(e)
  };
  const addImageLines = (e) => {
    if (e.detail === 1) {
      props.addImageLines(imageEntity);
      props.showToast("Details Uploaded Sucessfully", 1);
    }
  };
  const clearImageLines = (e) => {
    if (e.detail === 1) {
      //props.clearImageLines(imageEntity)
      const updatedImageEntity = {
        ...imageEntity, // Spread the existing properties
        tags: "", // Reset tags
        notesCommunication: "", // Reset notesCommunication
      };
      setImagesEntity(updatedImageEntity);
      props.clearImageLines(updatedImageEntity);
    }
  };
  return (
    // const textAreaStyle = {
    //   maxHeight: "10px",
    //   width: "30%",
    //   minHeight: "5em",
    //   resize: "none",
    //   padding: "9px",
    //   boxSizing: "border-box",
    //   fontSize: "15px",
    // };
    <div className="header_div  div_default">
      <div className="div_inline">
        <div className="div_30_no_overflow">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="imgTag" className="d-flex justify-content-around">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="imgTag"
                    multiple
                    accept="image/*"
                    onChange={handleChange}
                    //  disabled={disabledImages}
                    disabled={props.disableFormFields}
                  />
                </label>
              </div>
              {isImageMainPreview && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle-icon">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      //  disabled={isShowDocLabel}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteImage(e)}
                      //   disabled={isShowDocLabel}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.8rem" }}>
              {!isEmptyArray(img_Url) &&
                img_Url.map((image, index) => (
                  <div key={index} className="column">
                    <div className="effect">
                      <div className="effect-img">
                        <img
                          src={image}
                          alt={`upload-${index}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "1px solid black",
                            marginBottom: "5px", // Space between image and text
                            marginRight: "2px",
                            marginLeft: "2px",
                          }}
                          onClick={(e) => imageview(e, index)}
                          onMouseOver={(e) => hoverview(e, index)}
                          onMouseOut={() => setHover(false)} // Reset hover state on mouse out
                        />
                      </div>
                      {hover == true && (
                        <div className="effect-text">
                          <div class="inner">
                            <p
                            // style={{ fontSize: "12px", margin: 0 }}
                            >
                              {hoverData.imageName}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                    {/* Index Text Below Image */}
                  </div>
                ))}
            </div>
          </form>
          {/* </div> */}
        </div>
        <div className="div_60_no_overflow">
          {/* <div className="image-preview"> */}
          <form onSubmit={handleEditSubmit}>
            {
              !isEmpty(previewUrl) && (
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    paddingLeft: "200px",
                  }}
                >
                  <div className="image_grid">
                    {previewUrl != null && (
                      <div
                      // style={{ display: "flex", backgroundColor: "green" }}
                      >
                        <div
                          style={{
                            padding: "10px",
                            width: "100%",
                          }}
                        >
                          <img
                            src={previewUrl}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "200%",
                              float: "left",
                            }}
                          />
                          <label className="d-flex justify-content-around">
                            <div className="d-flex justify-content-around">
                              <span className="img_icon">
                                <CameraIcon />
                              </span>
                              <input
                                type="file"
                                className="img-input"
                                id="imgTag"
                                accept="image/*"
                                onChange={handleImageEditChange}
                                disabled={disabledImages}
                              />
                              <div className="d-flex justify-content-around align-middle">
                                <div className="align-middle">
                                  {isImagePreview && (
                                    <button
                                      id="fabric_Add_Button"
                                      type="submit"
                                      // disabled={disabledImages}
                                      disabled={props.disableFormFields}
                                    >
                                      Upload
                                    </button>
                                  )}
                                </div>
                                <div className="align-middle">
                                  <Button
                                    id="fabric_Add_Button"
                                    onClick={(e) => deleteUploadedImage(e)}
                                    // disabled={disabledImages}
                                    disabled={props.disableFormFields}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </div>
                              </div>
                              {/* <button
                              type="button"
                              id="fabric_Add_Button"
                            >
                              Remove
                            </button> */}
                            </div>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      padding: "20px",
                    }}
                  >
                    <Row>
                      <Col sm="2">
                        <FormLabel>Name</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //  value={imageEntity.imageName}
                          value={imageEntity.imageName || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Created By</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //value={imageEntity.createdBy}
                          value={imageEntity.createdBy || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>created Date</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.createdDate}
                          value={imageEntity.createdDate || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Tags</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.tags}
                          value={imageEntity.tags || ""}
                          name="tags"
                          // type="text"
                          onChange={onImageChange}
                          // disabled={disabledImages}
                          disabled={props.disableFormFields}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Notes</FormLabel>
                      </Col>
                      <Col sm="9">
                        <textarea
                          style={{
                            maxHeight: "10px",
                            width: "100%",
                            minHeight: "5em",
                            resize: "none",
                            padding: "9px",
                            boxSizing: "border-box",
                            fontSize: "15px",
                          }}
                          // className="form-control"
                          name="notesCommunication"
                          //  type="text"
                          // placeholder="Notes"
                          onChange={onImageChange}
                          value={imageEntity.notesCommunication || ""}
                          // value={imageEntity.notesCommunication}
                          // disabled={disabledImages}
                          disabled={props.disableFormFields}
                        />
                        {/* <InputTextbox
                                  value={imgDetails.notesCommunication}
                                // disabled={true}
                                /> */}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-center">
                        <Button
                          size="sm"
                          id="fabric_Add_Button"
                          className="header_buttons enterFocus"
                          onClick={(e) => addImageLines(e)}
                          //   disabled={disabledImages}
                          disabled={props.disableFormFields}
                        >
                          Add/Update
                        </Button>
                        <Button
                          id="fabric_Add_Button"
                          size="sm1"
                          onClick={(e) => clearImageLines(e)}
                          // disabled={disabledImages}
                          disabled={props.disableFormFields}
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>
                    {/* <p>{`Tags        : ${imgDetails.tags}`}</p>
                              <p>{`Notes       : ${imgDetails.notesCommunication}`}</p> */}
                    {/* </Col> */}
                  </div>
                </div>
              )
              // ))
            }
          </form>
          {/* // </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

function PurchaseOrderReceiptModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div id="app_container"></div>
      <PurchaseOrderReceiptList {...props} name="" /> <br />
    </div>
  );
}

export default PurchaseOrderReceiptModule;
